export const en = {
  welcome: "This is the first step in your use of this system",
  day: "day",
  expirationtime: "expiration time",
  lastLoginTime: "last login time",
  ainum: "AI",
  message: "Message",
  recharg_stream: "Recharge",
  persion_data: "Resource",
  free_app: "Free App",
  ecological: "Ecological operation",
  aicall: "AI Call",
  aicall_desc: "Robot autonomous call, integrated data statistics service. At the same time, it supports personalized configuration of scripts to cope with massive scenarios, help enterprises achieve growth of new customers, and activate retention.",
  callin:"Call In",
  callin_desc:"Intelligent inbound reception platform. Used for various Q&A consulting services, it can set up intelligent voice IVR navigation, intelligently allocate routes, accurately obtain user intentions, and efficiently complete reception.",
  customer_centor: "Customer Centor",
  customer_centor_desc: "CRM takes sales management as its core, sales activities as its driving force, and performance management as its goal. It helps enterprises achieve precise management of the entire sales process, from lead conversion, business opportunity follow-up, to payment collection management. By effectively supporting the complex business needs and changes of the enterprise, it comprehensively improves the efficiency of sales team collaboration and thereby improves performance.",
  seats_help: "Seat Help",
  seats_help_desc: "The rich knowledge base is equipped with knowledge graphs to automatically recommend reference knowledge and scripts for customer service personnel. At the same time, it has various intelligent auxiliary modules such as customer service work status reminders and accurate user portrait automatic acquisition.",
  normal_blacklist: "BlackList",
  normal_blacklist_desc: "Massive blacklist library, available for free use. Please contact your business manager.",
  pays_app: "Pays",
  opera_tool: "Tools",
  lead_market: "Lead Market",
  lead_market_desc: "Massive data, precise screening, and clue profiling help enterprises quickly locate target users.",
  dail_line: "Dialing",
  dail_line_desc: "Peer to Peer Calling",
  mini_app: "Applet",
  mini_app_desc: "Pay to install mini programs for easier operation on your phone",
  online_recharge: "Online recharge/offline recharge",
  online_recharge_desc: "Online recharge is connected to WeChat merchant accounts, and the recharge is received in real-time. Offline recharge docking with customer managers or delayed receipt of unified payment accounts.",
  recharge_time : "Recharge Time",
  recharge_money : "Amount",
  recharge_before_money : "Balance Before",
  recharge_after_money : "Balance After ",
  recharge_account : "Account",
  recharge_account_remark : "Remark",
  description : "Description",
  personal_information: "Personal Information",
  username: "Name",
  username_placeholder:"Please fill in your name",
  email: "Email",
  email_placeholder:"Please fill in your email address",
  phone: "Phone",
  phone_placeholder:"Please fill in your telephone number",
  weixin: "WeChat",
  nobind_weixin: "Not bound to wechat",
  save: "Save",
  level0 : "Super Admin",
  level1 : "User",
  level2 : "Merchant",
  system_message: "System Message",
  system_message_desc: "Display real-time messages pushed by the system.",
  message_content: "Message",
  message_date: "Time",
  action: "Action",
  readed: "Readed",
  new_customer: "New customers:",
  call_duration: " Call duration:",
  second: "second",
  bot_calling: "Calling",
  call_number: "Call number:",
  noise_value: "Noise ratio:",
  duijie_mini_pro: "Not connected to WeChat mini program",
  scan_weixin: "Scan WeChat and enter the mini program",
  environmental_monitoring: "Environment detection",
  woshi_title: "Title",
  upload_download_list: "Upload/Download File List",
  online: "Online",
  disableUse: "Disable",
  unline: "Offline",
  do_not_disturb: "Do not disturb.",
  download_ie: "Download Google Chrome for faster page browsing speed",
  help_doc: "Help Documents",
  click_fullscreen: "Full screen",
  modify_pass: "Change password",
  bind_weixin: "Bind WeChat",
  bind_more_weixin: "Bind more WeChat",
  logout: "Logout",
  scan_gongzh: "Please scan the code to follow the official account",
  remove_bind: "unbind",
  no_get_head: "We have not obtained your WeChat nickname and avatar. Please scan the code again for authorization",
  sure: "Confirm",
  cancel: "Cancel",
  login_pass: "Login password",
  export_pass: "Export Password",
  sourec_pass: "*Original password",
  sourec_pass_desc: "Please fill in the original password",
  new_pass: "*New password",
  new_pass_desc: "Please fill in the new password",
  sure_new_pass: "*Confirm new password",
  sure_new_pass_desc: "Please enter the new password again",
  zyText_1: "Due to the increase in data storage, which has resulted in slow data loading, from now on, all data will only be saved",
  zyText_2: "days, all recording files are only saved",
  zyText_3: "days, after this time, will be automatically cleaned. Please keep the data in time. Please understand the inconvenience caused by this. If you have any questions, please timely communicate with the service personnel. Time range during which the system prohibits calls:",
  navbar_notice_sys_rule: "System rules & quiet hours",
  environmental_test_result: "Environmental test result",
  ie: "Browser",
  ie_zq: "Browser meets requirements",
  ie_error: "Browser does not meet the requirements, please download the latest version of Google Chrome.",
  speech_device: "Voice device",
  loudspeaker: "Speaker",
  microphone: "Microphone",
  musice_play: "Music playback",
  remind: "Reminder:",
  remind_desc: "If you can hear both your own voice and the sound of music playing while speaking into the microphone, then the device is normal; If you cannot hear, please check your voice device.",
  opera_time: "Time",
  file_name: "FileName",
  upload_download: "Action",
  upload_z: "Upload",
  download_z: "Download",
  status_desc: "Status",
  delete_z: "Delete",
  failure: "Failure",
  runling: "Running",
  finally_z: "Finish",
  callback: "Callback",
  main_phone: "Major",
  symbol_phone: "GodDnf",
  please_input_phone: "Please enter number",
  follow_up: "Immediately follow up",
  follow_up_desc: "Fill in the follow-up details and press' Enter 'to submit",
  net_phone: "Internet",
  dial_record: "Records",
  hr: "Call In",
  hc: "Call",
  yjt: "Through",
  wjt: "Close",
  dial_number_no : "The number dialed is incorrect",
  main_symbol: "No primary or secondary card configured",
  soft_phone_status: "The soft phone status is:",
  auto_response: "Auto answer",
  hand_response: "Manual answer",
  soft_net_desc: "Replace the webpage softphone here with a third softphone",
  windows_download: "Windows download",
  android_download: "Android download",
  ios_download: "Apple Mobile App Market Search: PortSIP Alternative: Grandstream WaveLite",
  fenji_phone: "Extension number:",
  reg_pass: "Reg password:",
  reg_lianxi_admin: "Please contact your administrator for registration address and port",
  please_online: "Please online",
  please_dial_phone: "Please enter number",
  sys_weikaitong: "The system is not equipped with network telephone capability.",
  hello: "Hello,",
  welcome_z: ",Wishing you smooth work and happy every day!",
  ai_seats: "AIs",
  yuan: "$",
  balance: "Balance",
  overBalance: "Overdraw",
  lines: "Sip",
  today_data: "Today's data",
  realtime: "real-time",
  dailcount: "Number of calls",
  ci: "",
  switchoncount: "Number of connections",
  switchon_rate: "Completion rate",
  conversiontion: "Total call duration",
  pj_conversiontion: "Average call duration",
  asr_count: "Asr count",
  a_grade: "A",
  b_grade: "B",
  c_grade: "C",
  d_grade: "D",
  e_grade: "E",
  f_grade: "F",
  tiao: "",
  total_data: "Aggregate data",
  no_touchphone: "Uncalled customer",
  ge: "",
  touchphone: "Called customer",
  jietong_count: "Number of connected customers",
  dianhua_jietong_rate: "Telephone connection rate",
  dianhua_jietong_rate_desc: "Number of answered customers/total number of outbound customers",
  gradeacd: "Intended Customers (A/B/C)",
  fen: "minute",
  th_time: "Call duration",
  abcdef_desc: "The proportion of A/B/C/D/E/F in the past 7 days",
  leibie: "category",
  day7_tongji: "Statistics of 7 days",
  boda_count: "calls",
  jietong_phone_count: "connections",
  abc_count: "Total A/B/C",
  today_realtime_detail: "Today's real-time",
  c_count: "Total",
  import_customer: "Import",
  config_plan: "Configuration",
  select_start_call: "Start the selected number",
  change_task_id: "Export all to task",
  start_call: "Start",
  stop_call: "Stop",
  test_call: "Test",
  bot_name: "BOT Name:",
  dial_range_time: "Call date:",
  no_config: "Unconfigured",
  zhouqiboda_time: "Weekly call Date:",
  bodawancheng_weixing_push: "Push wechat message:",
  filter_customer: "Filter",
  operat_log: "Logs",
  add_dail_range_time_desc: "*Add call time:",
  starttime: "Start time",
  endtime: "End time",
  select_range_time: "Select time range",
  add_desc: "Add",
  close: "Close",
  repeat_zhouqi: "*Repeat cycle",
  task_finish_push: "Completed wechat push",
  data_push_title: "Data push",
  please_push_statgy: "Please select a policy",
  click_me_down: "Click (me) to download the template",
  click_me_down_desc: "Fill in the content according to the header (or modify the header in the EXCEL file to meet the requirements, the file suffix is xls, xlsx, txt)",
  select_file: "*Select file",
  import_statgy: "Import strategy",
  filter_statgy: "Filtering policy",
  sort_phone: "Sort",
  import_child_list: "Import to a subordinate account (do not choose to import to yourself)",
  select_child_account: "Select a subordinate account",
  dialing: "Call",
  test_dial_desc: "Enter a mobile phone number to make a call. Separate multiple numbers with commas (,)",
  push: "Push",
  no_push: "Do not push",
  import_template: "Import from template",
  import_check_phone: "Retrieval number import",
  default_desc: "Default",
  luanxu:"Out-order",
  please_add_dailtime: "Please add a call period.",
  please_select_repeat: "Please select a repeat period.",
  please_input_call_phone: "Please enter the number to call for the test.",
  please_select_import_file: "Select the Excel file you want to import.",
  only_import_geshi: "Only Excel files can be imported. The extensions are xls, xlsx, and txt",
  week1: "Monday",
  week2: "、Tuesday",
  week3: "、Wednesday",
  week4: "、Thursday",
  week5: "、Friday",
  week6: "、Saturday",
  week7: "、Sunday",
  please_input_search: "Please enter the number for the query",
  import_start_time: "Import start date",
  import_end_time: "Import end date",
  all_export: "Export",
  all_export_desc: "High-risk warning: If a task is in the process of making a call, stop the call before exporting the task to avoid unnecessary data synchronization. Are you sure you want to export it now?",
  batch_delete: "Delete",
  batch_delete_desc1: "Warning: If you are exporting data, ensure that the data is exported before deleting it. You confirm to delete this",
  batch_delete_desc2: " of data?",
  batch_delete2_desc1: "Warning: If you are currently exporting data, ensure that the data is exported before clearing it. You confirm to clean this",
  clear_phone: "Clean",
  phone_name: "Name",
  lianxi_fangshi: "Contact",
  status_z: "Status",
  no_start: "Stop",
  wait_call: "Pending",
  import_time: "Import date",
  source: "Source",
  sex: "Sex",
  companyname: "Company",
  sort: "Sort",
  address: "Address",
  contact_address_province: "Province (Contact Address)",
  contact_address_city: "City (Contact Address)",
  contact_address_district: "District (Contact Address)",
  remark1: "Remark1",
  remark2: "Remark2",
  remark3: "Remark3",
  remark4: "Remark4",
  remark5: "Remark5",
  success: "Success",
  error: "Error",
  please_gouxuan_delete: "Select the customer to be deleted.",
  task_title: "New task",
  task_name_label: "*Task name",
  task_name_label_desc: "Please fill in the task name",
  bot_name_label: "*BOT Name",
  bot_name_label_desc: "Please Select BOT",
  bot_count_label: "*BOTs：",
  bot_count_label_desc: "Please fill in the number of BOT",
  start_date: "*Start date",
  start_date_desc: "Select start date",
  dial_rangetime: "*Call period",
  no_dial_rangtime: "Do not call period",
  continue_error_hangup_label: "Failed suspension",
  continue_error_hangup_label_desc: "Number of failed entries",
  please_input_taskname: "Please enter a task name.",
  taskname_two_char: "The task name must be at least two characters long.",
  please_select_bot: "Please select BOT.",
  bots_dayu: "The number of bots must be less than or equal to the maximum number of agents. The current number of agents:",
  please_select_startdate: "Please select a start date.",
  please_select_dialrangetime: "Please select a call period.",
  please_input_content: "Please enter content",
  call_start_date: "Start date",
  call_end_date: "End date",
  number: "phone",
  export: "Export",
  filter_condition: "Condition：",
  number_z: "Phone：",
  call_date_z: "Call date：",
  to: "to",
  please_pass: "Please enter password",
  jieting_status: "Status",
  read_status: "Read status",
  rgysx: "Manual filtered",
  unknow: "unknown",
  filter_date: "Filtration time",
  export_filter: "Export Filter Customers",
  nodata_export_filter: "No data can be exported.",
  clear_number_title: "Clear the number and cannot be restored",
  clear_number_title_desc: "High risk prompt: If you are currently exporting data, please confirm that the data export is complete before clearing it. After clearing, it cannot be restored. Are you sure to continue?",
  tiao_data: " Data",
  grade: "Grade",
  edittask: "Edit task",
  change_sip: "Switch Sip",
  please_select: "Please select",
  gateway: "Gateway",
  kou: " ",
  parent_fp: " - (Assigned)",
  auto_repeat_call: "Redial",
  please_auto_repeat: "Please select redial",
  repeat_count: "Redial times",
  please_repeat_count: "Please select the number of redials",
  repeat_jiange: "Redial interval, in minutes",
  please_repeat_jiange: "Fill in the redial interval",
  set_auto_guize: "Processing Rules",
  push_location: "Location",
  please_push_location: "Please select location",
  please_select_push_account: "Please select an account",
  click_me_all: "Select All",
  a_fenpei: "A allocated to",
  b_fenpei: "B allocated to",
  c_fenpei: "C allocated to",
  d_fenpei: "D allocated to",
  e_fenpei: "E allocated to",
  f_fenpei: "F allocated to",
  lunxun_push: "Polling push",
  grade_push: "Polling and pushing by level",
  grade_push_layout_hint: "For each grade, pick sub-accounts (left) and extra WeChat (right); each column rotates on its own.",
  seats_group_push_grade_conflict: "Transfer-to-agent seat group conflicts with customer push settings. After hangup the same customer may be assigned to the answering agent and also pushed to other sub-accounts by grade. This applies when the task has push grades configured, or when the task has no push config but account-level auto-allocation is enabled under Integration & Push. Remove one setting or confirm this is intentional.",
  push_ai_customer_wz: "Push out AI workbench and customer center",
  only_push_ai: "Push out AI workbench",
  open: "Open",
  ci1: "1",
  ci2: "2",
  ci3: "3",
  ci4: "4",
  ci5: "5",
  please_select_repeat_count: "Please fill in the number of redials.",
  please_repeat_jiange_minite: "Please fill in the redial interval in minutes.",
  import_customer_num: "Number of Customers",
  import_customer_num_desc: "The number of all customers imported into this task (with numbers as the dimension, de duplication)",
  call_customer_num: "Number of Called",
  total_call_customer_num: "Total customers",
  jietong_waihu_customer_num: "Number of connected",
  yijieting_th_time: "Duration",
  hangup_2: "Customer 2 round hang up rate",
  hangup_2_desc: "Number of customers who answered without reaching two rounds of calls/total number of customers answered",
  continues_error: "Continuous call failure",
  last_dail_error_count: "The number of times the last consecutive call failed",
  a_grade_customer: "Number of Class A customers",
  a_grade_customer_desc: "Number of customers with strong intentions, accounting for a proportion equal to the total number of Class A customers/connected customers",
  ge_zanbi: "Proportion:",
  b_grade_customer: "Number of Class B customers",
  b_grade_customer_desc: "Number of intended general customers, with a proportion equal to the total number of B-class customers/connected customers",
  c_grade_customer: "Number of Class C customers",
  c_grade_customer_desc: "The proportion of customers that can be attempted to recover is equal to the total number of C-class customers/connected customers",
  xiaoyu10: "Less than 10 seconds",
  range10to59: "10-59 seconds",
  range60to99: "60 seconds - 119 seconds",
  dayu120: "Greater than or equal to 2 minutes",
  duihua_cyc: "Talks",
  cc_talk_count: "Dialogue round",
  ci0to2: "0-2",
  ci3to4: "3-4",
  ci5to6: "5-6",
  ci7to9: "7-9",
  ci10: "10 or more",
  intention_proportion: "Intention level proportion",
  exe_account: "Performer",
  exe_starttime: "Start date",
  exe_endtime: "End date",
  exe_user: "Performer",
  exe_date: "Date",
  exe_content: "Content",
  last: "Last",
  next: "Next",
  th_id: "ID：",
  th_status: "Status：",
  intention_grade: "Grade：",
  customer_source: "Source：",
  call_date: "Call date：",
  over_date: "Over date：",
  create_date: "Create Date：",
  hh_times: "Duration",
  kh_grade: "Intention",
  ai_focus: "Focus",
  none: "None",
  sx_youxiao: "Filter valid",
  sx_quxiao_youxiao: "Cancel valid",
  move_customer_centor: "Move to customer center",
  customer_info: "Information",
  please_ss_company: "Please fill in the name of your company",
  remark: "Remark",
  remark_desc: "Please fill in the remarks",
  history_record: "History",
  no_more_data: "No more records",
  no_data: "no data",
  tishi: "prompt",
  not_more_data: "There is no more data.",
  please_input_keyword: "Please enter query keywords",
  content: "Content",
  please_input_llm_keyword: "Enter LLM grades, e.g. High,Medium",
  llm_content: "LLM",
  llm_grade_panel_tip: "Select grades from current task data (multi-select). You can also type manually.",
  llm_grade_panel_empty: "No LLM grade data in current task",
  llm_grade_loading: "Loading...",
  yx_dengji: "Intention",
  yx_dengji_huilingy_status: "Intention and ring-back tone",
  yy_label: "Label",
  semanteme_page_title: "Semantic label",
  semanteme_label_desc:
    "Semantic tags are globally effective keyword recognition techniques that apply to all scripts.Identified potential customers can be quickly found through semantic tags.<br>For example, if the semantic tag is configured with the keyword WeChat and How much do you WeChat is mentioned during the conversation(This process is bidirectional recognition, including what the robot itself says), this record will be recorded.Then, you can quickly search through semantic tags in the dialed records or customer CRM system.",
  semanteme_label_desc2:
    "Note: Semantic tags also need to recognize the script content of the robot, so it is important to fill in the text correctly when configuring the script",
  semanteme_new_label: "New label",
  semanteme_index_name: "Index name",
  semanteme_keys: "Keyword Collection",
  semanteme_please_index_name: "Please enter an index name",
  semanteme_please_keys: "Multiple keywords, split",
  semanteme_new_label_title: "Create a new semantic label",
  semanteme_modify_label_title: "Modify semantic labels",
  semanteme_indexname_notnull: "Index name cannot be empty",
  semanteme_keys_notnull: "The keyword set cannot be empty",
  semanteme_sure_delete: "Are you sure you want to delete it?",
  sys_notice_page_title: "System announcements",
  notice_gonggao: "Announcement title",
  notice_content_col: "Announcement content",
  notice_new_title: "New announcement",
  notice_modify_title: "Edit announcement",
  notice_please_gonggao: "Please enter the announcement title",
  notice_please_content: "Please enter the content of the announcement",
  notice_gonggao_notnull: "The announcement title cannot be empty",
  notice_content_notnull: "The announcement content cannot be empty",
  notice_add_btn: "Add",
  notice_del_title: "Delete announcement",
  notice_sure_delete: "Are you sure you want to delete it?",
  mymain_notice_board: "Announcements",
  mymain_notice_empty: "No announcements",
  start_date_z: "Start date",
  end_date_z: "End date",
  mini_s: "Mini(s)",
  second_Hangup_Count_desc: "Second Hangup",
  max_s: "Max(s)",
  mini_c: "Mini",
  max_c: "Max",
  please_select_bot_v: "Please select BOT",
  please_select_label: "Please select BOT label",
  please_select_more_wx: "Please select WeChat",
  no_weixin_push: "Not pushed to WeChat",
  please_select_push_c: "Please select the subordinates to push",
  please_select_task: "Please select task",
  unread: "Unread",
  readed2: "Readed",
  rg_filter: "Manual filter",
  orderby_time: "Sort by time",
  cur_show_user: "The current users being viewed are:",
  export_date_file: "Export data to file",
  export_my_file: "Export my data to a file",
  export_child_file: "Export data from subordinate accounts to a file",
  batch_move_cutomer: "Batch Move to Customer Center",
  batch_push_weixin: "Batch Push to WeChat",
  batch_push_weixin_count: " record(s)",
  batch_push_weixin_desc: "Push filtered numbers to selected WeChat by strategy.",
  batch_push_wx_select: "Receiving WeChat",
  batch_push_wx_placeholder: "Select receiving WeChat",
  batch_push_wx_required: "Please select at least one receiving WeChat",
  batch_push_wx_strategy: "Push strategy",
  batch_push_strategy_round: "Round-robin",
  batch_push_strategy_round_desc: "e.g. 10 records, 3 WeChat: #1→A, #2→B, #3→C, #4→A…",
  batch_push_strategy_average: "Even split",
  batch_push_strategy_average_desc: "e.g. 10 records, 3 WeChat: first ~4→A, middle ~3→B, last ~3→C",
  batch_push_strategy_all: "Push to all",
  batch_push_strategy_all_desc: "Each record is pushed to every selected WeChat",
  batch_allocation_child: "Batch assign to my subordinates",
  repeat_call: "Repeat",
  ygouxuan_data: "The selected customer data is:",
  no_allocation_data: "No customer data available for allocation",
  label: "Bot Label",
  calin_out: "In or out",
  all: "All",
  more_wx: "More WeChat",
  no_red_data: "Unread",
  rg_filtered: "Filtered data",
  task_name: "Task name",
  clear_phone_title: "Clean",
  export_alert: "High risk prompt: If you are currently exporting data, please confirm that the data export is complete before cleaning up.",
  clear_status: "Clear the answering status to:",
  please_delete: "Please enter “delete”",
  wx: "WeChat",
  push_show: "Push",
  task: "Task",
  grade_sip: "Level/Status",
  llm_grade: "LLM Level",
  focus: "Focus",
  defen: "Score",
  details: "View",
  move_customer_desc: "After moving, please go to [Customer Center] - [My Customers] to view",
  batch_export: "Batch export",
  sure_filter_contition: "Are you sure you want to repeatedly dial the numbers under the above filtering criteria?",
  please_customer_data: "Please select customer data.",
  please_export_child_account: "Please select the subordinate account to export to.",
  please_input_pass: "Please enter the password.",
  please_wcz_delete: "Please enter 'delete'",
  cur_page_end: "There is no more data available on the current page, please turn the page.",
  delete_customer: "Delete customer",
  delete_customer_desc: "Are you sure you want to delete this connected message with an intention level of:",
  delete_customer_desc_2: " customers?",
  export_my: "Export ",
  export_my2: " Data to file",
  export_my3: "Are you sure you want to export the numbers under the above filtering criteria?",
  batch_move: "Batch Move ",
  batch_move2: " To my customer center",
  batch_move3: "Are you sure you want to bulk move the numbers under the above filtering criteria to my customer center?",
  export_child_1: "Export data from subordinate accounts to my file",
  export_child_2: "Are you sure you want to export the numbers under the above filtering criteria?",
  export_child_3: "The data of the following accounts will be exported to your export list:",
  repeat_call_desc: "Repeated calls ",
  repeat_call_desc2: " data",
  repeat_call_desc3: "Are you sure you want to repeatedly dial the numbers under the above filtering criteria?",
  batch_allocation_child_desc: "Assign customer data to the following accounts:",
  batch_move_1: "High risk prompt: If you are currently exporting data, please confirm that the data export is complete before moving. Are you sure to move this?",
  please_gx_movedata: "Please check the customer data that needs to be moved.",
  new_create_task: "New task",
  refresh_new_task: "Refresh",
  search_task: "Search",
  search_range_task: "Search by range",
  search_child_account: "Search account",
  search_status: "Search by status",
  parse_all_task: "Pause all",
  start_all_task: "Start all",
  gong: "",
  tiao_task: "tasks",
  user_parse: "User pause",
  no_dail_date: "Not during the call period",
  queueing: "Queuing",
  finallyed: "Completed",
  system_parse: "System pause",
  system_hangup: "System hangup",
  arrearage_parse: "Owe a fee",
  today_parse: "Paused for today",
  overed: "End",
  edit: "Edit",
  copy: "Copy",
  paste: "Paste",
  create_yu: "Created on",
  no_task: "No tasks",
  delete_task: "Delete task ",
  delete_task_danger: "High risk prompt: After the task is deleted, all data of 'non calling customers' under the task will be cleared and irreparable. Please operate with caution.",
  delete_task_danger_desc: "If you are currently exporting data, please confirm that the data export is complete before deleting it.",
  sync_delete_customer: "Synchronize deletion of data for all 'called customers'",
  start_task: "Start task",
  stop_task: "Stop task",
  refresh_data_desc: "Data display is not timely, manual refresh for statistics",
  repeat_dial_desc_1: "Repeated dialing of disconnected numbers, interval",
  repeat_dial_desc_2: "Minutes, repeated in total",
  bot_count: "BOTs:",
  sips_desc: "Sip description:",
  start_datetime: "Start date:",
  maohao: "：",
  continues_fails: "Consecutive failures:",
  continues_fails_desc: "Stop dialing after times",
  fault_desc_label: "Latest fault description: ",
  run_gaikuang: "Overview",
  no_data2: "no date",
  only_kan_self: "Only view oneself",
  kan_child: "View all",
  fang_wucao: "Incorrect input of the anti misoperation command 'delete'",
  delete_task_desc2: "High risk prompt: If you are currently exporting data, please confirm that the data export is complete before deleting it. Are you sure you want to delete the task",
  delete_task_desc3: " ? After the task is deleted, the data is cleared together and cannot be restored.",
  yixia_task_parse: "The following tasks will be suspended",
  yixia_task_parse2: "And only pause tasks with the status of in queue, in progress, and system paused",
  yixia_task_parse3: "Tasks with the status of Queuing, In Progress, and System Pause can be paused. Please be informed!",
  yixia_task_start: "The following tasks will be started",
  yixia_task_start2: "And only tasks with statuses of 'Not Started', 'User Paused', 'System Paused', and 'System Suspended' can be started",
  yixia_task_start3: "Tasks with the status of 'Not Started', 'User Paused', and 'System Suspended' can start. Please be informed!",
  add_jiedai: "Add scene",
  tiao_cj: "",
  default_jiedai: "Default scene",
  today_jiedai: "Today's reception",
  history_jiedai: "Historical reception",
  no_jiedai: "No scene",
  scene_name: "*Scene Name",
  scene_name_desc: "Please fill in the scene name",
  scene_sip: "Reception sip",
  scene_sip_desc: "Please select a reception sip",
  jiedai_botname: "BOT name:",
  jiedai_sip_name: "Reception Sip Name:",
  scene_jiedai: "Reception scene",
  jiedai_time: "Reception time",
  qiyong: "Enable",
  please_input_scene_name: "Please enter a scene name.",
  please_input_scene_name2: "The scene name should be at least 2 words long.",
  new_scene_name: "New scene",
  edit_scene_name: "Edit scene:",
  delete_scene: "Delete scene",
  delete_scene1: "Are you sure you want to delete the scene",
  delete_scene2: " ? After deletion, it cannot be restored.",
  ai_callout: "AI call out",
  cur_data: "current data",
  seats_count: "total",
  xi: "",
  seats_online: "online",
  tonghuaing: "calling",
  busying: "busy",
  jietinglv: "answer %",
  yx_jietinglv: "effective %",
  diushilv: "deletion %",
  seats_records: "records",
  seats_statistic: "statistics",
  mass_seats_statistic: "mass statistics",
  turn_regong: "The probability of manual transfer not being able to obtain idle seats is higher, and the efficiency of answering is lower.",
  seats_config: "Seat configuration",
  seats_config_desc: "Seat center: 1. All extension seats in the system can make calls to each other. 2. The robot calls out intended customers and transfers them to the extension seat without occupying any extra lines.",
  seats: "Seats",
  seats_group: "Group",
  jiedai_gateway: "Gateway",
  customer_number: "Attendant phone",
  customer_name: "Attendant name",
  dial_status: "Status",
  turn_rg_success: "Transfer to manual succeeded",
  turn_rg_success_effective: "Transfer to manual effective succeeded",
  type_e: "Type",
  turn_rg: "Transfer to manual",
  group_boda: "Intragroup calls",
  dial_time: "Call time",
  hangup_time: "Hangup time",
  turn_rg_time: "Transfer time",
  newdata: "Add",
  batch_modify_ip_port: "Batch Modify",
  batch_modify_ip_port_title: "Batch Modify IP and Port",
  batch_modify_ip_port_tip: "Lines matching the old IP and port under the current account will be replaced with the new IP and port. The database and SIP files will be updated together. Gateway lines are excluded.",
  old_server_ip: "*Old IP",
  old_server_port: "*Old Port",
  new_server_ip: "*New IP",
  new_server_port: "*New Port",
  please_old_server_ip: "Please enter the old IP.",
  please_old_server_port: "Please enter the old port.",
  please_new_server_ip: "Please enter the new IP.",
  please_new_server_port: "Please enter the new port.",
  please_new_ip_port_diff: "The new IP and port cannot be the same as the old ones.",
  please_valid_port: "Please enter a valid port number (1-65535).",
  xin_name:"*Name",
  xin_name_desc:"Please enter the name",
  xin_renz: "*Auth Name",
  xin_renz_desc: "Please enter the auth name",
  xin_pass: "*Auth password",
  xin_pass_desc: "Please enter the auth password",
  sip_number: "Sips",
  sip_number_desc: "Please enter the sips",
  prefix: "Prefix",
  prefix_desc: "Please enter the prefix",
  default_turn_sip: "Default to manual sip",
  name_bs: "Name identification",
  renz: "Auth Name",
  renz_pass: "Auth password",
  yuyin_gateway: "gateway",
  third_sip: "Third SIP",
  online_status: "Online status",
  work_status: "Work status",
  unqiyong: "unenabled",
  create_time: "Creation time",
  modify: "Modify",
  remove: "Remove",
  please_input_name: "Please enter a name.",
  please_name_2char: "The name must be at least 2 characters long.",
  please_input_renz: "Please enter an authentication name.",
  please_input_renz_6char: "The authentication name must be at least 6 characters long.",
  please_input_renz_pass: "Please enter the authentication password.",
  please_input_renz_pass_6char: "The authentication password must be at least 6 characters long.",
  new_sip: "Add sip",
  delete_gateway: "Delete gateway",
  delete_gateway_desc: "Are you sure you want to delete:",
  ma: " ?",
  modify_sip: "Modify sip",
  unopen: "unopened",
  new_seats_group: "Add seat group",
  xin_seats_group_name: "*Seat Group Name",
  xin_seats_group_name_desc: "Please enter the name of the seat group",
  seats_group_desc: "Description",
  seats_group_desc2: "Please enter a description",
  mingcheng: "Name",
  select: "Select",
  add_seats: "Add seats",
  select_seats: "Select seats",
  sip_reg_account_pass: "SIP reg account/password",
  uninvolved: "uninvolved",
  yg_fenji: "extension",
  mobile_seats: "Mobile seat",
  net_seats: "Extension seat",
  calling: "calling...",
  idle: "idle",
  please_left_select: "Please select a seat group on the left side",
  please_input_seats_group_name: "Please enter a seat group name.",
  please_seats_group_name_2char: "The seat group name must be at least 2 characters long.",
  delete_seats_group: "Delete seats group",
  modify_seats_group: "Modify seats group",
  new_seats: "Add seats",
  net_seats_phone: "Extension phone",
  mobile_seats_phone: "mobile",
  seats_type: "Type",
  yuangong_or_new: "Employee or new extension",
  please_select_yg: "Please select an employee",
  xin_customer_name: "*Customer service name",
  xin_customer_name_desc: "Please fill in the customer service name",
  xin_customer_phone: "*Customer service number",
  xin_customer_phone_desc: "Please enter the customer service number",
  please_select_yg_ju: "Please select an employee.",
  please_input_customer_name: "Please enter a customer service name.",
  please_input_customer_phone: "Please enter the customer service number.",
  please_input_customer_phone_2char: "The customer service number must be at least 2 digits.",
  delete_seats: "Delete seats",
  modify_seats: "Modify seats",
  seats_type_1: "Customer Service - Extension (Network Phone)",
  seats_type_2: "Customer Service - Mobile Number",
  seats_type_1_short: "CS - Extension",
  seats_type_2_short: "CS - Mobile",
  seats_type_1_desc: "SIP network extension, recommended for seat agents",
  seats_type_2_desc: "Bind a mobile number (CMCC / CUCC / CTCC)",
  seats_type_recommend: "Recommended",
  yg: "Employee",
  new_fj: "Add extension",
  yg_desc: "Bind an existing employee account",
  new_fj_desc: "Manually create a new extension number",
  yg_recommend: "Preferred",
  account: "Account",
  time: "Time",
  thl: "Call volume",
  jtl: "Connection volume",
  jtlv: "Connection %",
  yxjtl: "Effective connection volume",
  yxjtlv: "Effective connection %",
  today: "today",
  yx_th_time: "Effective duration",
  yx_th_pjtime: "Effective average duration",
  new_bot: "New Bot",
  upload_bot: "Upload",
  please_enter_botname: "Please enter the name",
  please_use_hy: "Please select an industry",
  please_use_zhy: "Please select an industry subtype",
  reload: "Reload",
  public_z: "Release",
  copy_top_me:"Copy to my Bot",
  audit:"in review",
  go_online: "Online",
  recording: "Recording",
  synthetic_voice: "synthetic voice",
  recording_synthetic_voice: "Recording + variable synthesis",
  audit_no_pass: "no pass",
  audit_pending_words: "Scripts pending audit",
  audit_pending_records: "Records or text pending audit",
  audit_words_name: "Script name",
  audit_modify_time: "Modified at",
  audit_submitter: "Submitter",
  audit_type_col: "Type",
  audit_content_audio: "Content / Audio",
  audit_segment_title: "Segment {n}",
  audit_pair_text: "Text",
  audit_pair_audio: "Recording",
  audit_translate_result: "Transcription",
  audit_flow_node: "Flow node",
  audit_know_entry: "Knowledge entry",
  audit_words_llm: "Script LLM prompt",
  audit_llm_readonly_hint: "Approve or reject via the script list on the left",
  audit_translate: "Transcribe",
  audit_pass: "Approve",
  audit_reject: "Reject",
  audit_filter_all: "All",
  audit_filter_submitter_ph: "Filter by submitter name",
  audit_filter_wordsname_ph: "Filter by script name",
  audit_placeholder_title: "No script selected",
  audit_placeholder_hint: "Select a row on the left to load recordings and text",
  audit_only_my_submissions: "Only my submissions",
  audit_mode_need_me: "Pending my review",
  audit_mode_my_submit: "My submissions (to superior)",
  enabled: "Enabled",
  unenabled: "not enabled",
  botid: "Bot ID:",
  task_list_id: "Task ID:",
  hyid: "Industry:",
  updatetime: "Update time:",
  nobot: "No Bot",
  down_bot: "Download Bot ",
  downing_bot: "Downloading Bot:",
  please_down_pass: ",Please enter the correct download password",
  please_down_pass_1: "Please enter the download password",
  mainflow: "Main flow",
  knows: "Knowledges",
  multtalk: "Multiple Sessions",
  hotword: "Hot words",
  question_learn: "Learning",
  yxlabel: "Intention label",
  train: "Train",
  record: "Recordings",
  sync: "Synchronous",
  tiandun: "Intercept",
  botset: "Set",
  llmset: "LLM Set",
  big_model_tab: "LLM settings",
  llm_menu_chat: "Dialog LLM",
  llm_menu_assistant: "Post-call analysis",
  llm_menu_hangup: "Hangup keywords",
  llm_menu_prompt_lib_admin: "Prompt library (admin)",
  llm_menu_guide: "Examples & guide",
  llm_page_subtitle: "Configure prompts by section on the left. Save when done.",
  llm_train_context_title: "Training: context coherence (aux.)",
  llm_train_context_desc:
    "Used in script-training QA: an auxiliary model judges whether the bot reply follows the prior turn. Requires “Activate assistant analysis” in Post-call analysis (same switch as post-call result analysis). Separate from the dialog LLM prompt.",
  llm_train_context_prompt_label: "Context-coherence analysis prompt",
  llm_train_context_placeholder:
    "User template for training QA. Include {{dialogue}} and optionally {{knowledgeCatalog}} or {{allKnowledge}} (same meaning).",
  llm_train_context_placeholders: `Placeholders (training coach User template):
• {{dialogue}} — dialogue history + the robot line under review (injected by the server).
• {{knowledgeCatalog}} or {{allKnowledge}} — all knowledge entries for this script (order, title, triggers, playout text), injected when the coach request passes ai2WordsId.
If you omit both knowledge placeholders but ai2WordsId is set, the knowledge block is prepended before the dialogue block automatically.
API field userPromptTemplate overrides this saved template when non-empty.`,
  llm_guide_intro: "Reference examples only. Your real prompts are edited in the first three items on the left.",
  llm_guide_train_context_title: "Training: context-coherence analysis (sample)",
  llm_guide_train_context_intro:
    "Used during script training: an auxiliary model checks whether each bot reply follows the user’s prior turn. Configure it under ② Post-call analysis → “Training: context coherence (aux.)”, and keep “Activate assistant analysis” on. It uses the same master switch as post-call analysis.",
  llm_guide_train_context_li1:
    "Use {{dialogue}} for dialogue + line under review; use {{knowledgeCatalog}} or {{allKnowledge}} for the full knowledge list of this script so the model can suggest a line from KB when needed.",
  llm_guide_train_context_li2:
    "Require a strict output format (e.g. JSON only) so scores or labels can be parsed reliably.",
  llm_guide_train_context_li3:
    "State clear criteria: classify the user’s prior line (including opening “hello/hi” greetings), on-topic vs off-topic, flow drift, and short-reply handling; if you follow the built-in coach schema, keep JSON keys aligned (e.g. customerPrevClass, hasIssue).",
  llm_guide_train_context_warn:
    "Do not rename {{dialogue}}, {{knowledgeCatalog}}, or {{allKnowledge}}. They differ from post-call [conversation].",
  llm_guide_train_context_sample: `{{allKnowledge}}

{{dialogue}}

You are a script-quality assistant. Use the knowledge list above and the dialogue block to judge whether the bot’s latest reply follows the user’s previous turn.

【Criteria】
1. Relevance: Does the reply address what the user just asked or said?
2. Coherence: Is it consistent with the business goal, without obvious non-sequiturs?
3. Short replies: If the user only says “OK” / “mm-hmm”, is the bot’s next step reasonable?

【Output】 Valid JSON only, no Markdown or extra text:
{
  "context_ok": "yes|no|partial",
  "reason": "",
  "suggestion": ""
}`,
  no_select_bot: "No selected",
  xin_bot_name: "*Bot name",
  xin_bot_name_desc: "Please enter a name",
  ss_hy: "Industry",
  ss_hy_type: "Industry subtype",
  ss_hy_type_desc: "Please select an industry subtype",
  upload_bot_file: "Upload Bot files",
  bot_desc: "Bot Description",
  please_bot_desc: "Please enter the Bot description",
  please_bot_name: "Please enter the name of the Bot.",
  please_hy: "Please select your industry.",
  please_hy_type: "Please select an industry subtype.",
  please_import_file: "Please select the file to import.",
  edit_bot: "Edit Bot",
  delete_bot: "Delete Bot",
  delete_bot1: "Are you sure you want to delete the Bot“",
  delete_bot2: "”? After deletion, it cannot be restored.",
  public_bot: "Release",
  public_bot1: "Are you sure you want to“",
  public_bot2: "”Is it released to the Bot market?",
  bot_wait: "Bot waiting time",
  bot_wait_desc: "Explanation: When there is no sound from the other party during the call, the maximum waiting time of the robot exceeds this time value, and the Bot will enter the process of user not answering in the knowledge base.",
  max_duration: "Maximum call duration for outbound calls",
  minute: "minute",
  max_duration_desc: "Explanation: The maximum call duration per call, beyond which Rot will automatically hang up. After being transferred to manual labor, it is not under control.",
  noise_handle: "Noise reduction processing",
  ji: "level",
  noise_handle_desc: "Explanation: When there is noise in the surrounding environment, reduce the noise in the environment. But there are also cases of mishandling normal sounds.",
  noise_gv_handle: "Noise filtering treatment",
  bridge_turn_human_waittime: "The timeout waiting time for manual conversion, in seconds.",
  bridge_turn_human_waittime_desc: "Explanation: Set 0 seconds as permanent wait",
  noise_gv_handle_desc: "Explanation: After the noise recognition engine determines, it will return a noise ratio (the smaller the noise ratio, the closer it is to the human voice), with a noise ratio of>=",
  noise_gv_handle_desc2: "The sound is judged as noise.",
  noise_key: "Noise ignore processing keywords, separated by ',' between multiple words",
  noise_key2: "Multiple keywords separated by commas",
  noise_key_desc: "Explanation: When a person's voice is not very clear, it will be misjudged as noise. At this time, the system can determine it as a normal voice by matching the text and keywords generated by ASR.",
  bot_speed: "Bot speed",
  key_pipei: "Keyword matching pattern",
  bot_asr: "Which sentence does the robot say to start ASR recognition",
  china_mode: "中文",
  english_mode: "English",
  di1: "First sentence",
  di2: "Second sentence",
  di3: "Third sentence",
  di4: "Fourth sentence",
  di5: "Fifth sentence",
  di6: "Sixth sentence",
  di7: "Seventh sentence",
  di8: "Eighth sentence",
  never: "Never",
  tiandun_title: "Day Shield intercepts calls by matching keywords in user replies. System libraries include Default, Voicemail/Secretary, and Explicit Rejection—enable categories as needed, and add account-specific keywords below. Settings apply to all scripts under this account.",
  illustrate: "explain",
  system_lanjie: "The system defaults to intercepting keywords (all scripts for all accounts in the entire system take effect)",
  please_key: "Please enter keywords",
  copy_all: "Copy All",
  save_sx: "Save and take effect",
  use_sys_key: "Using the system to intercept keywords",
  use_sys_key2: "Block keywords (all scripts of the current account take effect)",
  copy_success: "copy success",
  copy_failure: "copy failed",
  node_name: "node name",
  label_name: "tag name",
  node_bot: "Node Bot",
  node_desc: "If it is the first sentence spoken after connecting, the system recommends using a long sentence. For example, \"Hello (pause for 2-3 seconds), we are doing XXX business here",
  node_desc1: "Please fill in the text description of the node script.",
  upload_record_sm: "Uploading recordings only supports audio files in WAV format [mono, 8000Hz sampling rate]",
  click_me: "Click on me to listen to the recording of the current script",
  upload_record: "Upload recording",
  online_record: "Online voice recording requires microphone permission to be enabled.",
  push_address: "Collect and push addresses (press the # key to push; pause voice to push)",
  please_enter_http: "Please enter an address starting with HTTP/HTTPS",
  please_enter_param: "Please enter the parameter name",
  please_select_bl: "Please select a variable",
  add_param: "Add param",
  please_example: "Please enter the Json parameter, for example: {'name ':' {name} ',' age ':' {phone number} '}",
  search_result: "Query Results (Multiple Results Equal to Multiple Branches)",
  please_enter_back: "Please enter the return value",
  add_result: "Add Results",
  push_message_handle: "Post push processing",
  push_message_handle1: "The waiting sound played to the user during the process of waiting for the message to return",
  yibu_desc: "Asynchronous waiting: After the system sends an HTTP request to the business end and the business responds, the business data is returned through the asynchronous interface (see interface document 2-3-25); Synchronous waiting: After the system sends an HTTP request to the business end, the business end immediately returns business data.",
  other_set: "Other settings",
  allow_break: "Allow break",
  allow_break_desc: ">=One word interruption: The robot stops talking as soon as the customer speaks. Intelligent interruption: If the customer speaks more than 2 words, the robot pauses. If the customer does not speak, the robot will continue to finish the remaining words. Keyword interruption: When a customer's content name contains a keyword, the robot stops speaking the current sentence and then continues to speak the sentence in the name.",
  allow_break_desc1: "Intelligent interruption is prone to noise and misjudgment as a customer speaking, but it can adapt to most scenarios and is suitable for customers with simple script configuration and call scenarios. Keyword interruption refers to the situation where the content of a customer's speech contains keywords, and the robot stops speaking. The configuration requirements for dialogue keywords are relatively high.",
  set_customer_grade: "Set level",
  send_sms: "Send sms",
  queren: "confirm",
  score_name: "*Branch name",
  score_name_desc: "Please fill in the branch name",
  score_proper: "*Branch Properties",
  xin_key: "*Keys",
  xin_key_desc: "Please enter keywords and enter multiple, split",
  no_pz_key: "[No keywords configured]",
  pp_score_key: "Keywords matched to this branch",
  yx_use_key: "(Priority is given to using keywords)",
  yx_use_key1: "Priority configuration, such as: \"Package~9\" The larger the number, the higher the priority",
  copy_all_key: "Copy all keywords",
  delete_all_key: "Delete all keywords",
  answer: "Ask",
  answer_desc: "Match customer answers to this branch, multiple answers, please enter interval",
  score: "Score (usually used in exam scenarios)",
  score_desc: "When the user answers' hit ', it will automatically count towards this score",
  modify_label: "Modify tag",
  xin_label_name: "*tag name",
  xin_label_name_desc: "Please fill in the tag name",
  normal_node: "Normal node",
  keyword: "${key}",
  asr_char: "${asr text}",
  breakl: ">=1 word break",
  break2: "Keyword break",
  break3: "Ai break",
  new_score: "New branch",
  asyn_message: "Asynchronously waiting for message return",
  sync_message: "Sync waiting for message return",
  please_enter_score_name: "Please enter the name of the branch.",
  please_select_score_proper: "Please select a branch attribute.",
  please_enter_key: "Please enter the keywords.",
  please_enter_label_name: "Please enter a name for the label.",
  please_node_name: "Please enter a name for the node.",
  please_node_bot: "Please configure the Bot for the node.",
  repeat_cishu: "The number of repetitions must be greater than or equal to 1 and less than or equal to 5.",
  please_enter_address: "Please enter the calling address.",
  please_dy_adress_http: "The calling address is incorrect. Please enter the correct address starting with http/https",
  please_enter_params: "Please fill in the Param parameter.",
  please_enter_header_prarams: "Please fill in the Header parameter.",
  word_node: "Text node",
  ivr_node: "IVR node",
  ivr_node_desc: "IVR node:After connecting, process distribution can be carried out by pressing the button",
  gather_node : "Gather node",
  jump_node: "Jump node",
  jump_node_desc: "Jump node:You can specify to jump to any other process or hang up/switch to manual mode",
  delete_score: "Delete branch",
  delete_score1: "Are you sure you want to delete the branch“",
  delete_score2: "”? After deletion, it cannot be restored.",
  modify_score: "Modify branch",
  key_bixu: "The priority within the parentheses of the keyword must be a number",
  warn: "warn",
  please_hot_word: "Please enter the hot words.",
  show_hot_edit: "View hot word editing rules",
  show_hot_edit_desc: "1. Supports batch addition, with hot words separated by commas. 2. Only supports Chinese and no special symbols. 3. A single hot word can have up to 10 characters",
  cur_hot_word: "Current hot words",
  edit_hot_word: "Edit Hot Words",
  edit_jump_node: "Edit Jump Node",
  xin_jump_to: "*Jump To",
  please_jump_celv: "Please select a jump strategy",
  stream: "flow",
  please_select_stream: "Please select the process to jump to",
  please_conf_node_name_desc: "Please configure the Bot description for the node.",
  new_question: "New Issues",
  tianjia: "*add to",
  exist_problem: "Existing issues",
  new_problem: "New Issues",
  select_exist_problem: "*Select an existing issue",
  xin_title: "*Title",
  please_enter_title: "Please enter a title.",
  please_select_type: "Please select a type",
  zz_click_learn: "This configuration of regular expression keywords yields better results [click me to learn]",
  zz_click_learn1: "Regular expression keywords for better results [click me to learn]",
  edit_know_node: "Edit Knowledge Node",
  basedata: "Basic information",
  answer_type: "Answer method",
  single_answer: "Single sentence answer",
  enter_mult_talk: "Entering Multiple Sessions",
  jump_to: "Jump To",
  hulv_wusheng: "Ignore Silence",
  hulv_wusheng_desc: "Ignore Silence: When enabled, the answer to this sentence is played. If the user does not speak, a silent judgment will not be triggered. Press Unrecognized to proceed to the next step of the process.",
  follow_play: "Play along with the main process",
  follow_play_desc: "Play along with the main process: When enabled, this sentence will be played along with the main process. Play this sentence first and then play the voice of the main process.",
  mult_stream: "Multi flow",
  please_jump_stream: "Please select multiple processes to jump to",
  answer_voise: "Answer voice",
  answer_voise_desc: "Jump to knowledge questions in multiple rounds of conversation without configuring answer recordings. The system will directly skip to use the answer recording configured on multiple nodes for playback.",
  add_duotiao: "Add multiple answer voices, and the system will take turns using them",
  no_answer: "No response voice",
  train_optimize_record_sidebar_hint: "Select an item under \"Existing issue\" on the left first.",
  answer_audio_desc: "Answer the recorded text description",
  please_enter_audio_desc: "Please fill in the answer recording text description",
  upload_audio: "Upload recording files",
  tj_modify: "Submit modifications",
  delete: "Delete",
  train_optimize_log_view: "View",
  please_select_jump_stream: "Please select the jump process.",
  please_select_jump_mult_stream: "Please select the multi round process to jump to.",
  please_answer_audio: "Please fill in the recorded text description of the answer.",
  delete_answer_audio: "Delete answer recording",
  delete_answer_audio1: "Are you sure you want to delete the answer recording“",
  please_search_key: "Please enter the keyword for the query",
  record_search_title_content: "Search by title or content",
  record_batch_selected: "Selected: {n}",
  record_batch_synthesis: "Batch synthesize",
  record_batch_synthesis_empty: "Please select at least one row.",
  record_batch_synthesis_done: "Synthesized {n} item(s).",
  record_batch_synthesis_partial: "Done: {ok}, failed: {fail}.",
  wait_record: "To be recorded",
  set_record: "Recording set",
  set_grade: "Set level",
  new_create_problem: "New Question",
  questions: "The current knowledge base contains a total of",
  questions2: "Questions",
  gaoyou: "High quality:",
  gaoyou_celv: "Keyword Priority>Knowledge Node High Optimization",
  bz_question: "Standard issues",
  you_record: "Already recorded",
  yw_question: "Business issues",
  ask: "Ask",
  key: "Key",
  update_time: "Update time",
  more: "more",
  set_gy: "Set as High Premium",
  cancel_gy: "Cancel Priority",
  wait: "",
  ge_ask: "A question method.",
  delete_question: "Delete Question",
  delete_question_desc: "Are you sure you want to delete“",
  tuodong: "Drag to adjust order",
  set_break: "Interrupt set",
  save_bj: "Save Layout",
  stream_name: "*flow name",
  stream_name_desc: "Please fill in the flow name",
  new_stream: "New flow",
  please_enter_stream_name: "Please enter a name for the flow.",
  no_record: "No recording",
  enable_break: "Break enabled",
  enable_grade: "Level has been set",
  label_mao: "Tag:",
  audio_node: "Voice node",
  audio_tooltip: "Voice node: Voice needs to be recorded in advance",
  double_click: "Double click to enter content",
  gather_node_desc: "Gather node: can collect buttons and customer conversation content",
  word_node_desc: "Text node: After configuring text, convert it into a recording using TTS technology",
  next_select: "Next step: To be selected",
  modify_stream: "Modify flow",
  delete_stream: "Delete flow",
  delete_stream2: "Are you sure you want to delete the flow“",
  delete_node: "Delete node",
  delete_node2: "”Node? After deletion, it cannot be restored.",
  answer_score: "Answer Branch",
  node_all_desc: "Only 'all' branches will appear on the node, and all recognition results will follow this branch",
  default_check_key: "Default detection keywords, which will be directly used when hitting the knowledge base",
  default_no_check_key: "Do not detect keywords, jump directly to the next node for any answer",
  self_define_score: "Custom Answer Branch",
  no_asr: "no asr",
  no_asr_desc: "Priority for this node: When the user cannot recognize their speech, follow the 'unrecognized' process of this node; Knowledge base priority: When a user cannot recognize their speech, follow the process of 'unable to respond' in the knowledge base.",
  ben_node_yx: "node priority",
  konw_yx: "knowledge priority",
  repeat: "Repeat",
  repeat_desc: "Repeat this sentence (usually used in exam scenarios): When the user cannot recognize what they are saying, have the machine repeat this sentence.",
  please_repeat_num: "Please enter the number of repetitions",
  bot_speed_desc: "Set the reaction speed of the robot at the current node, which only takes effect at the current node. Note: The first sentence of the opening statement will not take effect",
  break11: ">=1 word interruption (customer talking robot stops speaking)",
  break12: "Knowledgebase keyword interruption (only determining knowledge base keywords)",
  break13: "All keyword breaks (knowledge base and node keyword breaks)",
  break14: "Intelligent interruption (the robot pauses when the customer speaks)",
  please_config_node_bot: "Please configure the Bot for the node.",
  wait_learn: "Waiting for problem learning",
  show_dial_record: "View call logs",
  record_time: "recording time",
  learn_status: "Learning status",
  no_learn: "Not Learned",
  learned: "Learned",
  learn: "Learn",
  no_search_record: "record was not found",
  wait_learn_sentence: "Delete sentence to be learned",
  wait_learn_sentence1: "Are you sure you want to delete the sentence to be learned“",
  bot_record: "Bot recording",
  repeat_record: "Recording Again",
  stop_record: "stop record",
  play_record: "play record",
  down_record: "download record",
  is_https: "To enable online recording, secure access is required through a domain name. For example:",
  is_https1: "Https://domain name",
  record_progress: "Recording progress",
  sy: "residue",
  ju: "",
  wait_record_bot: "Bot to be recorded",
  recorded: "Recorded",
  clear_all_record: "Clear all recordings",
  stream_node: "Flow node",
  konw_node: "Knowledge node",
  bot_content: "Bot content",
  know_title: "Title of knowledge points",
  clear_all_record1: "Are you sure you want to clear all recordings? After clearing, it cannot be restored.",
  di1z: "First:",
  di1z1: "Fuzzy Match All Words",
  di1z2: "Regular keywords:“",
  di1z3: "word.*word",
  di1z4: "”",
  di1z5: "The customer said, How much can you borrow with a loan of 3%? This sentence appears:“",
  di1z6: "",
  di1z7: "” “",
  di1z8: "number",
  di1z9: "”So this sentence will be hit",
  di1z10: "wherein ",
  di1z11: ".*",
  di1z12: "The configuration cannot be omitted, indicating that“",
  di1z13: "” and “",
  di1z14: "”Any sentence that appears in the middle will be hit.",
  di2z: "Second:",
  di2z1: "(Too | Really | Very)",
  di2z2: " Keywords or related",
  di2z3: " Regular keywords:“",
  di2z4: " (too | really | very). * (complex | troublesome)",
  di2z5: " The customer said, Are you having too much trouble with the loan? This sentence appears:“",
  di2z6: " highest",
  di2z7: " trouble",
  di2z8: " ”So this sentence will be hit",
  di2z9: " The customer said, Is your loan really too complicated? This sentence appears:“",
  di2z10: "true",
  di2z11: "complex",
  di2z12: "The customer said, 'Do you have a lot of complicated loan processes?“",
  di2z13: "very",
  di2z14: " Indicates that the occurrence of 'too', 'true', or 'very' will result in being hit",
  di2z15: " Indicates that the occurrence of complexity or trouble will result in being hit",
  di2z16: "If any combination of the above two sets of words appears simultaneously, this keyword will be hit.",
  di2z17: "For other more advanced regular matching relationships, please input regular expressions on Baidu to learn",
  di2z18: "(Complex | troublesome)",
  tuodong2: "Drag to adjust the judgment order.",
  manzu: "When all of the following rules are not met, set the customer to",
  add_gz: "Add rule",
  default_gz: "Restore system default rules",
  tsmanzu: "Simultaneously meeting the following conditions",
  please_selectc: "Please select a condition",
  duogefenge: "Multiple ',' divisions",
  add_tj: "Add conditions",
  yx_set: "Set the intention level label to",
  hf_default: "Restore default rules",
  pdxx: "Judgment order",
  gzzz: "In case no details are displayed, the system defaults to using: Default Rule 2 (loose)",
  rule: "rule",
  yxbq: "Customer Intention tag",
  ppcs: "Number of matches",
  affirm: "affirm",
  deny: "deny",
  refuse: "refuse",
  no_conf_condition: "There are no configuration conditions.",
  please_select_condition: "Please select a condition.",
  please_enter_fenge: "Please enter content keywords and split them into multiple ','.",
  please_select_yx_grade: "Please select the intention level label.",
  delete_rule: "Delete rule",
  sync_bot: "Script copying is the process of making a complete copy of the current script to the selected subordinate account. After successful copying, the subordinate account will automatically activate and use it (including calling tasks). If this script needs to be copied again when the subordinate account already has it, it needs to be 'deleted' once. If it is not deleted in advance, the system will automatically filter and not perform the copy operation.",
  explain: "explain",
  batch_sync: "Batch sync",
  all_select: "select all",
  ge_account: "accounts",
  sync_bots: "Sync Bot",
  sync_gei: "About to synchronize with",
  sync_sure: "Are you sure you want to synchronize your Bots immediately?",
  task_sync: "After synchronization, only tasks that use this Bot will be updated",
  task_sync1: "After synchronization, immediately enable as a single task outbound call Bot",
  task_sync2: "[Use the following options with caution]",
  task_sync3: "After synchronization, all multitasks will immediately switch to this Bot",
  child_access_mode_title: "Subordinate Bot access permission",
  child_access_mode_0: "Full access (view & edit)",
  child_access_mode_1: "View only (cannot edit)",
  child_access_mode_2: "Cannot view",
  child_access_mode_col: "Access",
  child_access_mode_0_short: "Full",
  child_access_mode_1_short: "View only",
  child_access_mode_2_short: "No view",
  child_view_password: "Unlock password",
  child_view_password_placeholder: "Optional, 6 characters",
  child_view_password_tip: "If set, subordinates must enter this password before opening the Bot. Leave empty to skip.",
  child_view_password_unlock_title: "Enter unlock password",
  child_view_password_unlock_tip: "This Bot was synced with a view password. Enter the 6-digit password to continue.",
  child_view_password_unlock_placeholder: "6-digit password",
  child_view_password_error: "Incorrect password, please try again",
  child_view_password_format: "Enter a 6-character password (letters or digits), or leave empty",
  child_view_password_set: "Password set",
  word_detail_forbidden_title: "Bot details unavailable",
  word_detail_forbidden_tip: "This Bot was synced by your parent account with view restricted. You can see it in the list but cannot open details.",
  word_view_only_tip: "This Bot was synced as view-only. You can browse details but cannot modify it.",
  child_account_name: "Subordinate account name",
  level: "level",
  sj:"Business",
  user: "User",
  account_remark: "Remark",
  sync_time: "Sync time",
  xin: "new",
  old: "old",
  issync: "Sync or not",
  nosync: "Not synchronized",
  synced: "synchronized",
  copyed: "copied",
  uncopy: "Not copied",
  batch_copy_bot: "Batch copy Bot",
  batch_copy_bot_desc: "Are you sure you want to copy the script? After copying, the current call of the subordinate account will automatically enable this Bot.",
  please_gx_child_account: "Please check the lower level account.",
  batch_delete_bot: "Batch delete Bot",
  batch_delete_bot_desc: "Are you sure you want to delete the script for the subordinate account? After deletion, it will cause the current calling state to have no available Bots.",
  copy_bot: "Copy Bot",
  copy_bot1: "Confirm“",
  copy_bot2: "”Do you want to copy the script? After copying, his current call will automatically activate this script.",
  delete_bot_account1: "Confirm deletion“",
  delete_bot_account2: "”Is the script for the account? After deletion, it will cause the current calling state to have no available scripts.",
  wei: "",
  click_train: "Click on the button in the upper right corner to start training the script",
  customer_yx_label: "The customer intention tag is:",
  please_enter_message: "Please enter a message and press Enter to send it",
  bdmb: "Open the dialing panel (network phone) and call the 9999 number to test the script. Please note that this script must be chosen for the reception script.",
  voise_train: "Speech training",
  text_train: "Text training",
  train_param_title: "Parameters",
  train_llm_analysis: "LLM review",
  train_llm_analysis_need_assistant:
    "Turn on “Activate assistant analysis” under LLM settings → Post-call analysis. Training analysis uses that switch.",
  train_carry_analysis_rule:
    "Carry-over analysis runs only when “Activate assistant analysis” is on and the “Training: context coherence” prompt is saved (LLM → Post-call analysis). No extra toggle here.",
  train_context_title: "Dialog carry-over review",
  train_context_pending: "Dialog carry-over analysis in progress...",
  train_parse_ok: "Model reply parsed as JSON (technical only).",
  train_parse_fail: "Could not parse model reply as JSON — no structured verdict.",
  train_carry_verdict_label: "Carry-over:",
  train_carry_no_struct: "No structured carry-over verdict; see model text below if any.",
  train_model_explanation_label: "Model analysis",
  train_full_model_output_label: "Full model output",
  train_zh_triple_title: "Model output (3 fields)",
  train_zh_carry_context: "Carry context",
  train_zh_brief_reason: "Brief reason",
  train_zh_improve_suggestion: "Improvement suggestion",
  train_zh_empty: "(none)",
  train_customer_prev_class: "Customer previous line (model class)",
  train_section_issues: "Issues",
  train_section_suggestions: "Suggestions",
  train_section_rewrite: "Suggested rewrite",
  train_rewrite_source_label: "Source",
  train_rewrite_from_knowledge: "Knowledge base entry",
  train_rewrite_from_new: "Custom line",
  train_suggested_utterance_label: "Suggested line to play",
  train_knowledge_index_label: "List index (legacy)",
  train_suggested_db_id_label: "suggestedDbId (record or knowledge id)",
  train_suggested_kb_id_label: "Knowledge id",
  train_suggested_kb_title_label: "Knowledge title",
  train_suggested_playback_text_label: "Playback text",
  train_raw_hint: "Full model reply (for manual review when JSON is missing):",
  train_context_issue: "Issue detected",
  train_context_ok: "On-topic",
  train_context_attention: "Review suggested (carry-risk or notes)",
  train_carry_risk_label: "Carry-risk: ",
  train_optimize: "Optimize",
  train_one_click_optimize: "One-click optimize",
  train_one_click_optimize_done: "One-click optimization done",
  train_one_click_optimize_failed: "One-click optimization failed",
  train_optimize_logs: "Optimize logs",
  train_optimize_log_time: "Time",
  train_optimize_log_operator: "Operator",
  train_optimize_log_action: "Action",
  train_optimize_log_action_create: "Created",
  train_optimize_log_action_update: "Updated",
  train_optimize_log_action_create_knowledge: "New knowledge",
  train_optimize_log_action_add_answer: "New answer",
  train_optimize_log_action_update_knowledge: "Updated knowledge",
  train_optimize_log_rollback_status: "Rollback",
  train_optimize_log_rollback_time: "Rollback time",
  train_optimize_log_rollback_yes: "Rolled back",
  train_optimize_log_rollback_no: "Active",
  train_optimize_log_knowledge: "Knowledge",
  train_optimize_log_customer_text: "Customer utterance",
  train_optimize_log_keyword: "Keyword",
  train_optimize_log_answer: "Answer",
  train_optimize_log_change_desc_col: "Change description",
  train_optimize_log_desc_kw_new: "New keyword",
  train_optimize_log_desc_kw_modify: "Keyword update",
  train_optimize_log_desc_ans_label: "Answer description",
  train_optimize_log_edit_need_knowledge: "This log has no knowledge title to edit.",
  train_optimize_log_delete_confirm: "Delete only this optimize log entry? Knowledge will not be changed.",
  train_optimize_log_rollback_btn: "Rollback",
  train_optimize_log_rollback_confirm:
    "Rollback this optimization? Added keywords will be removed from the knowledge, and newly added answer descriptions will be removed.",
  train_optimize_log_rollback_success: "Rollback completed",
  train_optimize_logs_need_session: "Open a session detail first, then view optimize logs.",
  train_optimize_know_title: "Training · add knowledge",
  train_optimize_no_words: "No script context",
  train_know_saved_hint: "Knowledge saved. Reload training if needed.",
  train_carry_optimized_badge: "Optimized",
  train_carry_expand_hint: "Tap to expand",
  stop_train: "Stop Training",
  detail: "details",
  result: "Result",
  th_event: "Call Event",
  lunci_desc: "Seconds, call round:",
  statistic_date: "Statistical time",
  kehu: "custom",
  minutes: "minutes",
  feiyong: "cost",
  llm_telcharge: "LLM call cost",
  fee_deducted_total: "Fee (actual deduct)",
  fee_deducted_total_tip: "Total amount finally deducted for this period.",
  llm_fee_included: "LLM fee (included)",
  llm_fee_included_tip: "Shows LLM-related deduct only. Already included in the adjacent actual-deduct total, not an extra charge.",
  call_cost_day: "Call cost (actual deduct)",
  call_cost_day_tip: "Total call fee finally deducted for this period.",
  cur_balance: "balance",
  please_1_more: "Select one or more months",
  stream_id: "Serial number",
  recharg_time: "Recharge time",
  recharg_account: "Recharge account",
  recharg_fy: "Recharge cost",
  recharg_before_ye: "Balance before recharge",
  recharg_after_ye: "Balance after recharge",
  recharg_desc: "Description",
  kaitong_yunyin: "Opened for operation",
  merchant_total: "Total",
  merchant_opened_on_page: "Opened (page)",
  user_name: "User name",
  slient: "silent",
  disable: "disable",
  expire: "expire",
  yunyin_switch: "Operation switch",
  yunyin_balance: "Operating balance",
  minite_danjia: "Minute billing unit price",
  asr_danjia: "Identification frequency unit price",
  llm_input_1k_danjia: "LLM input (¥/1K tokens)",
  llm_output_1k_danjia: "LLM output (¥/1K tokens)",
  tts_char_danjia: "TTS (¥/10K chars)",
  llm_voice_danjia: "LLM voice (¥/minute)",
  llm_billing_mutex_hint: "Mutually exclusive with LLM voice rate above; token/TTS pick one mode.",
  fee_dialog_tip: "When enabled, all accounts under this merchant are billed by these rates.",
  fee_stop_on_arrears: "Stop dialing on arrears",
  fee_stop_on_arrears_hint: "Stop dialing when operational balance hits overdraft.",
  fee_over_balance: "Operational overdraft",
  fee_over_balance_unit: "Unit: yuan (negative)",
  fee_over_balance_hint: "Allowed negative balance for operational billing. Enter as a negative amount, e.g. -100.",
  fee_voice_section_title: "Voice billing",
  fee_voice_normal_tag: "Standard",
  fee_voice_llm_tag: "LLM dialogue",
  fee_voice_diff_brief: "Regular scripts: billed per minute at the standard rate. LLM dialogue: billed at the LLM voice rate when configured; otherwise all calls use the standard rate.",
  fee_more_section_title: "More",
  fee_more_unit_asr: "ASR ¥/time",
  fee_more_unit_llm: "Token ¥/1K",
  fee_more_unit_tts: "TTS ¥/10K chars",
  fee_more_asr_tag: "ASR",
  fee_more_llm_in_tag: "LLM in",
  fee_more_llm_out_tag: "LLM out",
  fee_more_tts_tag: "TTS",
  fee_unit_yuan_per_minute: "¥/minute",
  fee_unit_label_yuan_per_minute: "Unit: ¥/minute",
  yikaiqi: "Opened",
  yunyin: "Business",
  rechar: "Recharge",
  yinyin_data: "Business data",
  yinyin_data_desc: "Reminder: After opening the operational account settlement, the minutes dialed by all accounts (including regular accounts and merchant accounts) under this merchant will be deducted according to this operational settlement method. Convenient for system owners and agents to settle fees.",
  jihuo: "enabled",
  yuyin_minite: "Voice",
  asr_ci: "ASR",
  llm_input_1k: "LLM input",
  llm_output_1k: "LLM output",
  tts_per_char: "TTS",
  llm_voice_minute: "LLM voice",
  recharge_before_money_account: "Recharge account",
  reru: "Charging fee, unit: yuan",
  reru_d: "Unit: $, maximum 10 million",
  congru_balance: "Charging fees:",
  congru_balance_desc: ", balance after charging",
  gouxuan: "After checking and confirming, you can click to recharge",
  please_congru_balance: "Please fill in the fees charged. Unit: $",
  please_congru_feiyong: "Please check and confirm before clicking on recharge",
  zhouqi_month: "Period Month",
  zhouqi_day: "Period - Days",
  ai_dail: "AI call",
  customer_name_1: "Customer Name",
  yuji_date: "Expected transaction date",
  follow_time: "Follow time:",
  customer_tag: "客户标签",
  add_tag: "Label",
  sure_enter: "Are you sure to enter the current follow-up stage?",
  follow_record: "Follow records",
  follow_remind: "Follow and reminder",
  baifang: "visit",
  remind_date: "Reminder date",
  follow_xq: "Follow details",
  follow_xq_desc: "Fill in the follow-up details and press' Enter 'to submit",
  no_follow_record: "There are no follow-up records yet",
  zong: "",
  tiao_record: "records",
  qian_genjin: "Follow up before",
  th_record: "Call Log",
  new_tag_group: "Add label group",
  tag_groupname: "Label group name",
  tag_groupname_desc: "Label group name",
  please_new_tag: "Please add a label",
  new_add_tag: "Add label",
  please_enter_tagname: "Please enter a label name",
  please_new_add_taggroup: "Please add a new label group",
  please_enter_tag_groupname: "Please enter a label group name.",
  please_enter_tag_name: "Please enter a label name.",
  delete_tag_groupname: "Delete label group",
  delete_tag_groupname2: "Are you sure you want to delete the label group:",
  modify_taggroupname: "Modify label group",
  delete_tag: "Delete label",
  delete_tag2: "Are you sure you want to delete the label:",
  thsc_fh: "Call duration>=",
  follow_jd: "follow-up stage",
  please_intention_grade: "Please select an intention level",
  please_yy_tag: "Please select a semantic label",
  follow_startdate: "Follow start date",
  follow_enddate: "Follow end date",
  allocation_startdate: "Allocation start date",
  allocation_enddate: "Allocation end date",
  please_kh_tag: "Please select the customer label",
  new_kh: "Add customer",
  batch_import: "Batch import",
  batch_import_child_data: "Batch export for subordinate accounts",
  batch_join_ai: "Batch join AI calls",
  batch_allocation: "Batch allocation",
  batch_fr_sea: "Batch placement into sea",
  batch_delete_dh: "Batch delete",
  clear_kh: "Clear",
  batch_dial: "Batch call",
  stop_batch_dial: "Stop call",
  refresh: "Refresh",
  xin_kh_name: "*Customer Name",
  please_kh_name: "Please enter the customer name",
  xin_kh_phone: "*customer phone",
  please_kh_phone: "Please enter the customer's phone number",
  please_companyname: "Please enter the company you belong to",
  down_excel_desc: "Fill in the corresponding content according to the title header (or modify the title header in the Excel file to meet the requirements, with the file suffix xls, xlsx)",
  celv_allcation: "Policy allocation",
  number_z1: "number",
  select_user: "Select user",
  search_gjz: "Keywords for query",
  follow_date: "Follow date",
  allocation_date: "Allocation date",
  please_export_pass: "Please enter the export password",
  allocation_kh: "Allocation customers",
  cur_selected: "Selected",
  cur_selected1: "allocate customer data",
  kefenpei: "allocable total:",
  kefenpei1: "Allocation according to policy, please select the allocation quantity and users",
  kefenpei2: "Explanation: When customer data is selected, it will be allocated according to the selected data, and when it is not selected, it will be allocated according to the policy.",
  enter_account: "enter the account",
  please_enter_account: "Please enter account names separated by commas for multiple accounts, such as test001, test002",
  allocation_time: "Allocate time",
  a_grade_desc: "Class A",
  b_grade_desc: "Class B",
  c_grade_desc: "Class C",
  d_grade_desc: "Class D",
  e_grade_desc: "Class E",
  f_grade_desc: "Class F",
  las_th_sc: "Last call duration",
  follow_time_1: "Follow up time",
  new_ruku: "New storage",
  ai_chufang: "AI visit",
  genjinzhong: "Following up",
  youyixiang: "Intentional",
  daiqiatang: "To be negotiated",
  yichengjiao: "Deal",
  please_enter_khname: "Please enter the customer's name.",
  please_enter_khphone: "Please enter the customer's phone number.",
  please_enter_khphone2: "The format of the phone is incorrect. Please enter an 11 digit phone number.",
  please_import_excel: "Only Excel files can be imported, with an extension of xls or xlsx",
  please_select_child_account: "Please select a subordinate account",
  please_import_pass: "Please enter the import password.",
  please_enter_fenpei_num: "Please enter the allocation quantity",
  please_select_child_user: "Please select a subordinate user",
  please_gouxuan_ai_account: "Please check the customer who needs to join the AI call.",
  please_gouxuan_public_sea: "Please check the customers who need to join the public sea.",
  sip_unonline: "The SIP extension is not online. Please open the dialing panel and click on 'go online'.",
  please_gouxuan_batch_user: "Please check the customers who need to make bulk calls.",
  wktong_sip: "SIP extension capability not enabled.",
  my_yxkh: "My Customers",
  yxkh: "Effective Customers",
  my_yxkh_desc: "You can add, delete, and modify customer information, and directly add customers to the AI's quick call list. You can also make calls through the manual outbound call provided by the system.",
  my_kh: "My Customers",
  tag_manage: "Label Management",
  kh_sea: "Customer seas",
  kh_sea_desc: "Share all customer resource data, regularly collect data from the high seas, and regularly track and identify potential customers.",
  create_date_rq: "create date",
  end_date_rq: "end date",
  batch_lq: "Batch collection",
  please_gx_lqkh: "Please check the customer who needs to be claimed.",
  show_history_record: "Display historical call records",
  dial_date_z: "Date of call",
  kh_name: "Customer Name",
  callin_callout: "call in/call out",
  thsc_second: "Call duration (seconds)",
  minite: "minites",
  jifeishichang: "Billing duration (minutes)",
  record_hangup_desc: "Record or hang up description",
  dial: "Call",
  work_remind: "Work reminder",
  work_remind_desc: "Display historical reminders that need to be processed, and highlight unprocessed reminders",
  handle: "handle",
  handled: "handled",
  wait_handle: "Pending",
  remind_type: "Remind",
  remind_content: "Reminder content",
  remind_time: "Reminder Time",
  recv_phone: "Receiver number",
  sms_content: "Sms content",
  send_time: "Send time",
  please_select_ch_sms: "Please select customer level to send timely Sms",
  xin_template_name: "*Template name",
  xin_template_name_desc: "Please enter the template name",
  template_content: "Template content",
  template_content_desc: "Please enter the template content",
  template_name: "Template name",
  template_code: "Template code",
  new_template: "Add template",
  delete_sms_template: "Delete template",
  modify_sms_template: "Modify template",
  sms_manage: "Sms management",
  sms_manage_desc: "Sms template configuration, Sms query sent",
  send_smsed: "Sms sent",
  sms_template: "Sms template",
  celv_config: "Policy Configuration",
  readed_count: "Total read",
  zuotian: "Yesterday",
  last_week: "Last week",
  last_month: "Last month",
  last_3month: "Last three months",
  summary: "Summary",
  today_realtime_data: "Today",
  today_realtime_data_30minu: "Historical（30m）",
  task_realtime_date: "Task Statistic",
  history_data: "Historical",
  bind_weixin_phone: "You have not yet bound your phone number. Please bind it first",
  func_open_close: "Function on or off",
  noneed_open_close: "Opening or closing unnecessary function entrances",
  task_more_config: "Task dialing related configuration",
  user_ai_dialtime: "Users can configure the interval between AI calls themselves",
  task_dail_time_default: "Task Call Period - Default",
  task_stop_time_default: "Task Prohibit Dialing Period - Default",
  task_continues_default: "Number of consecutive task failures - Default",
  bot_config_more: "Related configuration",
  bot_download_password: "Set the password for downloading scripts, which also applies to the password for importing numbers",
  download_self_pass: "Do I also need a password to download scripts created by myself",
  system_config: "System level configuration",
  gloabl_push_address: "Global Push Address Configuration",
  gloabl_push_address_desc: "Please enter the push address, such as: http://www.baidu.com",
  create_user_callback: "Create user callback",
  delete_user_callback: "Delete user callback",
  gloabl_dial_callback: "System-wide call order callback",
  ai_fenxi_address: "AI analysis address",
  sms_duijie_set: "SMS docking settings",
  sms_duijie_set_desc: "The system supports docking with Alibaba's SMS channel. Please fill in the parameter values applied for on the Alibaba platform in the following input boxes.",
  xin_sign_name: "*Signature name",
  xin_sign_name_desc: "Please enter the name of the signature, such as Baidu",
  xin_sms_template_id: "*SMS template ID",
  xin_sms_template_id_desc: "Please enter the SMS template ID",
  access_key_id: "Please enter the AccessKeyId",
  access_key_secret: "Please enter the AccessKeySecret",
  sms_content_example: "Sample SMS content",
  sms_content_example_desc: "Example: [Signature Name] Dear Customer: Today is your birthday, and all XXXX staff wish you a happy birthday! All the best!",
  sign_name: "Signature name",
  sms_template_id: "SMS template ID",
  sms_example: "Sample Sms",
  new_sms_channel: "Add SMS channel",
  please_sign_name: "Please enter a signature name.",
  please_sms_id: "Please enter the SMS template ID.",
  please_accesskeyid: "Please enter AccessKeyId。",
  please_accesskeysecret: "Please enter AccessKeySecret。",
  modify_sms_channel: "Modify and add SMS channels",
  delete_sms_channel: "Delete SMS channel",
  weixin_mini_app_config: "WeChat Mini Program Configuration",
  weixin_mini_app_config_desc: "Here, the parameters of the mini program are configured to connect the system with the mini program. After the connection, data can be managed through the mini program.",
  mini_param_config: "Mini Program parameter configuration",
  xin_miniapp_name: "*Mini Program name",
  xin_miniapp_name_desc: "Please enter the name of the mini program",
  xin_miniapp_appid_desc: "Please enter AppID",
  xin_miniapp_appsecret_desc: "Please enter AppSecret",
  xin_app_scan: "*Mini program scanning code",
  mini_proper_1: "Mini Program name is a required attribute.",
  appid_need: "AppID is a required attribute.",
  appsecret_need: "AppSecret is a required attribute.",
  file_max2m: "The file is too large, the maximum size should not exceed 2M.",
  file_jpg_png: "Only images in jpg and png formats can be uploaded.",
  weixin_public_config: "WeChat official account configuration",
  weixin_public_config_desc: "The official account parameters are configured here to connect the system with the official account. After the connection, the official account can push timely messages in real time.",
  weixin_public_perpor: "Official account parameter configuration",
  xin_public_name: "*Name of official account",
  xin_public_name_desc: "Please enter the name of the official account",
  template_details_1: "Details push template ID (acceptance result notification)",
  template_taskfinish_1: "Task call completion push template ID (execution result notification)",
  template_serveraddress_1: "Server Address URL (WeChat Message Push)",
  please_enter_token: "Please enter a Token",
  template_account_1: "Account is about to expire, push template ID (renewal reminder)",
  template_balance_1: "Insufficient Balance Push Template (Account Insufficient Balance Notification)",
  domain_address: "Domain name address, such as:“ http://www.baidu.com/ ”",
  please_enter_domainaddress: "Please enter the domain name address",
  public_welcome: "Welcome to official account",
  public_welcome_desc: "When the user follows the official account, the welcome message is pushed.",
  public_menu_json: "Menu definition of official account (JSON format)",
  public_menu_json_desc: "The menu display definition on the official account.",
  class_template: "Category Template Configuration",
  class_template_desc: "Category template application: WeChat official account ->template message ->category template ->add a prompt from the category template library: you can't see the official account of the template message, please click New Function - Template Message to activate.",
  please_enter_template_id: "Please enter the template ID",
  add_field: "Add field",
  test: "Test",
  replase_wei: "replace with",
  add_class: "Add class",
  class_field: "Class field",
  show_content: "show contents",
  show_content_desc: "show contents",
  defind_content: "Custom Content",
  defind_content_desc: "Please enter the custom content",
  gz_public: "Customer list of followed official account",
  headerimg: "head sculpture",
  phone_hm: "phone number",
  province: "province",
  city: "city",
  subscribe_time: "Follow time",
  please_tx_class_field: "Please enter the category field, such as {{thing9. DATA}}}",
  wexin_sqkt: "The WeChat official account is not authorized to open, please contact the administrator.",
  public_name_need: "Official account name is a required attribute.",
  token_need: "Token is a required attribute.",
  please_enter_class: "Please enter the category field.",
  class_field_geshi_error: "The format of the category field is incorrect.",
  please_show_content: "Please select the display content.",
  style_set_title: "Style parameter configuration",
  xin_login_main: "*Login Page Title",
  xin_login_main_desc: "Login Page Title",
  xin_login_main_welcom: "*Welcome message to login page",
  xin_login_main_welcom_desc: "Welcome message to login page",
  login_beian_hao: "Login page registration number",
  login_log_tu: "*Login page logo image 50px * 50px",
  login_log_tu2: "*Main page logo image 50px * 30px",
  login_log_tu3: "*Background image of login page",
  login_log_tu4: "*Background image on the right side of the login page",
  main_page_title: "*Main page title",
  main_page_title_desc: "Main page title",
  dashboard_welcome: "*Dashboard's Welcome Message",
  dashboard_welcome_desc: "Dashboard's welcome message, such as: Wishing you smooth work and happy every day!",
  dingbu_color: "Top Bar Color",
  left_color: "Left menu bar background color",
  left_menu_color: "Left Menu Bar Font Color",
  naviage_style: "Navigation samples",
  naviage_style_1: "1.Login page title modification location",
  naviage_style_2: "2.Welcome message to login page",
  naviage_style_3: "3.Login page registration number",
  naviage_style_4: "4.Login page logo image size: 50px * 50px",
  naviage_style_5: "5.Background image of login page",
  naviage_style_6: "6.Main page title",
  naviage_style_7: "7.Main page logo size:50px * 30px",
  please_login_main: "Please enter the login page title.",
  please_login_welcome: "Please enter the welcome message on the login page.",
  please_upload_logo: "Please upload the login page logo image.",
  please_upload_backgroud: "Please upload the background image of the login page.",
  please_enter_main_title: "Please enter the title of the main page.",
  please_upload_logo_tu: "Please upload the logo image on the main page.",
  max_file_1m: "The file is too large, the maximum size should not exceed 1M.",
  new_blacklist: "Add blacklist",
  batch_add_duohaoma: "Batch addition, multiple numbers separated by commas",
  batch_add_duohaoma2: "Please enter a blacklist number separated by multiple commas.",
  new_third_blacklist: "Add a third-party blacklist",
  call_address: "call address",
  test_third_title: "Testing third-party blacklists",
  test_phone: "Test number",
  callback_message: "Back Message",
  other: "other",
  method: "method",
  control_param: "Control parameters",
  all_system_start_time: "System silent start time",
  all_system_end_time: "System silent end time",
  dingshi_clear_db: "Regularly clean up database data",
  dingqi_clear_record: "Regularly cleaning recording data",
  dingqi_clear_record2: "Regularly clean up customer imported data that has not been dialed for a long time",
  jifeijingdu: "Billing accuracy (in seconds), all calls with a duration less than this value are counted as 0 seconds",
  jifeijingdu2: "Please enter billing accuracy",
  click_control_param: "Control parameters for point calling and dialing",
  meiri_dail_limit: "Maximum daily call limit for a single number",
  meiri_dail_limit2: "Please enter the daily dialing limit for a single number",
  m30_dail_limit: "Maximum call limit for a single number within 30 days",
  m30_dail_limit2: "Please enter the maximum dialing limit for a single number within 30 days",
  ssl_upload: "Certificate upload, only Apache certificates downloaded by Alibaba are supported",
  wss_upload: "WSS certificate upload (zip format)",
  submit: "submit",
  tian_q: "Days ago",
  please_search_user: "Please enter the query user",
  add_sips: "Add sip",
  my_sips: "My sips",
  please_search_sip: "Please enter the query sip",
  sip_name: "Sip name",
  sip_remark: "Sip remark",
  pinlv: "Frequency quantity/second",
  nolimit: "unlimited",
  reg: "register",
  dj: "abutment",
  reg_username: "Username",
  reg_password: "Password",
  reg_status: "Status",
  ip_address: "IP address",
  port: "port",
  caller: "caller",
  please_left_show_user: "Please select the users you want to view on the left side",
  please_s_user: "Please select a user.",
  please_s_sip: "Please select a sip.",
  jijiang_gei: "About to give users:",
  jijiang_gei2: "Distribution Sip:",
  new_allocation_sip: "Add distribution sip",
  remove_user_allsip: "Remove all sips from the user",
  remove_user_allsip2: "High risk reminder: Before removing, please ensure your account",
  remove_user_allsip3: "You have not used all the lines you assigned him, otherwise it will affect his normal dialing?",
  delete_sip: "Delete sip",
  delete_sip2: "High risk reminder: Before removing, please ensure your account",
  delete_sip3: "Is this line no longer in use, otherwise it will affect his normal dialing?",
  enable_status: "active state",
  xin_sip_name: "*Sip name",
  xin_sip_name_desc: "Please enter the line name",
  xin_server_ip: "*Server IP",
  xin_server_ip_desc: "Please enter the server IP",
  xin_reg_account: "*Account",
  xin_reg_account_desc: "Please enter a registered account",
  please_enter_caller: "Please enter the caller",
  songhao_pinlv: "Delivery frequency",
  songhao_pinlv2: "For example: every 1 second call out 2 numbers",
  gateway_port_num : "Number of gateway ports",
  please_sip_remark : "Please fill in the route remarks",
  xin_port: "*Port",
  xin_zici_port: "Please enter the port",
  xin_reg_pass: "*Password",
  xin_reg_pass_desc: "Please enter the password",
  callee_prefix: "prefix",
  callee_prefix_desc: "Please enter the prefix",
  line_dj_caller_prefix_tip: "If the line already has caller number and callee prefix configured, it is not recommended to set them here, to avoid failures when switching lines later.",
  change_sip_force_caller_prefix_tip: "This account has a forced caller number and/or forced prefix. When switching to other lines, the line's caller/prefix will not take effect. Please remove the caller number and prefix configured on the account first.",
  codec: "Speech code",
  codec_desc: "G729/PCMA/PCMU",
  port_sm: "Default distribution prefix for each port, separated by commas",
  port_sm2: "By default, send 001002003 and so on, with no prefix for single port gateways.",
  sipu: "Sip:",
  who_use: "Who is using",
  nouse: "not used",
  ports: "Port",
  allocation_who: "To whom",
  is_enable: "Enable or not",
  delete_sip33: "Delete Sip ",
  tishi_001: "Reminder: The users who are using this line are as follows:",
  tishi_002: "There are currently no users using this line, you can confidently delete it.",
  wei_user: "users",
  tongshi_fenpei: "assigned to:",
  please_enter_sip_name: "Please enter a line name.",
  please_enter_sip_name2: "Please enter a Sip name.",
  please_server_ip: "Please enter the server IP.",
  please_server_port: "Please enter the server port.",
  please_reg_account: "Please enter a registered account.",
  please_reg_account_6char: "The minimum length of the registered account is 6 characters.",
  please_reg_password: "Please enter the registration password.",
  please_reg_password_6char: "The registration password should have a minimum length of 6 characters.",
  please_songpin: "Please enter a valid delivery frequency: both seconds and number count must be positive integers",
  please_11phone: "Please enter an 11 digit phone number",
  stopuse: "Stop",
  duijie_mode: "Docking mode",
  reg_mode: "Registration mode",
  gateway_mode: "Gateway mode",
  kouwg: "gateway",
  busi_list: "Business list",
  busi_list_desc: "When the control permission of the merchant user role is given, the merchant user assigns the role to his subordinate users",
  show_kexuan_role: "View his optional roles",
  keyong_role: "List of available roles for",
  keyong_role_desc: "Assign the role to the merchant and move the mouse over the name to display menu permissions.",
  kexuan_role: "Optional roles",
  please_left_user: "Please select a user on the left side",
  role_menu_qx: "Role menu permissions",
  role_menu_qx_desc: "Move the mouse over the character name to view detailed information",
  ci_role_pz: "This role does not have a menu configured",
  role_pz: "Configuration of roles",
  role_pz_desc: "When a user role is assigned, the user has access to the corresponding module",
  xin_role_name: "*Role name",
  xin_role_name_desc: "Please enter the role name",
  role_desc: "Role description",
  role_desc2: "Please enter the description of the role",
  gongneng_mk: "Function module permission configuration",
  gongneng_mk_desc: "Please select the feature access permissions that need to be opened to the specified role",
  edit_save: "After editing, press Enter to save",
  other_tag: "Other labels",
  teshu_gongn: "Special functions",
  please_left_zw: "Please select a position on the left side",
  user_list: "User List",
  user_list_desc: "Show all current users with this role",
  role: "Role",
  new_zw: "New job",
  please_enter_zwname: "Please enter a job title.",
  new_role: "Add role",
  modify_role: "Modify role",
  please_select_status: "Please select a status",
  new_user: "Add user",
  xin_user_account: "*username",
  xin_user_account_desc: "Please enter the username",
  realname: "Real name",
  realname_desc: "Please enter the real name",
  xin_expirtime: "*Expiration date",
  xin_login_pass: "*Login password",
  xin_login_pass_desc: "Please enter login password",
  xin_sure_pass: "*Confirm password",
  xin_sure_pass_desc: "Please enter a confirmation password",
  ai_seats_num: "*AIs",
  please_ai_seats_num: "Please enter the number of AIs",
  xin_dial_jg: "*Dialing interval",
  please_xin_dial_jg: "Dialing interval, in seconds",
  xin_total_sq: "*Number of authorizations",
  xin_total_sq_desc: "The maximum number of AIs that merchants can open",
  xin_lines: "*Sip",
  gateway_reg: "Gateway registration",
  gateway_reg_desc: "Enter the gateway registration account",
  random_gateway_account: "Generate randomly",
  add_gateway_account: "Add gateway account",
  remove_gateway_account: "Remove",
  gateway_reg_multi_hint: "One user can register with multiple gateways. Click Add to enter another account.",
  gateway_reg_empty_use_username: "Leave empty to use the login username as the gateway account (same as before).",
  gateway_prefix_enabled: "Gateway destination prefix",
  gateway_prefix_enabled_on_desc: "When on, numbers pushed to the gateway include the default prefix",
  gateway_prefix_enabled_off_desc: "When off, numbers pushed to the gateway do not include this prefix",
  line_dj: "Sip docking",
  pool: "Pool",
  edit_remark: "Edit remark",
  please_enter_user_desc: "Please enter the general description information for this user",
  check: "Check",
  please_check_pass: "Please enter the verification password",
  password: "Password",
  gateway_account_sipname: "Gateway account/SIP name",
  gateway_status_prefix: "Gateway Status/Prefix",
  ai_seat: "AI",
  total_ai_seats: "Authorized number/AIs",
  yuyin_jifei: "Voice billing",
  asr_jifei: "asr billing",
  day_dial_control: "Daily call control",
  xian: "limit",
  blacklist_control: "Blacklist control",
  local_blacklist_enable: "Local blacklist activated",
  third_blacklist_enable: "Activation of third-party blacklist",
  expirationtimed: "Expired",
  js_recharg: "Settlement and recharge",
  recover: "restore",
  reset: "reset",
  please_enter_user_account: "Please enter a user account.",
  please_enter_user_account_6char: "The user account must be at least 6 characters long.",
  please_select_expiration: "Please select an expiration date.",
  password_6char: "The password must have a minimum length of 6 characters.",
  please_sure_pass: "Please enter a confirmation password.",
  sure_pass_sure_pass: "The entered password and confirmed password do not match.",
  please_enter_ai_seats: "Please enter the number of AI seats.",
  please_dial_jg: "Please enter the dialing interval.",
  please_total_sq: "Please enter the total number of authorizations.",
  please_bxxxx: "The total authorized number must be greater than the number of AI seats",
  please_sj_max: "Please enter the maximum number of AI seats that can be opened by the merchant.",
  please_reg_gateway_pass: "Please enter the account password for registering with the gateway.",
  please_s_pool: "Please select a communication pool.",
  please_s_port: "Please select a port.",
  please_check_pass2: "Please enter the verification password.",
  delete_user: "Delete user",
  delete_user_ma: "Will his data be permanently deleted and unrecoverable after deletion?",
  reset_pass: "Reset password",
  reset_pass1: "Are you sure you want to reset:",
  reset_pass2: " password for?",
  w_guoqi: "Not expired",
  realname2: "Real name",
  realname2_desc: "Please enter your real name",
  please_enter_bdjg: "Please enter the dialing interval",
  controller: "control",
  xz_mr_ci: "Limit daily connections",
  xz_mr_ci_desc: "Unit: times, equal to 0 means unlimited",
  xz_mr_ci2: "Limit daily minutes of connection",
  xz_mr_ci2_desc: "Unit: minutes, 0 represents unlimited",
  local_blacklist_controller: "Local blacklist control",
  third_blacklist_controller: "Third party blacklist control",
  sms: "SMS",
  enable_sms: "Enable SMS",
  sms_channel: "SMS channel",
  sms_channel_desc: "Please select the SMS channel",
  please_enter_sms_content: "Please enter the content of the SMS sent",
  asr: "ASR",
  edit_asrkey: "Edit ASR key",
  edit_asrkey_desc: "If the key is not configured, it defaults to using your superior's key.",
  clear: "Clear",
  lead: "Lead",
  xin_lead_account: "*Lead account",
  xin_lead_account_desc: "Please enter the lead account",
  xin_lead_pass: "*Lead password",
  xin_lead_pass_desc: "Please enter the lead password",
  financial_general: "Financial Overview",
  account_js: "Account settlement",
  local_account_mode: "Lock the settlement method for all accounts under this account",
  balance_yuan: "Balance, unit: yuan",
  over_balance_yuan: "Overdraw balance, unit: yuan",
  ai_yuezu: "AI monthly rent, unit: yuan/month/piece",
  other_fuwufei: "Other service fees, unit: yuan/month",
  yuyin_feilv: "Voice rate, unit: yuan/minute",
  sms_yuezu: "SMS rate, unit: yuan/piece",
  busi_xxx: "After the merchant user opens it, all of their subordinate sub accounts open this settlement and cannot be modified.",
  yuyin_asr_js: "Speech recognition fee settlement",
  day_cost_limit: "Daily consumption limit",
  day_cost_limit_amount: "Daily limit amount, unit: yuan",
  day_cost_limit_tip: "Configurable only when account settlement or speech recognition fee settlement is enabled. After enabling, the account's daily consumption will be limited to this amount.",
  asr_account_desc1: "Identification will only be deducted from this account, and calls will be stopped when the balance is less than 0.",
  asr_account_desc2: "When there is no balance in the account, deduct it from his superior. When the superior's balance is less than 0, stop calling.",
  asr_feilv_1: "Identification rate, unit: yuan/time",
  get_ta_recharg: "Recharge",
  gei: "",
  yue_recharg: "Balance recharge, unit: $",
  yue_recharg1: "Please enter the amount charged in",
  geiing: "To",
  before_after_recharg: "Recharge, before recharge:",
  before_after_recharg1: "After recharging:",
  jiesuan_lock: "Settlement lock",
  jiesuan_lock2: "You have enabled the settlement lock for this account, and the voice settlement methods for him and all his subordinates are based on your current configuration. After opening, it is impossible to restore. Please operate with caution.",
  xin_user_name: "*Username",
  xin_user_name_desc: "Please enter the login username",
  xin_password: "*Password",
  xin_password_desc: "Please enter your login password",
  ss_role: "Role",
  please_enter_account2: "Please enter the username",
  telephone: "telephone",
  telephone_desc: "Please enter a telephone",
  ss_zhiwu: "Position",
  please_enter_user: "Please enter a user name.",
  need_shuzi_char: "The user name must be composed of numbers or English letters.",
  need_6char: "The user name must be at least 6 words long.",
  please_select_role: "Please select the role you belong to.",
  sure_delete_user: "Are you sure you want to delete the user",
  sure_reset_pass: "Are you sure you want to reset the user",
  sure_reset_pass2: "Is the password for?",
  reset_success: "Reset successful",
  reset_success1: "The password for this account is reset to:",
  reset_success2: "It is recommended to reset the new password after logging in to the system.",
  weixin_public_title: "WeChat official account channel and other configurations",
  weixin_public_title_desc: "After the docking of WeChat official account, you can log in to the system through WeChat scanning code, or you can query orders on official account.",
  weixin_public_set: "WeChat official account settings",
  weixin_app_set: "WeChat Mini Program Settings",
  func_set: "Function settings",
  blacklist_set: "blacklist configuration",
  blacklist_set_desc: "Configure necessary control parameters for the safe and stable long-term operation of the system",
  local_blacklist_db: "Local blacklist",
  third_blacklist_db: "Other blacklist library",
  sms_weixin_other_set: "SMS/WeChat official account channel and other configurations",
  sms_weixin_other_set_desc: "SMS/SMS supports the Alibaba channel and can enable the sending of various blessings or greetings as needed. After the docking of WeChat official account, you can log in to the system through WeChat scanning code, or you can query orders on official account.",
  menu_role_manage: "Menu Role Management",
  menu_role_manage_desc: "Here, a new menu role can be added. After selecting a menu based on the role, users can be specified to access the opened menu entry.",
  busi_fenpei_role: "Merchant assignable menu",
  role_qx: "Menu permissions",
  system_style: "System Style",
  system_style_desc: "Settings include logo, title, background image, etc",
  style_set: "Style Settings",
  system_anquan_pz: "System security parameter configuration",
  system_anquan_pz_desc: "Configure necessary control parameters for the safe and stable long-term operation of the system",
  dj_manage: "Docking management",
  dj_manage_desc: "Manage SIP line docking & assignment, voice cloning, and other third-party integrations.",
  fenpeixianlu: "Distribution Sip",
  sms_dj: "SMS docking",
  user_manage: "User manage",
  user_manage_desc: "You can add regular users here and add subordinate agents on the mer您确定要对以上筛选条件下的号码进行重复拨打吗chant page.",
  balance_notify_set: "Balance WeChat reminder",
  balance_notify_threshold: "Notify when balance is below",
  balance_notify_max_num: "Stop after this many reminders (at most once a day)",
  balance_notify_yuan: "CNY",
  balance_notify_times: "times",
  balance_notify_hint: "Scheduled reminder is sent at most once per day. After the set number of reminders, automatic push stops. Immediate push ignores the balance threshold and sends once to billed accounts that have bound WeChat.",
  balance_notify_push_now: "Push now",
  balance_notify_push_confirm: "This will send a WeChat reminder immediately, even if the balance is still above the threshold. Continue?",
  balance_notify_param_error: "Please enter a valid threshold and reminder count.",
  user2_manage: "Employ manage",
  user2_manage_desc: "You can add and delete employees here.",
  yuangong: "Employ",
  asr_aiover_content:"End decision",
  asr_aiover_content_desc:"The AI doesn't get interrupted when it speaks, it keeps talking without pausing. Default option description: When the AI speaks, anything the customer says is judged. Another option is to determine only what the customer said after the AI spoke",
  recharge_remark_desc: "remark",
  reboot: "reboot",
  rebootdesc: "After the server (OS) is restarted, wait 5 minutes and try again",
  rebootsure_desc: "Before restarting the server, check that no calls are made or the server is silent. Are you sure to restart the server immediately?",
  sms_channel_col: "Channel",
  sms_proxy_add_title: "Add SMS gateway",
  sms_proxy_edit_title: "Edit SMS gateway",
  sms_ip_or_url: "IP or URL",
  sms_ip_or_url_ph: "e.g. 127.0.0.1",
  sms_port_ph: "e.g. 8080",
  sms_enterprise_id: "Enterprise ID",
  sms_enterprise_id_ph: "Enterprise ID",
  sms_sign_id_ph: "Signature ID",
  sms_template_id_ph: "Template ID",
  sms_template_param: "Template parameters",
  sms_template_param_ph: "Template parameters",
  sms_goip_name: "GOIP name(s)",
  sms_goip_name_ph: "Multiple names separated by comma",
  sms_uplink_recv: "SMS uplink URL",
  sms_report_recv: "SMS report URL",
  sms_price_fen: "SMS price",
  sms_price_fen_ph: "Price in fen",
  sms_price_unit: "(unit: fen)",
  sms_day_limit: "Max sends per day",
  sms_day_limit_ph: "Daily cap",
  sms_count_unit: "(unit: messages)",
  sms_month_limit: "Max sends per month",
  sms_month_limit_ph: "Monthly cap",
  sms_test_phone: "Test mobile",
  sms_test_phone_ph: "Mobile number",
  sms_test_content: "Test content",
  sms_test_now: "Send test",
  sms_test_dialog_title: "SMS send test",
  sms_test_btn: "Test",
  sms_err_valid_ip: "Please enter a valid IP",
  sms_err_valid_port: "Please enter a valid port",
  sms_err_valid_url: "Please enter a valid URL",
  sms_err_goip: "Please enter GOIP name(s)",
  sms_err_sign_id: "Please enter signature ID",
  sms_err_username: "Account cannot be empty",
  sms_err_password: "Password cannot be empty",
  sms_err_price: "Please enter SMS unit price",
  sms_err_day: "Please enter daily send limit",
  sms_err_month: "Please enter monthly send limit",
  sms_err_test_phone: "Please enter mobile for test",
  sms_err_test_need_save: "Save the configuration first, then test",
  sms_err_test_no_target: "Open test from the list action",
  normal: "Normal",
  comm_pool_manage: "Communication Pool Management",
  comm_pool_manage_desc: "Communication pool has two modes: 1) default mode, used for direct gateway/VOS/SIP lines and precise control of dial count or minutes; 2) privacy/API line mode, used for indirect docking through privacy/API vendors to dynamically rewrite called numbers via API for flexible dialing, while also controlling dial count or minutes precisely.",
  comm_pool_mode_desc: "Both registration modes do not push numbers to VOS. They only receive SIP calls from VOS as receivers.",
  comm_line_cycle_desc: "Lines in a communication pool are used in rotation. When more than one line is configured, the system selects lines in order by configured parameters. If one line reaches a limit, it will stop being selected until the next cycle.",
  comm_pool_name: "Pool name",
  comm_name_remark: "Name remark",
  comm_owner_account: "Owner account",
  comm_operation: "Operation",
  comm_temp_disable: "Temporarily disabled",
  comm_address_port: "Address/Port",
  comm_reg_username: "Register username",
  comm_edit: "Edit",
  comm_view: "View",
  comm_pool_add_title: "Add communication pool",
  comm_pool_edit_title: "Edit communication pool",
  comm_line_add_title: "Add line",
  comm_line_edit_title: "Edit line",
  comm_pool_type: "Pool type",
  comm_pool_mode: "Mode",
  comm_pool_account_pass: "Account/Password",
  comm_pool_prefix: "Inbound called prefix",
  comm_pool_prefix_placeholder: "Please fill in 4 characters",
  comm_pool_frozen: "Frozen",
  comm_pool_limit: "Frequency limited",
  comm_pool_freeze: "Freeze",
  comm_pool_restore: "Restore",
  comm_pool_delete_confirm: "Are you sure to delete this communication pool?",
  comm_line_pool: "Line pool",
  comm_vos_to_sys: "VOS registers to this system",
  comm_sys_to_vos: "This system registers to VOS",
  comm_rate: "Rate",
  comm_rate_with_unit: "Rate (li)",
  comm_rate_placeholder: "Unit: li. Billing cycle is by minute; less than one minute is counted as one minute.",
  comm_user_rate: "User rate",
  comm_settle_rate: "Settlement rate",
  comm_net_rate: "Net rate",
  comm_min_cost: "Minimum monthly cost",
  comm_use: "Use",
  commcon_prefix: "Prefix",
  comm_codec: "Codec",
  comm_codec_line: "Codec/Line",
  comm_codec_auto: "Auto match",
  comm_codec_desc: "Codec is the voice encoding format. If no special requirement, choose auto match. Line count means simultaneous connected channels.",
  comm_dial_interval_desc: "Interval (seconds) from last connected call end to next call, and from last unconnected call end to next call.",
  comm_dial_interval_on_placeholder: "Connected interval (seconds)",
  comm_dial_interval_off_placeholder: "Unconnected interval (seconds)",
  comm_dial_limit_desc: "Limits for 1 hour total dials, 1 day total dials, and 1 day connected dials. Set 0 for no limit.",
  comm_dial_limit_hour_placeholder: "1-hour limit",
  comm_dial_limit_day_placeholder: "1-day limit",
  comm_dial_limit_connected_day_placeholder: "1-day connected limit",
  comm_month_minute_limit_desc: "Monthly total call minutes based on carrier billing minutes. Less than one minute counts as one minute. 0 means no limit.",
  comm_month_minute_limit_placeholder: "Monthly total call minutes based on carrier billing minutes; less than one minute counts as one minute.",
  comm_provider: "Provider",
  comm_server_ip: "Server IP",
  comm_server_port: "Server port",
  comm_line_name: "Line name",
  comm_line_count: "Line count",
  comm_main_send_number: "Main outgoing number",
  comm_dial_interval: "Dial interval",
  comm_dial_limit: "Dial volume limit",
  comm_month_minute_limit: "Monthly minute limit",
  comm_line_delete_confirm: "Are you sure to delete this line?",
  comm_pool_name_required: "Pool name must be at least 2 characters.",
  comm_pool_account_required: "Account and password are required.",
  comm_pool_prefix_required: "Prefix is required and must be 4 characters.",
  comm_line_name_required: "Line name must be at least 2 characters.",
  comm_line_address_required: "Server address and port are required.",
  comm_server_port_invalid: "Server port is invalid.",
  comm_record_mode: "Record mode",
  comm_no_record: "No recording",
  comm_sys_record: "System recording",
  comm_third_record: "Third-party recording",
  comm_word_content: "Script content",
  comm_word_keywords: "Script audit keywords",
  comm_line_type_landing: "Landing gateway",
  comm_line_type_docking_register: "Docking gateway - register mode",
  comm_line_type_docking: "Docking gateway - direct mode",
  comm_line_type_privacy_landing: "Privacy number - landing gateway",
  comm_line_type_privacy_register: "Privacy number - docking register",
  comm_line_type_privacy_docking: "Privacy number - docking direct",
  comm_line_type_api: "API line",
  team_stat_title: "Team Analysis",
  team_stat_subtitle: "Team analysis only includes customer-center relationship stats. Dial stats are manual calls and exclude robot outbound calls.",
  team_stat_all: "All",
  team_stat_call_duration: "Call duration",
  team_stat_second_unit: "sec",
  team_stat_call_count: "Call count",
  team_stat_count_unit: "times",
  team_stat_start_date: "Start date",
  team_stat_end_date: "End date",
  team_stat_query: "Query",
  team_stat_last10days: "Last 10 days call stats",
  team_stat_today_top10: "Today's top 10 calls",
  team_stat_back: "Back",
  team_stat_account: "Account",
  team_stat_total_dials: "Total dials",
  team_stat_connected: "Connected",
  team_stat_unconnected: "Unconnected",
  team_stat_connect_rate: "Connect rate",
  team_stat_total_duration: "Total call duration",
  team_stat_billing_duration: "Billed duration",
  team_stat_followup: "Follow-up calls",
  team_stat_remind: "Reminder calls",
  team_stat_alloc_success: "Superior allocation success",
  team_stat_alloc_fail_repeat: "Superior allocation retry failed",
  team_stat_add_customer: "New customers",
  team_stat_delete_customer: "Deleted customers",
  team_stat_pubsea_pick: "Picked from public pool",
  team_stat_pubsea_release: "Released to public pool",
  team_stat_operation: "Operation",
  team_stat_view_detail: "View details",
  team_stat_phone: "Phone",
  team_stat_recording: "Recording",
  team_stat_export_started: "Export started, please check downloads later.",
  team_stat_intention_connected: "Connected",
  team_stat_intention_noneed: "Not needed",
  team_stat_intention_need: "Clearly needed",
  team_stat_intention_hangup_after_connect: "Hung up after connected",
  team_stat_intention_unconnected: "Unconnected",
  team_stat_intention_unknown: "Unknown",
  comm_log_title: "Log Analysis",
  comm_log_subtitle: "Used to view real-time communication logs. When enabled, it refreshes every 5 seconds.",
  comm_log_switch_label: "Log collection",
  comm_log_empty: "No log content",
  save_ok: "Saved",
  comm_delete_success: "Deleted successfully",
  auto_refresh: "Auto refresh",
  auto_refresh_interval_3s: "Refresh every 3s",
  auto_refresh_interval_5s: "Refresh every 5s",
  auto_refresh_interval_10s: "Refresh every 10s",
  auto_refresh_interval_default: "Default refresh",
};
export const zh = {
  welcome: "这是您使用本系统的第",
  day: "天",
  expirationtime: "过期时间",
  lastLoginTime: "最近登录时间",
  ainum: "AI坐席数",
  message: "消息",
  recharg_stream: "充值流水",
  persion_data: "个人资料",
  free_app: "免费应用",
  ecological: "生态运营",
  aicall: "AI外呼",
  aicall_desc: "机器人自主呼叫，数据统计一体化服务。同时支持个性化配置话术，应对海量场景，帮助企业实现增长新客，激活留存。",
  callin:"呼入接待",
  callin_desc:"智能呼入接待平台。用于各类答疑咨询服务，可设置智能语音IVR导航，智能分配线路，同时精准获取用户意图，高效完成接待。",
  customer_centor: "客户中心",
  customer_centor_desc: "CRM以销售管理为核心，以销售活动为驱动，以业绩经营为目标，帮助企业实现从线索转化、商机跟进到回款管理等销售全流程的精准管理，通过有效支撑企业的复杂业务需求及业务变化，全面提升销售团队协作效率，进而提升业绩。",
  seats_help: "坐席辅助",
  seats_help_desc: "丰富的知识库搭载知识图谱为客服人员自动推荐参考知识和话术，同时拥有客服工作状态提醒，精准用户画像自动获取等各种类智能辅助模块。",
  normal_blacklist: "普通黑名单",
  normal_blacklist_desc: "海量黑名单库，提供免费使用。请联系您的业务经理。",
  pays_app: "按量付费应用",
  opera_tool: "运营工具",
  lead_market: "线索市场",
  lead_market_desc: "海量数据，精准筛选、线索画像，帮企业快速定位目标用户。",
  dail_line: "拨号线路",
  dail_line_desc: "点对点拨打呼叫",
  mini_app: "小程序",
  mini_app_desc: "付费安装小程序，手机上操作更便捷",
  online_recharge: "在线充值/线下充值",
  online_recharge_desc: "在线充值对接微信商户账号，充值实时到账。线下充值对接客户经理或统一收款账户延迟到账。",
  recharge_time : "充值时间",
  recharge_money : "充入金额",
  recharge_before_money : "充入前余额",
  recharge_after_money : "充入后余额",
  recharge_account : "充入账号",
  recharge_account_remark : "充值账号的备注",
  description : "描述",
  personal_information: "个人信息",
  username: "姓名",
  username_placeholder:"请填写您的姓名",
  email: "邮箱地址",
  email_placeholder:"请填写您的邮箱地址",
  phone: "电话",
  phone_placeholder:"请填写您的电话号码",
  weixin: "微信",
  nobind_weixin: "未绑定微信",
  save: "保存",
  level0 : "超级管理员",
  level1 : "普通用户",
  level2 : "商家用户",
  system_message: "系统消息",
  system_message_desc: "显示系统推送的实时消息",
  message_content: "消息内容",
  message_date: "消息时间",
  action: "操作",
  readed: "已读",
  new_customer: "新客户：",
  call_duration: " 通话时长：",
  second: "秒",
  bot_calling: "正在呼叫",
  call_number: "转呼号码：",
  noise_value: "噪比值：",
  duijie_mini_pro: "未对接微信小程序",
  scan_weixin: "微信扫一扫，进入小程序",
  environmental_monitoring: "环境检测",
  woshi_title: "我是标题",
  upload_download_list: "上传/下载文件列表",
  online: "在线",
  disableUse: "禁用",
  unline: "离线",
  do_not_disturb: "请勿打扰",
  download_ie: "下载谷歌浏览器，页面浏览速度更快",
  help_doc: "帮助文档",
  click_fullscreen: "点击全屏",
  modify_pass: "修改密码",
  bind_weixin: "绑定微信",
  bind_more_weixin: "绑定更多微信",
  logout: "退出登录",
  scan_gongzh: "请扫码关注公众号",
  remove_bind: "解除绑定",
  no_get_head: "没有获取到您的微信昵称和头像，请再次扫码授权",
  sure: "确定",
  cancel: "取消",
  login_pass: "登录密码",
  export_pass: "导出密码",
  sourec_pass: "*原密码",
  sourec_pass_desc: "请填写原密码",
  new_pass: "*新密码",
  new_pass_desc: "请填写新密码",
  sure_new_pass: "*确认新密码",
  sure_new_pass_desc: "请再次输入新密码",
  zyText_1: "鉴于数据存储量的增大，导致数据加载缓慢，即日起，所有数据只保存",
  zyText_2: "天，所有的录音文件只保存",
  zyText_3: "天，超过此时间，将自动清理。请大家及时保存好数据，由此带来的不便还请理解，有任何问题请及时和服务人员沟通，谢谢！<br>系统禁止拨打时间段：",
  navbar_notice_sys_rule: "系统规则与时段说明",
  environmental_test_result: "环境检测结果",
  ie: "浏览器",
  ie_zq: "浏览器符合要求",
  ie_error: "浏览器不符合要求，请下载最新版本的谷歌浏览器。",
  speech_device: "语音设备",
  loudspeaker: "扬声器",
  microphone: "麦克风",
  musice_play: "音乐播放",
  remind: "提醒:",
  remind_desc: "若您对着麦克风讲话时，可以听到自己声音的同时也能听到音乐播放声，则设备正常；如果听不到，请检查您的语音设备。",
  opera_time: "操作时间",
  file_name: "文件名称",
  upload_download: "上传/下载",
  upload_z: "上传",
  download_z: "下载",
  status_desc: "状态描述",
  delete_z: "删除",
  failure: "失败",
  runling: "进行中",
  finally_z: "完成",
  callback: "回拨电话",
  main_phone: "主号",
  symbol_phone: "副号",
  please_input_phone: "请输入拨打号码",
  follow_up: "立刻打跟进",
  follow_up_desc: "填写跟进详情，按“回车”提交",
  net_phone: "网络电话",
  dial_record: "拨打记录",
  hr: "呼入",
  hc: "呼出",
  yjt: "已接通",
  wjt: "未接通",
  dial_number_no : "拨打的号码不正确",
  main_symbol: "未配置主卡或者副卡",
  soft_phone_status: "软电话状态为：",
  auto_response: "自动应答",
  hand_response: "手动应答",
  soft_net_desc: "使用第三软电话替代这里的网页软电话",
  windows_download: "Windows系统点我下载",
  android_download: "安卓系统点我下载",
  ios_download: "苹果手机APP市场搜索：PortSIP 备选：Grandstream WaveLite",
  fenji_phone: "分机号码：",
  reg_pass: "注册密码：",
  reg_lianxi_admin: "注册地址和端口，请联系您的管理员",
  please_online: "请先上线",
  please_dial_phone: "请输入拨打号码",
  sys_weikaitong: "系统未开通网络电话能力。",
  hello: "嗨，",
  welcome_z: "，祝您工作顺利，天天开心！",
  ai_seats: "AI坐席数",
  yuan: "元",
  balance: "余额",
  overBalance: "透支额度",
  lines: "线路",
  today_data: "今日数据",
  realtime: "实时",
  dailcount: "拨打次数",
  ci: "次",
  switchoncount: "接通次数",
  switchon_rate: "接通率",
  conversiontion: "通话总时长",
  pj_conversiontion: "平均通话时长",
  asr_count: "识别次数",
  a_grade: "A类",
  b_grade: "B类",
  c_grade: "C类",
  d_grade: "D类",
  e_grade: "E类",
  f_grade: "F类",
  tiao: "条",
  total_data: "总量数据",
  no_touchphone: "未呼客户",
  ge: "个",
  touchphone: "已呼客户",
  jietong_count: "接通客户数",
  dianhua_jietong_rate: "电话接通率",
  dianhua_jietong_rate_desc: "已接听的客户数/外呼客户总数",
  gradeacd: "意向客户(A/B/C)",
  fen: "分",
  th_time: "通话时长",
  abcdef_desc: "最近7天A/B/C/D/E/F占比",
  leibie: "类别",
  day7_tongji: "最近7天拨打统计",
  boda_count: "拨打总量",
  jietong_phone_count: "接通总量",
  abc_count: "A/B/C总量",
  today_realtime_detail: "今日实时详情",
  c_count: "总量",
  import_customer: "导入客户",
  config_plan: "配置计划",
  select_start_call: "将选中号码开始呼叫",
  change_task_id: "全部转移给任务",
  start_call: "全部开始呼叫",
  stop_call: "全部停止呼叫",
  test_call: "测试拨打",
  bot_name: "BOT名称：",
  dial_range_time: "拨打时段：",
  no_config: "未配置",
  zhouqiboda_time: "周拨打日期：",
  bodawancheng_weixing_push: "拨打完成是否推送微信消息：",
  filter_customer: "过滤客户",
  operat_log: "操作日志",
  add_dail_range_time_desc: "*添加拨打时段，可以添加多条：",
  starttime: "开始时间",
  endtime: "结束时间",
  select_range_time: "选择时间范围",
  add_desc: "添加",
  close: "关闭",
  repeat_zhouqi: "*重复周期",
  task_finish_push: "任务完成微信通知",
  data_push_title: "数据推送",
  please_push_statgy: "请选择推送策略",
  click_me_down: "点击(我)下载模版",
  click_me_down_desc: "根据标题头填充相应内容 (或在EXCEL文件中修改标题头符合要求, 文件后缀为xls, xlsx, txt)",
  select_file: "*选择文件",
  import_statgy: "导入策略",
  filter_statgy: "过滤策略",
  sort_phone: "排序号码",
  import_child_list: "导入到下级账号（不选择导入给自己）",
  select_child_account: "选择下级账号",
  dialing: "拨打",
  test_dial_desc: "输入手机号码进行拨打，多个号码之间“,”分隔",
  push: "推送",
  no_push: "不推送",
  import_template: "按模板导入",
  import_check_phone: "检索号码导入",
  default_desc: "默认",
  luanxu:"乱序入库",
  please_add_dailtime: "请添加拨打时段。",
  please_select_repeat: "请选择重复周期。",
  please_input_call_phone: "请输入测试拨打的号码。",
  please_select_import_file: "请选择要导入的Excel文件",
  only_import_geshi: "只能导入Excel文件，扩展名是xls、xlsx、txt",
  week1: "星期一",
  week2: "、星期二",
  week3: "、星期三",
  week4: "、星期四",
  week5: "、星期五",
  week6: "、星期六",
  week7: "、星期日",
  please_input_search: "请输入查询的号码",
  import_start_time: "导入开始日期",
  import_end_time: "导入结束日期",
  all_export: "全部导出",
  all_export_desc: "高危提示：如果任务正在拨打中，为了避免没有不必要数据同步问题，请先停止拨打后再导出。确定现在就要导出吗？",
  batch_delete: "批量删除",
  batch_delete_desc1: "高危提示：如果你当前正在导出数据，请确认数据导出完成后再进行删除。您确认删除这",
  batch_delete_desc2: "条数据吗？",
  batch_delete2_desc1: "高危提示：如果你当前正在导出数据，请确认数据导出完成后再进行清空。您确认清理这",
  clear_phone: "清空号码",
  phone_name: "客户名称",
  lianxi_fangshi: "联系方式",
  status_z: "状态",
  no_start: "未开始",
  wait_call: "待呼叫",
  import_time: "导入时间",
  source: "来源",
  sex: "性别",
  companyname: "所属公司",
  sort: "分类",
  address: "地址",
  contact_address_province: "省（通讯地址）",
  contact_address_city: "市（通讯地址）",
  contact_address_district: "区（通讯地址）",
  remark1: "备注1",
  remark2: "备注2",
  remark3: "备注3",
  remark4: "备注4",
  remark5: "备注5",
  success: "成功",
  error: "错误",
  please_gouxuan_delete: "请勾选需要删除的客户。",
  task_title: "新增任务",
  task_name_label: "*任务名称",
  task_name_label_desc: "请填写任务名称",
  bot_name_label: "*BOT名称",
  bot_name_label_desc: "请选择BOT名称",
  bot_count_label: "*BOT数量，总BOT：",
  bot_count_label_desc: "请填写BOT数量",
  start_date: "*开始日期",
  start_date_desc: "选择开始日期",
  dial_rangetime: "*拨打时段",
  no_dial_rangtime: "禁止拨打时段",
  continue_error_hangup_label: "连续失败挂起任务",
  continue_error_hangup_label_desc: "填写连续失败次数",
  please_input_taskname: "请输入任务名称。",
  taskname_two_char: "任务名字最少2个字。",
  please_select_bot: "请选择BOT话术。",
  bots_dayu: "BOT数量必须小于等于最大坐席数，当前坐席数：",
  please_select_startdate: "请选择开始日期。",
  please_select_dialrangetime: "请选择拨打时段。",
  please_input_content: "请输入内容",
  call_start_date: "呼叫开始日期",
  call_end_date: "呼叫结束日期",
  number: "号码",
  export: "导出",
  filter_condition: "筛选条件为：",
  number_z: "号码：",
  call_date_z: "呼叫日期：",
  to: "至",
  please_pass: "请输入密码",
  jieting_status: "接听状态",
  read_status: "查看状态",
  rgysx: "有效客户",
  unknow: "未知",
  filter_date: "过滤时间",
  export_filter: "导出过滤客户",
  nodata_export_filter: "没有数据可以被导出。",
  clear_number_title: "清空号码，不可恢复",
  clear_number_title_desc: "高危提示：如果你当前正在导出数据，请确认数据导出完成后再进行清除。清除后不可恢复，您确认继续吗？",
  tiao_data: " 条数据",
  grade: "等级",
  edittask: "编辑任务",
  change_sip: "切换到其他线路",
  please_select: "请选择",
  gateway: "网关",
  kou: "口 ",
  parent_fp: " - (上级分配)",
  auto_repeat_call: "未接通号码自动重拨",
  please_auto_repeat: "请选择自动重拨",
  repeat_count: "重拨次数",
  please_repeat_count: "请选择重拨次数",
  repeat_jiange: "重拨间隔，单位：分钟",
  please_repeat_jiange: "填写重拨间隔",
  set_auto_guize: "设置客户自动处理规则",
  push_location: "推送后存放位置",
  please_push_location: "请选择存放位置",
  please_select_push_account: "请选择要推送的账号",
  click_me_all: "点我全选",
  a_fenpei: "A类分配给",
  b_fenpei: "B类分配给",
  c_fenpei: "C类分配给",
  d_fenpei: "D类分配给",
  e_fenpei: "E类分配给",
  f_fenpei: "F类分配给",
  lunxun_push: "轮询推送",
  grade_push: "按等级轮询推送",
  grade_push_layout_hint: "每一档意向单独配置：左侧为分配的下级账号，右侧为触达客户的更多微信；各列表独立轮询。",
  seats_group_push_grade_conflict: "当前配置了「转人工坐席组」，且存在有效的客户推送配置。挂机后同一客户可能既归属实际接听的坐席账号，又按等级推送给其他下级账号，导致号码重复分配。推送来源包括：本任务已配置的推送等级，或任务未配置时账号「对接与推送」中已启用并配置的自动分配。请取消其中一项配置，或确认此为预期行为。",
  push_ai_customer_wz: "推送到AI工作台的呼出记录和客户中心的我的客户",
  only_push_ai: "仅推送到AI工作台的呼出记录",
  open: "开启",
  ci1: "1次",
  ci2: "2次",
  ci3: "3次",
  ci4: "4次",
  ci5: "5次",
  please_select_repeat_count: "请填写重拨次数。",
  please_repeat_jiange_minite: "请填写重拨间隔，单位：分钟。",
  import_customer_num: "导入客户数",
  import_customer_num_desc: "导入至该任务的所有客户数（以号码为维度，去重）",
  call_customer_num: "外呼客户数",
  total_call_customer_num: "总的外呼客户数",
  jietong_waihu_customer_num: "已接通数的外呼客户数",
  yijieting_th_time: "已接听的总的计费时长（不足一分钟的按一分钟计算）",
  hangup_2: "客户2轮挂机率",
  hangup_2_desc: "接听且通话轮次未达到两轮的客户数/接听客户总数",
  continues_error: "连续拨打失败",
  last_dail_error_count: "最近一次连续拨打失败的次数",
  a_grade_customer: "A类客户数",
  a_grade_customer_desc: "意向较强客户数，占比等于A类客户/接通客户总数",
  ge_zanbi: "个 占比：",
  b_grade_customer: "B类客户数",
  b_grade_customer_desc: "意向一般客户数，占比等于B类客户/接通客户总数",
  c_grade_customer: "C类客户数",
  c_grade_customer_desc: "可以尝试挽回的客户，占比等于C类客户/接通客户总数",
  xiaoyu10: "小于10秒",
  range10to59: "10秒-59秒",
  range60to99: "1分钟-1分59秒",
  dayu120: "大于等于2分钟",
  duihua_cyc: "说话次数",
  cc_talk_count: "对话轮次",
  ci0to2: "0-2次",
  ci3to4: "3-4次",
  ci5to6: "5-6次",
  ci7to9: "7-9次",
  ci10: "10次及以上",
  intention_proportion: "意向等级占比",
  exe_account: "执行者账号",
  exe_starttime: "执行开始日期",
  exe_endtime: "执行结束日期",
  exe_user: "执行者",
  exe_date: "执行时间",
  exe_content: "操作内容",
  last: "上一通",
  next: "下一通",
  th_id: "通话ID：",
  th_status: "通话状态：",
  intention_grade: "意向等级：",
  customer_source: "客户来源：",
  call_date: "呼叫时间：",
  over_date: "结束时间：",
  create_date: "创建时间：",
  hh_times: "会话时长",
  kh_grade: "客户意向等级",
  ai_focus: "AI识别的客户关注点",
  none: "无",
  sx_youxiao: "设置有效",
  sx_quxiao_youxiao: "取消有效",
  move_customer_centor: "移到客户中心",
  customer_info: "客户信息",
  please_ss_company: "请填写所属公司名称",
  remark: "备注",
  remark_desc: "请填写备注",
  history_record: "历史记录",
  no_more_data: "没有更多记录",
  no_data: "没有数据",
  tishi: "提示",
  not_more_data: "已经没有更多得数据了。",
  please_input_keyword: "请输入查询关键字",
  content: "内容",

  please_input_llm_keyword: "可输入多个，如：高,中",
  llm_content: "LLM",
  llm_grade_panel_tip: "从当前任务数据中选择等级（可多选），也可手动输入",
  llm_grade_panel_empty: "当前任务暂无LLM等级数据",
  llm_grade_loading: "加载中...",

  yx_dengji: "意向等级",
  yx_dengji_huilingy_status: "意向等级和号码回铃音状态",
  yy_label: "语义标签",
  semanteme_page_title: "语义标签",
  semanteme_label_desc:
    "语义标签是全局生效的关键字识别技巧，它应用到所有话术中。被识别到的意向客户可以通过语义标签快速查找到。 <br>比如：语义标签配置了关键字“微信”，当对话过程中说到“你微信多少”时（这个过程是双向识别，包括机器人自己说的），这条记录就会被记录到。然后可以在已拨打记录或客户CRM系统中通过语义标签快速查找。",
  semanteme_label_desc2: "备注：语义标签也要识别机器人的话术内容，所以在配置话术时务必把文字填写正确。",
  semanteme_new_label: "新增标签",
  semanteme_index_name: "索引名称",
  semanteme_keys: "关键字集合",
  semanteme_please_index_name: "请输入索引名称",
  semanteme_please_keys: "多个关键字 , 分割",
  semanteme_new_label_title: "新建语义标签",
  semanteme_modify_label_title: "修改语义标签",
  semanteme_indexname_notnull: "索引名称不能为空。",
  semanteme_keys_notnull: "关键字集合不能为空。",
  semanteme_sure_delete: "您确定要删除吗?",
  sys_notice_page_title: "系统公告管理",
  notice_gonggao: "公告标题",
  notice_content_col: "公告内容",
  notice_new_title: "新增公告",
  notice_modify_title: "修改公告",
  notice_please_gonggao: "请输入公告标题",
  notice_please_content: "请输入公告内容",
  notice_gonggao_notnull: "公告标题不能为空。",
  notice_content_notnull: "公告内容不能为空。",
  notice_add_btn: "添加",
  notice_del_title: "删除公告",
  notice_sure_delete: "您确定要删除吗?",
  mymain_notice_board: "系统公告",
  mymain_notice_empty: "暂无公告",
  start_date_z: "开始日期",
  end_date_z: "结束日期",
  mini_s: "最小值(s)",
  second_Hangup_Count_desc: "秒挂",
  max_s: "最大值(s)",
  mini_c: "最小值(次)",
  max_c: "最大值(次)",
  please_select_bot_v: "请选择话术",
  please_select_label: "请选择话术标签",
  please_select_more_wx: "请选择更多微信",
  no_weixin_push: "未推送微信",
  please_select_push_c: "请选择推送的下级",
  please_select_task: "请选择任务",
  unread: "未查看",
  readed2: "已查看",
  rg_filter: "人工筛选",
  orderby_time: "按拨打时间排序",
  cur_show_user: "当前查看的用户是：",
  export_date_file: "导出数据到文件",
  export_my_file: "导出我的数据到文件",
  export_child_file: "导出下级账号的数据到文件",
  batch_move_cutomer: "批量移到客户中心",
  batch_push_weixin: "批量推送微信",
  batch_push_weixin_count: " 条",
  batch_push_weixin_desc: "筛选结果按策略推送到所选微信。",
  batch_push_wx_select: "接收微信",
  batch_push_wx_placeholder: "请选择接收微信",
  batch_push_wx_required: "请至少选择一个接收微信",
  batch_push_wx_strategy: "推送策略",
  batch_push_strategy_round: "轮流推",
  batch_push_strategy_round_desc: "如10条选3人：第1条→A，第2条→B，第3条→C，第4条→A…",
  batch_push_strategy_average: "平均推",
  batch_push_strategy_average_desc: "如10条选3人：前4条→A，中间3条→B，后3条→C",
  batch_push_strategy_all: "全部推",
  batch_push_strategy_all_desc: "每条记录推送给所有已选微信",
  batch_allocation_child: "批量分配给我的下级",
  repeat_call: "重复拨打",
  ygouxuan_data: "已勾选的客户数据为：",
  no_allocation_data: "没有可分配的客户数据",
  label: "话术标签",
  calin_out: "呼入呼出",
  all: "全部",
  more_wx: "更多微信",
  no_red_data: "未读数据",
  rg_filtered: "已筛选数据",
  task_name: "任务名称",
  clear_phone_title: "清空号码",
  export_alert: "高危提示：如果你当前正在导出数据，请确认数据导出完成后再进行清理。",
  clear_status: "清空接听状态为：",
  please_delete: "请输入“delete”",
  wx: "微信",
  push_show: "推送给",
  task: "任务",
  grade_sip: "等级/线路状态",
  llm_grade: "LLM等级",
  focus: "关注点",
  defen: "得分",
  details: "查看",
  move_customer_desc: "移动后请到【客户中心】- 【我的客户】查看",
  batch_export: "批量导出",
  sure_filter_contition: "您确定要对以上筛选条件下的号码进行重复拨打吗?",
  please_customer_data: "请选择客户数据。",
  please_export_child_account: "请选择导出到的下级账号。",
  please_input_pass: "请输入密码。",
  please_wcz_delete: "请输入防误操作指令“delete”",
  cur_page_end: "当前页已经没有更多得数据了，请翻页。",
  delete_customer: "删除客户",
  delete_customer_desc: "您确认要删除这条已接通，且意向等级为：",
  delete_customer_desc_2: " 的客户吗？",
  export_my: "导出我的 ",
  export_my2: " 条数据到文件",
  export_my3: "您确定要对以上筛选条件下的号码进行导出吗?",
  batch_move: "批量移动 ",
  batch_move2: " 条到我的客户中心",
  batch_move3: "您确定要对以上筛选条件下的号码进行批量移动到我的客户中心吗?",
  export_child_1: "导出下级账号的数据到我的文件",
  export_child_2: "您确定要对以上筛选条件下的号码进行导出吗?",
  export_child_3: "以下账号的数据将会被导出到您的导出列表里：",
  repeat_call_desc: "重复拨打 ",
  repeat_call_desc2: " 条数据",
  repeat_call_desc3: "您确定要对以上筛选条件下的号码进行重复拨打吗?",
  batch_allocation_child_desc: "将客户数据分配给以下账号：",
  batch_move_1: "高危提示：如果你当前正在导出数据，请确认数据导出完成后再进行移动。您确认移动这",
  please_gx_movedata: "请勾选需要移动的客户数据。",
  new_create_task: "新建任务",
  refresh_new_task: "刷新任务数据",
  search_task: "搜索任务",
  search_range_task: "按范围搜索",
  search_child_account: "搜索下级账号",
  search_status: "按状态搜索",
  parse_all_task: "暂停全部任务",
  start_all_task: "开始全部任务",
  gong: "共",
  tiao_task: "条任务",
  user_parse: "用户暂停",
  no_dail_date: "不在拨打时段",
  queueing: "排队中",
  finallyed: "已完成",
  system_parse: "系统暂停",
  system_hangup: "系统挂起",
  arrearage_parse: "欠费暂停",
  today_parse: "今日暂停",
  overed: "已终止",
  edit: "编辑",
  copy: "复制",
  paste: "粘贴",
  create_yu: "创建于",
  no_task: "没有任务",
  delete_task: "删除任务 ",
  delete_task_danger: "高危提示：任务删除后，任务下所有 “未呼客户” 的数据将一并清理不可恢复，请慎重操作。",
  delete_task_danger_desc: "如果你当前正在导出数据，请确认数据导出完成后再进行删除。",
  sync_delete_customer: "同步删除所有 “已呼客户” 的未接通的数据",
  start_task: "开始任务",
  stop_task: "停止任务",
  refresh_data_desc: "数据显示不及时，手动刷新进行统计",
  repeat_dial_desc_1: "已开启未接通号码重复拨打，间隔",
  repeat_dial_desc_2: "分钟，共重复",
  bot_count: "BOT数量：",
  sips_desc: "线路描述：",
  start_datetime: "启动日期：",
  maohao: "：",
  continues_fails: "连续失败：",
  continues_fails_desc: "次后停止拨打",
  fault_desc_label: "最近一次的故障描述：",
  run_gaikuang: "运行概况",
  no_data2: "暂无数据",
  only_kan_self: "仅查看自己",
  kan_child: "查看所有下级",
  fang_wucao: "防误操作指令“delete”输入错误",
  delete_task_desc2: "高危提示：如果你当前正在导出数据，请确认数据导出完成后再进行删除。确定要删除任务：",
  delete_task_desc3: " 吗？任务删除后数据一并清除，且不可恢复。",
  yixia_task_parse: "以下任务将被暂停",
  yixia_task_parse2: "且只对状态为：“排队中”“进行中”“系统暂停”的任务进行暂停",
  yixia_task_parse3: "状态为“排队中”“进行中”“系统暂停”的任务可以暂停，请知悉！",
  yixia_task_start: "以下任务将被开始",
  yixia_task_start2: "且只对状态为：“未开始”“用户暂停”“系统暂停”“系统挂起”的任务可以开始",
  yixia_task_start3: "状态为“未开始”“用户暂停”“系统挂起”的任务可以开始，请知悉！",
  add_jiedai: "添加接待场景",
  tiao_cj: "条场景",
  default_jiedai: "默认接待场景",
  today_jiedai: "今日接待",
  history_jiedai: "历史接待",
  no_jiedai: "没有接待场景",
  scene_name: "*场景名称",
  scene_name_desc: "请填写场景名称",
  scene_sip: "接待线路",
  scene_sip_desc: "请选择接待线路",
  jiedai_botname: "接待BOT名称:",
  jiedai_sip_name: "接待线路名称:",
  scene_jiedai: "接待场景",
  jiedai_time: "接待时间",
  qiyong: "启用",
  please_input_scene_name: "请输入场景名称。",
  please_input_scene_name2: "场景名称最少2个字。",
  new_scene_name: "新增场景",
  edit_scene_name: "编辑场景：",
  delete_scene: "删除场景",
  delete_scene1: "确定要删除场景：",
  delete_scene2: " 吗？删除后不可恢复。",
  ai_callout: "AI呼出",
  cur_data: "当前数据",
  seats_count: "坐席总数",
  xi: "席",
  seats_online: "坐席在线",
  tonghuaing: "正在通话中",
  busying: "繁忙度",
  jietinglv: "接听率",
  yx_jietinglv: "有效接听率",
  diushilv: "缺失率",
  seats_records: "坐席拨打记录",
  seats_statistic: "AI转坐席统计",
  mass_seats_statistic: "人工群呼转坐席统计",
  turn_regong: "转接人工无法获取到空闲坐席的机率，越高接听效率越低。",
  seats_config: "坐席配置",
  seats_config_desc: "坐席中心：1、系统内所有分机坐席之间可以互相拨打电话。2、机器人呼出意向客户转到分机坐席无需占用多余线路。",
  seats: "坐席",
  seats_group: "班组",
  jiedai_gateway: "接待网关",
  customer_number: "客服号码",
  customer_name: "客服名称",
  dial_status: "拨打状态",
  turn_rg_success: "成功转人工",
  turn_rg_success_effective: "有效转人工",
  type_e: "类型",
  turn_rg: "转人工",
  group_boda: "组内拨打",
  dial_time: "拨打时间",
  hangup_time: "挂机时间",
  turn_rg_time: "转人工时间",
  newdata: "新增",
  batch_modify_ip_port: "批量修改",
  batch_modify_ip_port_title: "批量修改IP和端口",
  batch_modify_ip_port_tip: "将把当前账号下，IP和端口与旧值完全一致的对接/注册线路，批量替换为新的IP和端口，并同步更新数据库和SIP配置文件。网关模式线路不参与替换。",
  old_server_ip: "*旧IP",
  old_server_port: "*旧端口",
  new_server_ip: "*新IP",
  new_server_port: "*新端口",
  please_old_server_ip: "请输入旧IP。",
  please_old_server_port: "请输入旧端口。",
  please_new_server_ip: "请输入新IP。",
  please_new_server_port: "请输入新端口。",
  please_new_ip_port_diff: "新IP和端口不能与旧值完全相同。",
  please_valid_port: "请输入有效的端口号（1-65535）。",
  xin_name:"*名称",
  xin_name_desc:"请填写名称",
  xin_renz: "*认证名",
  xin_renz_desc: "请输入认证名",
  xin_pass: "*认证密码",
  xin_pass_desc: "请输入认证密码",
  sip_number: "线路数量",
  sip_number_desc: "请输入线路数量",
  prefix: "前缀",
  prefix_desc: "请输入前缀",
  default_turn_sip: "默认为转人工线路",
  name_bs: "名称标识",
  renz: "认证名",
  renz_pass: "认证密码",
  yuyin_gateway: "语音网关",
  third_sip: "第三方SIP",
  online_status: "在线状态",
  work_status: "工作状态",
  unqiyong: "未启用",
  create_time: "创建时间",
  modify: "修改",
  remove: "移除",
  please_input_name: "请输入名称。",
  please_name_2char: "名称必须最少2个字符。",
  please_input_renz: "请输入认证名。",
  please_input_renz_6char: "认证名必须最少6个字符。",
  please_input_renz_pass: "请输入认证密码。",
  please_input_renz_pass_6char: "认证密码必须最少6个字符。",
  new_sip: "新增线路",
  delete_gateway: "删除网关",
  delete_gateway_desc: "确定要删除：",
  ma: " 吗？",
  modify_sip: "修改线路",
  unopen: "未开启",
  new_seats_group: "新增班组",
  xin_seats_group_name: "*班组名称",
  xin_seats_group_name_desc: "请填写班组名称",
  seats_group_desc: "班组描述",
  seats_group_desc2: "请输入班组描述",
  mingcheng: "名称",
  select: "选择",
  add_seats: "添加坐席",
  select_seats: "选择坐席",
  sip_reg_account_pass: "SIP注册账号/密码",
  uninvolved: "不涉及",
  yg_fenji: "员工分机",
  mobile_seats: "移动坐席",
  net_seats: "分机电话坐席",
  calling: "正在通话中...",
  idle: "空闲",
  please_left_select: "请在左侧选择班组",
  please_input_seats_group_name: "请输入班组名称。",
  please_seats_group_name_2char: "班组名称必须最少2个字符。",
  delete_seats_group: "删除班组",
  modify_seats_group: "修改班组",
  new_seats: "新增坐席",
  net_seats_phone: "分机电话号码",
  mobile_seats_phone: "移动电话号码",
  seats_type: "坐席类型",
  yuangong_or_new: "员工或新增分机",
  please_select_yg: "请选择员工",
  xin_customer_name: "*客服名称",
  xin_customer_name_desc: "请填写客服名称",
  xin_customer_phone: "*客服号码",
  xin_customer_phone_desc: "请输入客服号码",
  please_select_yg_ju: "请选择员工。",
  please_input_customer_name: "请输入客服名称。",
  please_input_customer_phone: "请输入客服号码。",
  please_input_customer_phone_2char: "客服号码必须最少2个数字。",
  delete_seats: "删除坐席",
  modify_seats: "修改坐席",
  seats_type_1: "客服-分机（网络电话）",
  seats_type_2: "客服-手机号码（移动、联通、电信）",
  seats_type_1_short: "客服-分机",
  seats_type_2_short: "客服-手机",
  seats_type_1_desc: "网络电话 SIP 分机坐席，推荐使用",
  seats_type_2_desc: "绑定移动 / 联通 / 电信手机号",
  seats_type_recommend: "推荐",
  yg: "员工",
  new_fj: "新增分机",
  yg_desc: "绑定已有员工账号",
  new_fj_desc: "手动填写客服名称与分机号码",
  yg_recommend: "优选",
  account: "账号",
  time: "时间",
  thl: "通话量",
  jtl: "接通量",
  jtlv: "接通率",
  yxjtl: "有效接通量",
  yxjtlv: "有效接通率",
  today: "今天",
  yx_th_time: "有效通话时长",
  yx_th_pjtime: "有效通话平均时长",
  new_bot: "新建话术",
  upload_bot: "上传话术",
  please_enter_botname: "请输入要搜索的话术名称",
  please_use_hy: "请选择行业",
  please_use_zhy: "请选择行业子类型",
  reload: "重载",
  public_z: "发布",
  copy_top_me:"复制到我的话术",
  audit:"审核中",
  go_online: "已上线",
  recording: "录制音",
  synthetic_voice: "常用音",
  recording_synthetic_voice: "录制音+变量音",
  audit_no_pass: "审核未通过",
  audit_pending_words: "待审核话术",
  audit_pending_records: "待审核录音或文字",
  audit_words_name: "话术名称",
  audit_modify_time: "修改时间",
  audit_submitter: "提交人",
  audit_type_col: "类型",
  audit_content_audio: "内容/录音",
  audit_segment_title: "第 {n} 条",
  audit_pair_text: "文案",
  audit_pair_audio: "录音",
  audit_translate_result: "翻译结果",
  audit_flow_node: "流程节点",
  audit_know_entry: "知识条目",
  audit_words_llm: "话术大模型",
  audit_llm_readonly_hint: "请在左侧话术列表中通过或驳回整单",
  audit_translate: "翻译",
  audit_pass: "通过",
  audit_reject: "驳回",
  audit_filter_all: "全部",
  audit_filter_submitter_ph: "输入提交人筛选",
  audit_filter_wordsname_ph: "输入话术名称筛选",
  audit_placeholder_title: "尚未选择话术",
  audit_placeholder_hint: "请先在左侧点击一条话术，查看录音与文字",
  audit_only_my_submissions: "仅看我提交的",
  audit_mode_need_me: "待我审核",
  audit_mode_my_submit: "我提交给上级审核",
  enabled: "已启用",
  unenabled: "未启用",
  botid: "话术ID：",
  task_list_id: "任务ID：",
  hyid: "行业：",
  updatetime: "更新时间：",
  nobot: "没有话术",
  down_bot: "下载话术 ",
  downing_bot: "正在下载话术: ",
  please_down_pass: "，请输入正确的下载密码",
  please_down_pass_1: "请输入下载密码",
  mainflow: "主流程",
  knows: "知识库",
  multtalk: "多轮会话",
  hotword: "热词",
  question_learn: "问题学习",
  yxlabel: "意向标签",
  train: "训练",
  record: "录音",
  sync: "同步",
  tiandun: "天盾拦截",
  botset: "Bot设置",
  llmset: "LLM设置",
  big_model_tab: "大模型设置",
  llm_menu_chat: "对话大模型",
  llm_menu_assistant: "结果分析助手",
  llm_menu_hangup: "挂机关键字",
  llm_menu_prompt_lib_admin: "提示词库管理",
  llm_menu_guide: "样例与参考说明",
  llm_page_subtitle: "请按左侧分类逐项配置，完成后点击保存。",
  llm_guide_intro: "以下为参考样例与写法说明；正式生效的配置请在左侧前三项中填写并保存。",
  no_select_bot: "没有选中话术",
  xin_bot_name: "*话术名称",
  xin_bot_name_desc: "请填写话术名称",
  ss_hy: "所属行业",
  ss_hy_type: "所属行业子类型",
  ss_hy_type_desc: "请选择行业子类型",
  upload_bot_file: "上传话术文件",
  bot_desc: "话术描述",
  please_bot_desc: "请填写话术描述",
  please_bot_name: "请输入话术的名称。",
  please_hy: "请选择所属行业。",
  please_hy_type: "请选择所属行业子类型。",
  please_import_file: "请选择要导入的文件。",
  edit_bot: "编辑话术",
  delete_bot: "删除话术",
  delete_bot1: "确定要删除话术“",
  delete_bot2: "”吗？删除后不可恢复。",
  public_bot: "发布话术",
  public_bot1: "确定要将 “",
  public_bot2: "” 发布到话术市场吗？",
  bot_wait: "Bot等待时长",
  bot_wait_desc: "说明：当通话对方没有任何声音时，机器人最大的等待时长，超过此时间值时，Bot会进入知识库“用户不回答处理”的流程。",
  max_duration: "外呼最大通话时长",
  minute: "分钟",
  max_duration_desc: "说明：每通电话的最大通话时长，超过此数值时Rot自动挂机。转人工后，不受管控。",
  noise_handle: "噪音降噪处理",
  ji: "级",
  noise_handle_desc: "说明：周围环境有噪音时，对环境噪音进行降噪。但也存在对正常声音误处理的情况。",
  noise_gv_handle: "噪音过滤处理",
  bridge_turn_human_waittime: "转人工超时等待时长，单位：秒",
  bridge_turn_human_waittime_desc: "说明：设置 0 秒为永久等待，5秒为一个周期检测请配置5的倍速时长",
  noise_gv_handle_desc: "说明：噪音识别引擎判定后会返回一个噪比值（噪比值越小越接近人声），噪比值 >=",
  noise_gv_handle_desc2: "的声音被判定为噪音。",
  noise_key: "噪音忽略处理关键词，多个词之间“,”分隔",
  noise_key2: "多个关键词用逗号分隔",
  noise_key_desc: "说明：人声音不太清晰时会被误判为噪音，这个时候可以通过ASR出的文字与关键词匹配后让系统判定为正常人声。",
  bot_speed: "Bot反应速度",
  key_pipei: "关键字匹配模式",
  bot_asr: "机器人说第几句开启ASR识别",
  china_mode: "中文模式",
  english_mode: "英文模式",
  di1: "第一句",
  di2: "第二句",
  di3: "第三句",
  di4: "第四句",
  di5: "第五句",
  di6: "第六句",
  di7: "第七句",
  di8: "第八句",
  never: "永不",
  tiandun_title: "天盾在通话过程中识别用户回复关键词并触发拦截。系统天盾提供「系统默认」「语音信箱/秘书」「明确拒绝/勿扰」三类词库，可按需勾选启用；下方还可维护本账号专属关键词。以上配置对本账号下全部话术同步生效。",
  illustrate: "说明",
  system_lanjie: "系统默认拦截关键词（全系统所有账号的所有话术生效）",
  please_key: "请输入关键词",
  copy_all: "复制全部",
  save_sx: "保存并立即生效",
  use_sys_key: "使用系统拦截关键词",
  use_sys_key2: "拦截关键词（当前账号的所有话术生效）",
  copy_success: "复制成功",
  copy_failure: "复制失败",
  node_name: "节点名称",
  label_name: "标签名称",
  node_bot: "节点话术",
  node_desc: "'如果是接通后说的第一句话，系统建议使用一段长句。比如 “喂，你好（停顿2~3秒），我们这里是做XXX业务的...”'",
  node_desc1: "请填写节点话术文字描述。",
  upload_record_sm: "上传录音仅支持WAV格式的音频文件【单声道、8000Hz采样率】",
  click_me: "点我听当前话术的录音",
  upload_record: "上传录音",
  online_record: "在线录制语音，需要开启麦克风权限。",
  push_address: "采集推送地址（按#号键后推送；人声说话停顿推送）",
  please_enter_http: "请输入以HTTP/HTTPS开头的地址",
  please_enter_param: "请填写参数名",
  please_select_bl: "请选择变量",
  add_param: "增加参数",
  please_example: "请填写Json参数，示例：{'name':'{姓名}','age':'{手机号}'}",
  search_result: "查询结果（多个结果等于多个分支）",
  please_enter_back: "请填写返回值",
  add_result: "增加结果",
  push_message_handle: "推送后的处理",
  push_message_handle1: "等待消息返回过程中，给用户播放的等待音",
  yibu_desc: "异步等待：系统给业务端发出http请求后业务响应后再通过异步接口（见接口文档2-3-25）返回业务数据；同步等待：系统给业务端发出http请求后业务端立刻返回业务数据。",
  other_set: "其他设置",
  allow_break: "允许打断",
  allow_break_desc: ">=1个字打断：客户一说话机器人就停止说话。智能打断：客户说话大于2个字机器人暂停说话，如果客户没有说了机器人会接着把剩下的话说完。关键字打断：客户说话的内容名中了关键字时，机器人停止说当前句子，然后继续说被名中的语句。",
  allow_break_desc1: "智能打断容易出现噪音的误判为客户说话，但能适配大部分场景，适合话术简单配置通话场景简单的客户。关键字打断是客户说话的内容包含关键字的情况下，机器人停止说话，对话术关键字配置要求较高。",
  set_customer_grade: "设置客户等级",
  send_sms: "发送短信",
  queren: "确认",
  score_name: "*分支名称",
  score_name_desc: "请填写分支名称",
  score_proper: "*分支属性",
  xin_key: "*关键词",
  xin_key_desc: "请输入关键词后回车，多个 , 分割",
  no_pz_key: "【未配置关键词】",
  pp_score_key: "匹配到该分支的关键词",
  yx_use_key: "(优先推荐使用关键词)",
  yx_use_key1: "优先级配置如：“包裹~9” 数字越大越优先",
  copy_all_key: "复制全部关键词",
  delete_all_key: "删除全部关键词",
  answer: "问法",
  answer_desc: "匹配到该分支的客户问法，多个问法请回车间隔",
  score: "得分（一般用于考试场景）",
  score_desc: "当用户回答命中，会自动计入此得分",
  modify_label: "修改标签",
  xin_label_name: "*标签名称",
  xin_label_name_desc: "请填写标签名称",
  normal_node: "普通节点",
  keyword: "${按键}",
  asr_char: "${识别文字}",
  breakl: ">=1个字打断",
  break2: "关键字打断",
  break3: "智能打断",
  new_score: "新建分支",
  asyn_message: "异步等待消息返回",
  sync_message: "同步等待消息返回",
  please_enter_score_name: "请输入分支的名称。",
  please_select_score_proper: "请选择分支属性。",
  please_enter_key: "请录入关键词。",
  please_enter_label_name: "请输入标签的名称。",
  please_node_name: "请输入节点的名称。",
  please_node_bot: "请配置节点的话术。",
  repeat_cishu: "重复次数必须大于等于1小于等于5。",
  please_enter_address: "请输入调用地址。",
  please_dy_adress_http: "调用地址不正确，请输入正确的http/https开头的地址",
  please_enter_params: "请填写 Param 参数。",
  please_enter_header_prarams: "请填写 Header 参数。",
  word_node: "文字节点",
  ivr_node: "IVR节点",
  ivr_node_desc: "IVR节点：接通后可以通过按键进行流程分发",
  gather_node : "采集节点",
  jump_node: "跳转节点",
  jump_node_desc: "跳转节点：可以指定跳转到任意其它流程或者挂机/转人工",
  delete_score: "删除分支",
  delete_score1: "确定要删除分支“",
  delete_score2: "”吗？删除后不可恢复。",
  modify_score: "修改分支",
  key_bixu: "关键字括号内的优先级必须是数字",
  warn: "警告",
  please_hot_word: "请填写热词。",
  show_hot_edit: "查看热词编辑规则",
  show_hot_edit_desc: "1.支持批量添加，热词间以逗号分隔 2.仅支持中文，不支持特殊符号 3.单个热词最多10个字符",
  cur_hot_word: "当前热词",
  edit_hot_word: "编辑热词",
  edit_jump_node: "编辑跳转节点",
  xin_jump_to: "*跳转到",
  please_jump_celv: "请选择跳转策略",
  stream: "流程",
  please_select_stream: "请选择要跳转的流程",
  please_conf_node_name_desc: "请配置节点的话术描述。",
  new_question: "新增问题",
  tianjia: "*添加到",
  exist_problem: "已有问题",
  new_problem: "新增问题",
  select_exist_problem: "*选择已有问题",
  xin_title: "*标题",
  please_enter_title: "请输入标题。",
  please_select_type: "请选择类型",
  zz_click_learn: "这配置正则表达式关键字，效果更优【点我学习】",
  zz_click_learn1: "正则表达式关键字，效果更优【点我学习】",
  edit_know_node: "编辑知识节点",
  basedata: "基础信息",
  answer_type: "回答方式",
  single_answer: "单句回答",
  enter_mult_talk: "进入多轮会话",
  jump_to: "跳转到",
  hulv_wusheng: "忽略无声",
  hulv_wusheng_desc: "忽略无声: 启用后，此句回答播放完成，如果用户没有说话时不会触发无声判定，直接按“未识别”走下一步流程。",
  follow_play: "跟随主流程一起播放",
  follow_play_desc: "跟随主流程一起播放: 启用后此句语音会跟随主流程一起播放，先播放此句再播放主流程的语音。",
  mult_stream: "多轮流程",
  please_jump_stream: "请选择要跳转的多轮流程",
  answer_voise: "回答语音",
  answer_voise_desc: "跳转到多轮会话的知识问题，不用配置回答录音。系统会直接跳转过去使用多轮节点上配置的回答录音进行播放。",
  add_duotiao: "添加多条回答语音，系统会进行轮流使用",
  no_answer: "没有回答语音",
  train_optimize_record_sidebar_hint: "请先在左侧「选择已有问题」中选中一项。",
  answer_audio_desc: "回答录音文字描述",
  please_enter_audio_desc: "请填写回答录音文字描述",
  upload_audio: "上传录音文件",
  tj_modify: "提交修改",
  delete: "删除",
  train_optimize_log_view: "查看",
  please_select_jump_stream: "请选中跳转流程。",
  please_select_jump_mult_stream: "请选中跳转的多轮流程。",
  please_answer_audio: "请填写回答录音文字描述。",
  delete_answer_audio: "删除此条回答记录",
  delete_answer_audio1: "确定要删除此条回答记录“",
  please_search_key: "请输入查询的关键字",
  record_search_title_content: "按标题或内容搜索",
  record_batch_selected: "已选 {n} 条",
  record_batch_synthesis: "批量合成音",
  record_batch_synthesis_empty: "请先勾选要合成的记录",
  record_batch_synthesis_done: "已成功合成 {n} 条",
  record_batch_synthesis_partial: "成功 {ok} 条，失败 {fail} 条",
  wait_record: "待录音",
  set_record: "设置了录音",
  set_grade: "设置客户等级",
  new_create_problem: "新建问题",
  questions: "当前知识库共包含",
  questions2: "个问题",
  gaoyou: "高优：",
  gaoyou_celv: "关键字优先级 > 知识节点高优",
  bz_question: "标准问题",
  you_record: "已有录音",
  yw_question: "业务问题",
  ask: "问法",
  key: "关键词",
  update_time: "更新时间",
  more: "更多",
  set_gy: "设为高优",
  cancel_gy: "取消高优",
  wait: "等",
  ge_ask: "个问法。",
  delete_question: "删除问题",
  delete_question_desc: "确定要删除“",
  tuodong: "拖动调整顺序",
  set_break: "设置了打断",
  save_bj: "保存布局",
  stream_name: "*流程名称",
  stream_name_desc: "请填写流程名称",
  new_stream: "新增流程",
  please_enter_stream_name: "请输入流程的名称。",
  no_record: "无录音",
  enable_break: "已开启打断",
  enable_grade: "已设置客户等级",
  label_mao: "标签：",
  audio_node: "语音节点",
  audio_tooltip: "语音节点：需要提前录制好语音",
  double_click: "双击录入内容",
  gather_node_desc: "采集节点：可采集按键和客户说话内容",
  word_node_desc: "文字节点：配置文字后通过TTS技术转换成录音",
  next_select: "下一步：待选择",
  modify_stream: "修改流程",
  delete_stream: "删除流程",
  delete_stream2: "确定要删除流程“",
  delete_node: "删除节点",
  delete_node2: "”节点吗？删除后不可恢复。",
  answer_score: "回答分支",
  node_all_desc: "节点上仅会出现“全部”的分支，所有识别结果都走此分支",
  default_check_key: "默认检测关键词，命中知识库会直接使用",
  default_no_check_key: "不检测关键词，任何回答或无声直接跳入一下个节点",
  self_define_score: "自定义回答分支",
  no_asr: "未识别",
  no_asr_desc: "本节点优先：当用户说话无法识别时走本节点的‘未识别’流程；知识库优先：当用户说话无法识别时，走知识库的‘无法应答处理’的流程。",
  ben_node_yx: "本节点优先",
  konw_yx: "知识库优先",
  repeat: "重复此句",
  repeat_desc: "重复此句（一般用于考试场景）：当用户说话无法识别时，让机器重复再说一遍此句。",
  please_repeat_num: "请输入重复次数",
  bot_speed_desc: "设置当前节点机器人的反映速度，仅在当前节点生效。注意：开场第一句话将不会生效",
  break11: ">=1个字打断（客户说话机器人停止说话）",
  break12: "知识库关键字打断（仅判定知识库关键字）",
  break13: "所有关键字打断（知识库和节点关键字打断）",
  break14: "智能打断（客户说话机器人会暂停说话）",
  please_config_node_bot: "请配置节点的话术。",
  wait_learn: "待问题学习",
  show_dial_record: "查看通话记录",
  record_time: "记录时间",
  learn_status: "学习状态",
  no_learn: "未学习",
  learned: "已学习",
  learn: "学习",
  no_search_record: "没有找到记录",
  wait_learn_sentence: "删除待学习句子",
  wait_learn_sentence1: "确定要删除待学习句子“",
  bot_record: "话术录音",
  repeat_record: "重新录音",
  stop_record: "停止录音",
  play_record: "播放录音",
  down_record: "下载录音",
  is_https: "开启在线录音，需要通过域名进行安全访问。如：",
  is_https1: "https://您的域名",
  record_progress: "录音进度",
  sy: "剩余",
  ju: "句",
  wait_record_bot: "待录音话术",
  recorded: "已录音",
  clear_all_record: "清除全部录音",
  stream_node: "流程节点",
  konw_node: "知识节点",
  bot_content: "话术内容",
  know_title: "知识点标题",
  clear_all_record1: "确定要清除全部录音吗？清除后不可恢复。",
  di1z: "第一招：",
  di1z1: " 模糊匹配所有字",
  di1z2: "正则关键词：“",
  di1z3: "厘.*多少",
  di1z4: "”",
  di1z5: "客户说：“你们贷款3厘能贷多少？”  此句中出现了：“",
  di1z6: "厘",
  di1z7: "” “",
  di1z8: "多少",
  di1z9: "” 所以此句会被命中",
  di1z10: "其中 ",
  di1z11: ".*",
  di1z12: " 的配置不能少，表示“",
  di1z13: "”和“",
  di1z14: "”中间出现任何句子都会被命中。",
  di2z: "第二招：",
  di2z1: "(太|真|很)",
  di2z2: " 关键字或相关",
  di2z3: " 正则关键词：“",
  di2z4: " (太|真|很).*(复杂|麻烦)",
  di2z5: " 客户说：“你们贷款太多麻烦了？”  此句中出现了：“",
  di2z6: " 太",
  di2z7: " 麻烦",
  di2z8: " ” 所以此句会被命中",
  di2z9: " 客户说：“你们贷款真的太复杂了？”  此句中出现了：“",
  di2z10: "真",
  di2z11: "复杂",
  di2z12: "客户说：“你们贷款很多流程，好复杂？”  此句中出现了：“",
  di2z13: "很",
  di2z14: " 表示出现“太”或“真”或“很”会被命中",
  di2z15: " 表示出现 “复杂”或“麻烦”会被命中",
  di2z16: "同时出现以上两组词的任意组合，此关键词会被命中。",
  di2z17: "其它更高级的正则匹配关系请到百度输入“正则表达式”进行学习",
  di2z18: "(复杂|麻烦)",
  tuodong2: "可拖动调整判断顺序。",
  manzu: "当以下所有规则均不满足时，将客户设置为",
  add_gz: "添加规则",
  default_gz: "恢复系统默认规则",
  tsmanzu: "同时满足下列条件",
  please_selectc: "请选择条件",
  duogefenge: "多个“,”分割",
  add_tj: "添加条件",
  yx_set: "将意向等级标签设置为",
  hf_default: "恢复默认规则",
  pdxx: "判断顺序",
  gzzz: "未显示详情的情况下，系统默认使用：默认规则二（宽松）",
  rule: "规则",
  yxbq: "客户意向标签",
  ppcs: "匹配次数",
  affirm: "肯定",
  deny: "否定",
  refuse: "拒绝",
  no_conf_condition: "没有配置条件。",
  please_select_condition: "请选择条件。",
  please_enter_fenge: "请输入内容关键字，多个“,”分割。",
  please_select_yx_grade: "请选择将意向等级标签。",
  delete_rule: "删除规则",
  sync_bot: "话术复制是将当前话术完整的拷贝一份给选中的下级账户，拷贝成功后下级账户会自动启用并使用（包括拨打任务）。当下级账户已有此话术时需要再次进行复制的，要将此话术进行一次“删除”操作，如果没有提前删除，系统会自动过滤不进行复制操作。",
  explain: "说明",
  batch_sync: "批量同步",
  all_select: "全部选中",
  ge_account: "个账号",
  sync_bots: "同步话术",
  sync_gei: "即将要同步给",
  sync_sure: "请确定要立刻进行话术同步吗？",
  task_sync: "【任务】同步后，仅更新给使用了此话术的任务",
  task_sync1: "【单任务】同步后，立刻启用为单任务外呼话术",
  task_sync2: "【下面的选项谨慎使用】",
  task_sync3: "【任务】同步后，所有多任务都立刻切换为此话术",
  child_access_mode_title: "下级话术访问权限",
  child_access_mode_0: "完全可修改可查看",
  child_access_mode_1: "仅查看不能修改",
  child_access_mode_2: "不可查看",
  child_access_mode_col: "访问权限",
  child_access_mode_0_short: "可改可查",
  child_access_mode_1_short: "仅查看",
  child_access_mode_2_short: "不可查看",
  child_view_password: "解锁密码",
  child_view_password_placeholder: "可选，6位字符",
  child_view_password_tip: "设置后，下级打开话术前需先输入此密码。可不填。",
  child_view_password_unlock_title: "请输入解锁密码",
  child_view_password_unlock_tip: "该话术由上级设置了查看密码，输入正确的6位密码后才能查看。",
  child_view_password_unlock_placeholder: "请输入6位数字密码",
  child_view_password_error: "密码错误，请重新输入",
  child_view_password_format: "请输入6位字母或数字，或不填",
  child_view_password_set: "已设密码",
  word_detail_forbidden_title: "话术不可查看",
  word_detail_forbidden_tip: "该话术由上级同步且限制为不可查看详情，列表中可见，但无法打开详情内容。",
  word_view_only_tip: "该话术由上级同步为仅查看，可浏览详情但不能修改。",
  child_account_name: "下级账号名称",
  level: "级别",
  sj:"商家",
  user: "普通用户",
  account_remark: "账号备注",
  sync_time: "同步时间",
  xin: "新",
  old: "旧",
  issync: "是否同步",
  nosync: "未同步",
  synced: "已同步",
  copyed: "已复制",
  uncopy: "未复制",
  batch_copy_bot: "批量复制话术",
  batch_copy_bot_desc: "确定要进行话术复制吗？复制后，下级账号的当前拨打自动启用此话术。",
  please_gx_child_account: "请勾选下级账户。",
  batch_delete_bot: "批量删除话术",
  batch_delete_bot_desc: "确定要删除下级账户的话术吗？删除后，会造成当前正在拨打的状态无话术可用。",
  copy_bot: "复制话术",
  copy_bot1: "确定对“",
  copy_bot2: "”进行话术复制吗？复制后，他的当前拨打自动启用此话术。",
  delete_bot_account1: "确定删除“",
  delete_bot_account2: "”账户的话术吗？删除后，会造成当前正在拨打的状态无话术可用。",
  wei: "位",
  click_train: "点击右上方的按钮开始训练话术",
  customer_yx_label: "客户意向标签为：",
  please_enter_message: "请输入消息，回车发送",
  bdmb: "打开拨打面板（网络电话），呼叫 9999 号码，即可测试话术。注意必须是接待话术选择此话术。",
  voise_train: "语音训练",
  text_train: "文本训练",
  train_param_title: "训练参数",
  train_llm_analysis: "大模型评析",
  train_llm_analysis_need_assistant:
    "请先在「大模型设置 → 结果分析助手」中勾选「激活助手分析能力」，训练承接分析才会调用模型（与通话结束后的结果分析共用该开关）。",
  train_carry_analysis_rule:
    "对话承接分析：仅在校验「激活助手分析能力」已开启，且已保存「训练：对话承接分析」提示词时自动执行；训练页无单独开关。",
  train_context_title: "对话承接分析",
  train_context_pending: "对话承接分析中...",
  train_parse_ok: "模型输出已解析为 JSON（仅表示格式解析成功，不代表话术合理）",
  train_parse_fail: "模型输出未能解析为 JSON，下方无「是否存在问题」等结构化承接结论",
  train_carry_verdict_label: "承接判定：",
  train_carry_no_struct: "无结构化承接结论，请结合下方模型原文自行判断",
  train_model_explanation_label: "模型说明",
  train_full_model_output_label: "模型完整输出",
  train_zh_triple_title: "模型输出（三字段）",
  train_zh_carry_context: "承接上下文",
  train_zh_brief_reason: "简要理由",
  train_zh_improve_suggestion: "改进建议",
  train_zh_empty: "（无）",
  train_customer_prev_class: "客户上一句分类",
  train_section_issues: "问题点",
  train_section_suggestions: "优化建议",
  train_section_rewrite: "推荐改写",
  train_rewrite_source_label: "改写来源",
  train_rewrite_from_knowledge: "知识库条目",
  train_rewrite_from_new: "自拟话术",
  train_suggested_utterance_label: "推荐播读",
  train_knowledge_index_label: "列表序号（兼容旧版）",
  train_suggested_db_id_label: "suggestedDbId（播读记录/知识点 ID）",
  train_suggested_kb_id_label: "知识库 ID",
  train_suggested_kb_title_label: "知识点标题",
  train_suggested_playback_text_label: "播读正文",
  train_raw_hint: "模型完整回复（未解析时供人工查看）：",
  train_context_issue: "存在问题",
  train_context_ok: "承接合理",
  train_context_attention: "建议人工查看（承接判定风险或模型备注）",
  train_carry_risk_label: "承接判定风险：",
  train_optimize: "优化",
  train_one_click_optimize: "一键优化",
  train_one_click_optimize_done: "一键优化完成",
  train_one_click_optimize_failed: "一键优化失败",
  train_optimize_logs: "优化日志",
  train_optimize_log_time: "时间",
  train_optimize_log_operator: "操作者",
  train_optimize_log_action: "动作",
  train_optimize_log_action_create: "新增",
  train_optimize_log_action_update: "修改",
  train_optimize_log_action_create_knowledge: "新增知识",
  train_optimize_log_action_add_answer: "新增回答",
  train_optimize_log_action_update_knowledge: "修改知识",
  train_optimize_log_rollback_status: "回滚",
  train_optimize_log_rollback_time: "回滚时间",
  train_optimize_log_rollback_yes: "已回滚",
  train_optimize_log_rollback_no: "有效",
  train_optimize_log_knowledge: "知识标题",
  train_optimize_log_customer_text: "客户原话",
  train_optimize_log_keyword: "关键词",
  train_optimize_log_answer: "回答描述",
  train_optimize_log_change_desc_col: "变更描述",
  train_optimize_log_desc_kw_new: "新增关键字",
  train_optimize_log_desc_kw_modify: "修改关键字",
  train_optimize_log_desc_ans_label: "新增回答描述",
  train_optimize_log_edit_need_knowledge: "该日志缺少知识标题，无法定位编辑。",
  train_optimize_log_delete_confirm: "仅删除这条优化日志记录，不会改动知识库。确定删除？",
  train_optimize_log_rollback_btn: "回滚",
  train_optimize_log_rollback_confirm: "确认回滚该条优化？将移除本次合并到知识上的关键词，并删除本次新增的回答描述（若有）。",
  train_optimize_log_rollback_success: "回滚成功",
  train_optimize_logs_need_session: "请先在左侧打开某个会话详情，再查看优化日志。",
  train_optimize_know_title: "训练优化 · 新增知识",
  train_optimize_no_words: "未选中话术，无法添加知识",
  train_know_saved_hint: "知识已保存，如需可重新开始训练以载入最新知识库",
  train_carry_optimized_badge: "已优化",
  train_carry_expand_hint: "点击展开全文",
  stop_train: "停止训练",
  detail: "详情",
  result: "结果",
  th_event: "通话事件",
  lunci_desc: "秒， 说话次数：",
  statistic_date: "统计时间",
  kehu: "客户",
  minutes: "分钟数",
  feiyong: "费用",
  llm_telcharge: "大模型通话消费",
  fee_deducted_total: "费用（实扣合计）",
  fee_deducted_total_tip: "本周期最终实际完成扣除的费用合计。",
  llm_fee_included: "大模型扣费（已含）",
  llm_fee_included_tip: "方便查看大模型相关扣了多少；该金额已计入相邻的实扣合计，不会额外再扣。",
  call_cost_day: "通话消费（实扣）",
  call_cost_day_tip: "本周期最终实际扣除的通话费用合计。",
  cur_balance: "当时余额",
  please_1_more: "选择一个或多个月",
  stream_id: "流水编号",
  recharg_time: "充值时间",
  recharg_account: "充入账号",
  recharg_fy: "充值费用",
  recharg_before_ye: "充值前余额",
  recharg_after_ye: "充值后余额",
  recharg_desc: "充值描述",
  kaitong_yunyin: "已开通运营",
  merchant_total: "合计",
  merchant_opened_on_page: "本页已开通",
  user_name: "用户名称",
  slient: "静默",
  disable: "禁用",
  expire: "过期",
  yunyin_switch: "运营开关",
  yunyin_balance: "运营余额",
  minite_danjia: "分钟计费单价",
  asr_danjia: "识别次数单价",
  llm_input_1k_danjia: "大模型输入(元/千token)",
  llm_output_1k_danjia: "大模型输出(元/千token)",
  tts_char_danjia: "语音合成(元/万字符)",
  llm_voice_danjia: "大模型对话语音(元/分钟)",
  llm_billing_mutex_hint: "与上方大模型对话语音互斥；token/合成三选一。",
  fee_dialog_tip: "开启后，此商户下全部账号按以下单价运营扣费。",
  fee_stop_on_arrears: "欠费即停拨",
  fee_stop_on_arrears_hint: "运营欠费达透支额后立刻停拨",
  fee_over_balance: "透支额度",
  fee_over_balance_unit: "单位：元（负数）",
  fee_over_balance_hint: "运营余额可透支的额度，请填写负数，例如 -100。",
  fee_voice_section_title: "语音计费",
  fee_voice_normal_tag: "普通话术",
  fee_voice_llm_tag: "大模型话术",
  fee_voice_diff_brief: "通话使用的普通话术时，按普通话术单价扣费；启用大模型话术的通话，按大模型话术单价扣费，未配置大模型话术话术单价时则全部按普通单价扣费。或者未配置普通话术单价且配置了大模型单价时则全部按大模型单价扣费。",
  fee_more_section_title: "更多计费项",
  fee_more_unit_asr: "识别 元/次",
  fee_more_unit_llm: "大模型 元/千token",
  fee_more_unit_tts: "合成 元/万字符",
  fee_more_asr_tag: "识别",
  fee_more_llm_in_tag: "大模型输入",
  fee_more_llm_out_tag: "大模型输出",
  fee_more_tts_tag: "语音合成",
  fee_unit_yuan_per_minute: "元/分钟",
  fee_unit_label_yuan_per_minute: "单位：元/分钟",
  yikaiqi: "已开启",
  yunyin: "运营",
  rechar: "充值",
  yinyin_data: "运营数据",
  yinyin_data_desc: "提示：开启运营账户结算后，此商户下所有账号（包括普通账户、商家账户）拨打的分钟数都会按此运营结算方式进行扣费。方便系统拥有者和代理商家进行扣费结算。",
  jihuo: "激活",
  yuyin_minite: "语音",
  asr_ci: "识别",
  llm_input_1k: "大模型输入",
  llm_output_1k: "大模型输出",
  tts_per_char: "语音合成",
  llm_voice_minute: "大模型对话语音",
  recharge_before_money_account: "充值账号",
  reru: "充入费用，单位：元",
  reru_d: "单位：元，最大1000万",
  congru_balance: "充入费用：",
  congru_balance_desc: " ，充入后余额 ",
  gouxuan: "勾选确认后可点击充值",
  please_congru_balance: "请填写充入的费用。单位：元",
  please_congru_feiyong: "请勾选确认后可点击充值",
  zhouqi_month: "周期 - 月",
  zhouqi_day: "周期 - 天",
  ai_dail: "AI拨打",
  customer_name_1: "客户名称",
  yuji_date: "预计成交日期",
  follow_time: "跟进时间：",
  customer_tag: "客户标签",
  add_tag: "添加标签",
  sure_enter: "确认进入当前跟进阶段嘛？",
  follow_record: "跟进记录",
  follow_remind: "跟进与提醒",
  baifang: "拜访方式",
  remind_date: "提醒日期",
  follow_xq: "跟进详情",
  follow_xq_desc: "填写跟进详情，按“回车”提交",
  no_follow_record: "还没有跟进记录",
  zong: "总",
  tiao_record: "条记录",
  qian_genjin: "前跟进过",
  th_record: "通话记录",
  new_tag_group: "新增标签组",
  tag_groupname: "标签组名称",
  tag_groupname_desc: "标签组名称",
  please_new_tag: "请新增标签",
  new_add_tag: "新增标签",
  please_enter_tagname: "请输入标签名称",
  please_new_add_taggroup: "请新增标签组",
  please_enter_tag_groupname: "请输入标签组名称。",
  please_enter_tag_name: "请输入标签名称。",
  delete_tag_groupname: "删除标签组",
  delete_tag_groupname2: "确定要删除标签组：",
  modify_taggroupname: "修改标签组",
  delete_tag: "删除标签",
  delete_tag2: "确定要删除标签：",
  thsc_fh: "通话时长 >= ",
  follow_jd: "跟进阶段",
  please_intention_grade: "请选择意向等级",
  please_yy_tag: "请选择语义标签",
  follow_startdate: "跟进开始日期",
  follow_enddate: "跟进结束日期",
  allocation_startdate: "分配开始日期",
  allocation_enddate: "分配结束日期",
  please_kh_tag: "请选择客户标签",
  new_kh: "新增客户",
  batch_import: "批量导入",
  batch_import_child_data: "批量导出下级账号的数据",
  batch_join_ai: "批量加入AI拨打",
  batch_allocation: "批量分配",
  batch_fr_sea: "批量放入公海",
  batch_delete_dh: "批量删除客户",
  clear_kh: "清空客户",
  batch_dial: "批量拨打",
  stop_batch_dial: "停止批量拨打",
  refresh: "刷新",
  xin_kh_name: "*客户名称",
  please_kh_name: "请填写客户名称",
  xin_kh_phone: "*客户电话",
  please_kh_phone: "请填写客户电话",
  please_companyname: "请填写所属公司",
  down_excel_desc: "根据标题头填充相应内容 (或在EXCEL文件中修改标题头符合要求, 文件后缀为xls, xlsx)",
  celv_allcation: "策略分配",
  number_z1: "数量",
  select_user: "选择用户",
  search_gjz: "查询的关键字",
  follow_date: "跟进日期",
  allocation_date: "分配日期",
  please_export_pass: "请输入导出密码",
  please_import_pass: "请输入导入密码",
  allocation_kh: "分配客户",
  cur_selected: "当前选中",
  cur_selected1: "条客户数据进行分配",
  kefenpei: "可分配总数：",
  kefenpei1: "条，按策略进行分配，请选中分配数量和用户",
  kefenpei2: "说明：有选中客户数据时按选中数据进行分配，没有选中时按策略进行分配。",
  enter_account: "直接输入账号",
  please_enter_account: "请输入账号名称，多个账户逗号分隔，如：test001,test002",
  allocation_time: "分配时间",
  a_grade_desc: "A类(较强)",
  b_grade_desc: "B类(一般)",
  c_grade_desc: "C类(很少)",
  d_grade_desc: "D类(需筛选)",
  e_grade_desc: "E类(需再次跟进)",
  f_grade_desc: "F类(无需跟进)",
  las_th_sc: "最后通话时长",
  follow_time_1: "跟进时间",
  new_ruku: "新入库",
  ai_chufang: "AI初访",
  genjinzhong: "跟进中",
  youyixiang: "有意向",
  daiqiatang: "待洽谈",
  yichengjiao: "已成交",
  please_enter_khname: "请输入客户的名称。",
  please_enter_khphone: "请输入客户的手机号码。",
  please_enter_khphone2: "电话的格式不对，请输入11位手机号码。",
  please_import_excel: "只能导入Excel文件，扩展名是xls或者xlsx",
  please_select_child_account: "请选择下级账户",
  please_enter_fenpei_num: "请填写分配数量",
  please_select_child_user: "请选择下级用户",
  please_gouxuan_ai_account: "请勾选需要加入AI拨打的客户。",
  please_gouxuan_public_sea: "请勾选需要加入公海的客户。",
  sip_unonline: "SIP分机未上线，请打开拨打面板点击上线。",
  please_gouxuan_batch_user: "请勾选需要批量拨打的客户。",
  wktong_sip: "未开通SIP分机能力。",
  my_yxkh: "我的有效客户",
  yxkh: "有效客户",
  my_yxkh_desc: "可以新增、删除、修改客户的资料信息，同时可以直接将客户加入到AI的快捷拨打列表，也可以通过系统提供的人工外呼进行拨打。",
  my_kh: "我的客户",
  tag_manage: "标签管理",
  kh_sea: "客户公海",
  kh_sea_desc: "共享的所有客户资源数据，定期从公海领取数据，定期跟踪发现潜在客户。",
  create_date_rq: "创建日期",
  end_date_rq: "结束日期",
  batch_lq: "批量领取",
  please_gx_lqkh: "请勾选需要领取的客户。",
  show_history_record: "展示历史拨打记录",
  dial_date_z: "拨打日期",
  kh_name: "客户姓名",
  callin_callout: "呼入/呼出",
  thsc_second: "通话时长(秒）",
  minite: "分",
  jifeishichang: "计费时长(分）",
  record_hangup_desc: "录音或挂机描述",
  dial: "拨打",
  work_remind: "工作提醒",
  work_remind_desc: "展示历史需要处理的提醒信息，未处理的提醒会高亮显示",
  handle: "处理",
  handled: "已处理",
  wait_handle: "待处理",
  remind_type: "提醒类型",
  remind_content: "提醒内容",
  remind_time: "提醒时间",
  recv_phone: "接收方号码",
  sms_content: "短信内容",
  send_time: "发送时间",
  please_select_ch_sms: "请选择客户等级发送及时短信",
  xin_template_name: "*模板名称",
  xin_template_name_desc: "请填写模板名称",
  template_content: "模板内容",
  template_content_desc: "请填写模板内容",
  template_name: "模板名称",
  template_code: "模板Code",
  new_template: "新增短信模板",
  delete_sms_template: "删除短信模板",
  modify_sms_template: "修改短信模板",
  sms_manage: "短信管理",
  sms_manage_desc: "短信模板配置，已发送短信查询",
  send_smsed: "已发送短信",
  sms_template: "短信模板",
  celv_config: "策略配置",
  readed_count: "已读总量",
  zuotian: "昨天",
  last_week: "最近一周",
  last_month: "最近一个月",
  last_3month: "最近三个月",
  summary: "汇总",
  today_realtime_data: "今日实时（天）",
  today_realtime_data_30minu: "拨打数据（30分钟）",
  task_realtime_date: "多任务通话统计",
  history_data: "拨打数据（天）",
  bind_weixin_phone: "您当前还未绑定手机号码，请先绑定",
  func_open_close: "功能开启或关闭",
  noneed_open_close: "对不需要的功能入口开启或者关闭",
  task_more_config: "任务拨打相关配置",
  user_ai_dialtime: "用户可自行配置AI拨打间隔时间",
  task_dail_time_default: "任务拨打时段-默认值",
  task_stop_time_default: "任务禁止拨打时段-默认值",
  task_continues_default: "任务连续失败次数-默认值",
  bot_config_more: "相关配置",
  bot_download_password: "设置下载话术的密码，同时也适用于导入号码的密码",
  download_self_pass: "下载自己创建的话术是否也需要密码",
  system_config: "系统级配置",
  gloabl_push_address: "全局推送地址配置",
  gloabl_push_address_desc: "请输入推送地址，如：http://www.baidu.com",
  create_user_callback: "创建用户回调",
  delete_user_callback: "删除用户回调",
  gloabl_dial_callback: "全系统拨打话单回调",
  ai_fenxi_address: "AI分析地址",
  sms_duijie_set: "短信对接设置",
  sms_duijie_set_desc: "系统支持对接阿里的短信通道，请在以下输入框中填入在阿里平台申请的各项参数值。",
  xin_sign_name: "*签名名称",
  xin_sign_name_desc: "请输入签名的名称，如：百度",
  xin_sms_template_id: "*短信模板ID",
  xin_sms_template_id_desc: "请输入短信模板ID",
  access_key_id: "请输入 AccessKeyId",
  access_key_secret: "请输入 AccessKeySecret",
  sms_content_example: "短信内容样例",
  sms_content_example_desc: "样例：【签名名称】尊敬的客户：今天是您的生日，XXXX全体工作人员祝您生日快乐！万事如意！",
  sign_name: "签名名称",
  sms_template_id: "短信模板ID",
  sms_example: "短信样例",
  new_sms_channel: "新增短信通道",
  please_sign_name: "请输入签名名称。",
  please_sms_id: "请输入短信模板ID。",
  please_accesskeyid: "请输入 AccessKeyId。",
  please_accesskeysecret: "请输入 AccessKeySecret。",
  modify_sms_channel: "修改新增短信通道",
  delete_sms_channel: "删除短信通道",
  weixin_mini_app_config: "微信小程序配置",
  weixin_mini_app_config_desc: "这里配置小程序的参数，用以将系统与小程序进行对接，对接之后可以通过小程序管理数据。",
  mini_param_config: "小程序参数配置",
  xin_miniapp_name: "*小程序名称",
  xin_miniapp_name_desc: "请输入小程序名称",
  xin_miniapp_appid_desc: "请输入AppID",
  xin_miniapp_appsecret_desc: "请输入 AppSecret",
  xin_app_scan: "*小程序扫描码",
  mini_proper_1: "小程序名称是必填属性。",
  appid_need: "AppID 是必填属性。",
  appsecret_need: "AppSecret 是必填属性。",
  file_max2m: "文件太大了，最大不超过2M。",
  file_jpg_png: "只能上传jpg、png格式的图片。",
  weixin_public_config: "微信公众号配置",
  weixin_public_config_desc: "这里配置公众号参数，用以将系统与公众号进行对接，对接之后可以通过公众号实时推送及时消息。",
  weixin_public_perpor: "公众号参数配置",
  xin_public_name: "*公众号名称",
  xin_public_name_desc: "请输入公众号名称",
  template_details_1: "详情推送模版ID（受理结果通知）",
  template_taskfinish_1: "任务拨打完成推送模版ID（执行结果通知）",
  template_serveraddress_1: "服务器地址URL(微信消息推送)",
  please_enter_token: "请输入Token",
  template_account_1: "账号即将过期推送模版ID（续费提醒）",
  template_balance_1: "余额不足推送模板（账户余额不足通知）",
  domain_address: "域名地址, 如:“http://www.baidu.com/”",
  please_enter_domainaddress: "请输入域名地址",
  public_welcome: "公众号欢迎语",
  public_welcome_desc: "当用户关注公众号时，推送的欢迎语。",
  public_menu_json: "公众号菜单定义(JSON格式）",
  public_menu_json_desc: "公众号上的菜单显示定义。",
  class_template: "类目模板配置",
  class_template_desc: "类目模板申请：微信公众号->模板消息->类目模板->从类目模板库中添加 提示：看不到模板消息的公众号，请点击：新的功能-模板消息 进行开通。",
  please_enter_template_id: "请输入模板ID",
  add_field: "添加字段",
  test: "测试",
  replase_wei: "替换为",
  add_class: "添加类目",
  class_field: "类目字段",
  show_content: "显示内容",
  show_content_desc: "显示内容",
  defind_content: "自定义内容",
  defind_content_desc: "请填写自定义内容",
  gz_public: "已关注公众号客户列表",
  headerimg: "头像",
  phone_hm: "手机号码",
  province: "省份",
  city: "城市",
  subscribe_time: "关注时间",
  please_tx_class_field: "请填写类目字段，如：{{thing9.DATA}}",
  wexin_sqkt: "微信公众号未授权开通，请联系管理员。",
  public_name_need: "公众号名称是必填属性。",
  token_need: "Token 是必填属性。",
  please_enter_class: "请输入类目字段。",
  class_field_geshi_error: "类目字段格式不正确。",
  please_show_content: "请选择显示内容。",
  style_set_title: "样式参数配置",
  xin_login_main: "*登录页标题",
  xin_login_main_desc: "登录页标题",
  xin_login_main_welcom: "*登录页欢迎语",
  xin_login_main_welcom_desc: "登录页欢迎语",
  login_beian_hao: "登录页备案号",
  login_log_tu: "*登录页LOGO图 50px * 50px",
  login_log_tu2: "*主页面LOGO图 50px * 30px",
  login_log_tu3: "*登录页背景图",
  login_log_tu4: "*登录页右侧背景图",
  main_page_title: "*主页面的标题",
  main_page_title_desc: "主页面的标题",
  dashboard_welcome: "*Dashboard的欢迎语",
  dashboard_welcome_desc: "Dashboard的欢迎语，如：祝您工作顺利，天天开心！",
  dingbu_color: "顶部条颜色",
  left_color: "左侧菜单栏背景颜色",
  left_menu_color: "左侧菜单栏字体颜色",
  naviage_style: "导航样例",
  naviage_style_1: "1、登录页标题修改位置",
  naviage_style_2: "2、登录页欢迎语",
  naviage_style_3: "3、登录页备案号",
  naviage_style_4: "4、登录页LOGO图 大小：50px * 50px",
  naviage_style_5: "5、登录页背景图",
  naviage_style_6: "6、主页面的标题",
  naviage_style_7: "7、主页面的LOGO图 大小：50px * 30px",
  please_login_main: "请填写登录页标题。",
  please_login_welcome: "请填写登录页欢迎语。",
  please_upload_logo: "请上传登录页LOGO图。",
  please_upload_backgroud: "请上传登录页背景图。",
  please_enter_main_title: "请填写主页面的标题。",
  please_upload_logo_tu: "请上传主页面的LOGO图。",
  max_file_1m: "文件太大了，最大不超过1M。",
  new_blacklist: "新增黑名单",
  batch_add_duohaoma: "批量添加，多个号码逗号分隔",
  batch_add_duohaoma2: "请输入黑名单号码，多个逗号分隔。",
  new_third_blacklist: "新增第三方黑名单",
  call_address: "调用地址",
  test_third_title: "测试第三方黑名单",
  test_phone: "测试号码",
  callback_message: "返回消息",
  other: "其它",
  method: "方法",
  control_param: "控制参数",
  all_system_start_time: "全系统静默开始时间",
  all_system_end_time: "全系统静默结束时间",
  dingshi_clear_db: "定期清理数据库数据",
  dingqi_clear_record: "定期清理录音文件",
  dingqi_clear_record2: "定期清理客户导入的长期未拨打的数据",
  jifeijingdu: "计费精度（单位：豪秒），所有通话的时长小于此值都计为：0秒",
  jifeijingdu2: "请输入计费精度",
  click_control_param: "点呼拨打控制参数",
  meiri_dail_limit: "每日单个号码的拨打上限",
  meiri_dail_limit2: "请输入每日单个号码的拨打上限",
  m30_dail_limit: "30天内单个号码的拨打上限",
  m30_dail_limit2: "请输入30天内单个号码的拨打上限",
  ssl_upload: "证书上传，仅支持阿里下载的Apache证书",
  wss_upload: "WSS 证书上传(zip格式)",
  submit: "提交",
  tian_q: "天前",
  please_search_user: "请输入查询用户",
  add_sips: "添加线路",
  my_sips: "我的线路",
  please_search_sip: "请输入查询线路",
  sip_name: "线路名称",
  sip_remark: "线路备注",
  pinlv: "频率 数量/秒",
  nolimit: "无限制",
  reg: "注册",
  dj: "对接",
  reg_username: "注册用户名",
  reg_password: "注册密码",
  reg_status: "注册状态",
  ip_address: "IP地址",
  port: "端口",
  caller: "主叫号码",
  please_left_show_user: "请在左侧选择需要查看的用户",
  please_s_user: "请选择用户。",
  please_s_sip: "请选择线路。",
  jijiang_gei: "即将给用户：",
  jijiang_gei2: " 分配线路：",
  new_allocation_sip: "新增分配线路",
  remove_user_allsip: "移除用户的所有线路",
  remove_user_allsip2: "高危提示：移除前，请确保账号",
  remove_user_allsip3: " 已经没有使用你分配给他的所有线路了，否则会影响他的正常拨打？",
  delete_sip: "移除线路",
  delete_sip2: "高危提示：移除前，请确保账号",
  delete_sip3: " 已经没有使用此线路了，否则会影响他的正常拨打？",
  enable_status: "激活状态",
  xin_sip_name: "*线路名称",
  xin_sip_name_desc: "请填写线路名称",
  xin_server_ip: "*服务器IP",
  xin_server_ip_desc: "请输入服务器IP",
  xin_reg_account: "*注册账号",
  xin_reg_account_desc: "请输入注册账号",
  please_enter_caller: "请输入主叫号码",
  songhao_pinlv: "送号频率",
  songhao_pinlv2: "如：每隔 1 秒呼出 2 个号码",
  gateway_port_num : "网关端口数量",
  please_sip_remark : "请填写线路备注",
  xin_port: "*端口",
  xin_zici_port: "请填写端口",
  xin_reg_pass: "*注册密码",
  xin_reg_pass_desc: "请输入注册密码",
  callee_prefix: "被叫前缀",
  callee_prefix_desc: "请输入被叫前缀",
  line_dj_caller_prefix_tip: "若线路对接管理里已配置主叫号码或被叫前缀，此处不建议再配置，以免后续切换线路时不成功。",
  change_sip_force_caller_prefix_tip: "当前账号已配置强制主叫号码/强制前缀号码，切换其他线路拨打时线路上的主叫与前缀不会生效。请先删除账号上配置的主叫号码和前缀号码。",
  codec: "语音编码",
  codec_desc: "编码G729/PCMA/PCMU",
  port_sm: "每个端口的默认下发前缀，逗号分隔",
  port_sm2: "默认情况下发001,002,003以此类推，单口网关不加前缀。",
  sipu: "线路：",
  who_use: "谁在使用",
  nouse: "未使用",
  ports: "端口号",
  allocation_who: "分配给谁",
  is_enable: "是否启用",
  delete_sip33: "删除线路 ",
  tishi_001: "提示：正在使用此线路的用户如下：",
  tishi_002: "当前没有用户使用此线路，可以放心删除。",
  wei_user: "位用户",
  tongshi_fenpei: "同时分配给：",
  please_enter_sip_name: "请输入线路名称。",
  please_enter_sip_name2: "请输入线路名称。",
  please_server_ip: "请输入服务器IP。",
  please_server_port: "请输入服务器端口。",
  please_reg_account: "请输入注册账号。",
  please_reg_account_6char: "注册账号长度最少6个字符。",
  please_reg_password: "请输入注册密码。",
  please_reg_password_6char: "注册密码长度最少6个字符。",
  please_songpin: "请填写正确的送号频率，秒数和号码数均为正整数",
  please_11phone: "请输入11位手机号码",
  stopuse: "停用",
  duijie_mode: "对接模式",
  reg_mode: "注册模式",
  gateway_mode: "网关模式",
  kouwg: "口网关",
  busi_list: "商家列表",
  busi_list_desc: "当赋予商家用户角色的控制权限时，此商家用户分配角色给他的下级用户",
  show_kexuan_role: "查看他的可选角色",
  keyong_role: "的可用角色列表",
  keyong_role_desc: "将角色配给商户，鼠标移动到名称上显示菜单权限。",
  kexuan_role: "可选角色",
  please_left_user: "请在左侧选中用户",
  role_menu_qx: "角色菜单权限",
  role_menu_qx_desc: "鼠标移动到角色名称上查看详细信息",
  ci_role_pz: "此角色未配置菜单",
  role_pz: "角色的配置",
  role_pz_desc: "当赋予某个用户角色时，此用户就有了对应的模块的访问权限",
  xin_role_name: "*角色名称",
  xin_role_name_desc: "请填写角色名称",
  role_desc: "角色描述",
  role_desc2: "请填写角色的描述",
  gongneng_mk: "功能模块权限配置",
  gongneng_mk_desc: "请选择需要开放给指定角色的功能访问权限",
  edit_save: "编辑后，回车保存",
  other_tag: "其它标签",
  teshu_gongn: "特殊功能",
  please_left_zw: "请在左侧选中职务",
  user_list: "用户列表",
  user_list_desc: "展示拥有此角色的当前所有用户",
  role: "角色",
  new_zw: "新增职务",
  please_enter_zwname: "请输入职务名称。",
  new_role: "新增角色",
  modify_role: "修改角色",
  please_select_status: "请选择状态",
  new_user: "新增用户",
  xin_user_account: "*用户账号",
  xin_user_account_desc: "请填写用户账号",
  realname: "真实名称",
  realname_desc: "请填写真实名称",
  xin_expirtime: "*过期日期",
  xin_login_pass: "*登录密码",
  xin_login_pass_desc: "请输入登录密码",
  xin_sure_pass: "*确认密码",
  xin_sure_pass_desc: "请输入确认密码",
  ai_seats_num: "*AI坐席数量",
  please_ai_seats_num: "请输入AI坐席数量",
  xin_dial_jg: "*拨打间隔",
  please_xin_dial_jg: "拨打间隔，单位：秒",
  xin_total_sq: "*总授权数",
  xin_total_sq_desc: "商家最大可开通的AI坐席数",
  xin_lines: "*线路",
  gateway_reg: "网关注册",
  gateway_reg_desc: "请填写网关注册账号",
  random_gateway_account: "随机生成",
  add_gateway_account: "添加网关账号",
  remove_gateway_account: "删除",
  gateway_reg_multi_hint: "一个账号可注册到多个网关，点击添加即可增加账号",
  gateway_reg_empty_use_username: "不填则默认使用登录用户名作为网关账号（与原来一致）",
  gateway_prefix_enabled: "送到网关前缀",
  gateway_prefix_enabled_on_desc: "开启后推送号码会带上默认前缀",
  gateway_prefix_enabled_off_desc: "关闭后推送号码不再加此前缀",
  line_dj: "线路对接",
  pool: "通信池",
  edit_remark: "编辑备注",
  please_enter_user_desc: "请输入此用户的一般描述信息",
  check: "校验",
  please_check_pass: "请输入校验密码",
  password: "密码",
  gateway_account_sipname: "网关账号/SIP名称",
  gateway_status_prefix: "网关状态/主叫/前缀",
  ai_seat: "AI坐席",
  total_ai_seats: "总授权数/AI坐席",
  yuyin_jifei: "语音计费",
  asr_jifei: "识别计费",
  day_dial_control: "每日拨打控制",
  xian: "限",
  blacklist_control: "黑名单控制",
  local_blacklist_enable: "本地黑名单激活",
  third_blacklist_enable: "三方黑名单激活",
  expirationtimed: "已过期",
  js_recharg: "结算与充值",
  recover: "恢复",
  reset: "重置",
  please_enter_user_account: "请输入用户账号。",
  please_enter_user_account_6char: "用户账号必须6个字符以上。",
  please_select_expiration: "请选择过期日期。",
  password_6char: "密码长度最少6个字符。",
  please_sure_pass: "请输入确认密码。",
  sure_pass_sure_pass: "输入的密码和确认密码不一致。",
  please_enter_ai_seats: "请输入AI坐席数量。",
  please_dial_jg: "请输入拨打间隔。",
  please_total_sq: "请输入总授权数。",
  please_bxxxx: "总授权数必须大于AI坐席数量",
  please_sj_max: "请输入商家最大可开通的AI坐席数。",
  please_reg_gateway_pass: "请输入注册到网关的账号密码。",
  please_s_pool: "请选择通讯池。",
  please_s_port: "请选择端口。",
  please_check_pass2: "请输入校验密码。",
  delete_user: "删除用户",
  delete_user_ma: " 吗，删除后他的数据将永久删除不可恢复？",
  reset_pass: "重置密码",
  reset_pass1: "确定要重置：",
  reset_pass2: " 的密码吗？",
  w_guoqi: "未过期",
  realname2: "真实姓名",
  realname2_desc: "请填写真实姓名",
  please_enter_bdjg: "请填写拨打间隔",
  controller: "控制",
  xz_mr_ci: "限制每日接通次数",
  xz_mr_ci_desc: "单位：次，等于 0 代表不限制",
  xz_mr_ci2: "限制每日接通分钟数",
  xz_mr_ci2_desc: "单位：分钟， 0 代表不限制",
  local_blacklist_controller: "本地黑名单控制",
  third_blacklist_controller: "第三方黑名单控制",
  sms: "短信",
  enable_sms: "是否启用短信",
  sms_channel: "短信通道",
  sms_channel_desc: "请选中短信通道",
  please_enter_sms_content: "请输入发送的短信内容",
  asr: "识别",
  edit_asrkey: "编辑语音KEY",
  edit_asrkey_desc: "【空白】未配置key的情况下，默认使用您上级的key。",
  clear: "清除",
  lead: "其它",
  xin_lead_account: "*线索账号",
  xin_lead_account_desc: "请填写线索账号",
  xin_lead_pass: "*线索密码",
  xin_lead_pass_desc: "请填写线索密码",
  financial_general: "财务概况",
  account_js: "账户结算",
  local_account_mode: "锁住此账号下的所有账号的结算方式",
  balance_yuan: "余额，单位：元",
  over_balance_yuan: "透支额，单位：元",
  ai_yuezu: "AI月租，单位：元/月/个",
  other_fuwufei: "其它服务费，单位：元/月",
  yuyin_feilv: "语音费率，单位：元/分钟",
  sms_yuezu: "短信费率，单位：元/条",
  busi_xxx: "商家用户开启后，他的所有下级子账户都开启此结算，不可修改。",
  yuyin_asr_js: "语音识别费结算",
  day_cost_limit: "每日消费限额",
  day_cost_limit_amount: "每日限额金额，单位：元",
  day_cost_limit_tip: "仅当账户结算或语音识别费结算任一开启后才可配置。开启后，该账户每日消费将受此金额限制。",
  asr_account_desc1: "识别仅从此账户扣除，余额小于0时停止拨打。",
  asr_account_desc2: "账户没有余额时从他的上级扣除，上级余额小于0时停止拨打。",
  asr_feilv_1: "识别费率，单位：元/次",
  get_ta_recharg: "给他充值",
  gei: "给",
  yue_recharg: "余额充值，单位：元",
  yue_recharg1: "请输入充入的金额",
  geiing: "正在给",
  before_after_recharg: "充值，充值前：",
  before_after_recharg1: "元，充值后：",
  jiesuan_lock: "结算锁定",
  jiesuan_lock2: "您开启了此账号的结算锁定，他和他的所有下级的语音结算方式都基于你当前的配置。开启后，不可能恢复请谨慎操作。",
  xin_user_name: "*用户名称",
  xin_user_name_desc: "请填写登录账号",
  xin_password: "*密码",
  xin_password_desc: "请输入登录密码",
  ss_role: "所属角色",
  please_enter_account2: "请输入账号",
  telephone: "电话号码",
  telephone_desc: "请输入电话号码",
  ss_zhiwu: "所属职务",
  please_enter_user: "请输入用户名称。",
  need_shuzi_char: "必须是数字或者英文字母组成且长度必须是6个字母以上",
  need_6char: "用户名称必须6个字以上。",
  please_select_role: "请选择所属角色。",
  sure_delete_user: "确定要删除用户：",
  sure_reset_pass: "确定要重置用户：",
  sure_reset_pass2: " 的密码吗？",
  reset_success: "重置成功",
  reset_success1: "此账号的密码重置为：",
  reset_success2: " ，建议登录系统后重新设置新密码。",
  weixin_public_title: "微信公众号通道和其它配置",
  weixin_public_title_desc: "微信公众号对接后，可以通过微信扫码登录系统，也可以在公众号上进行订单查询。",
  weixin_public_set: "微信公众号设置",
  weixin_app_set: "微信小程序设置",
  func_set: "功能设置",
  blacklist_set: "黑名单配置",
  blacklist_set_desc: "为系统能安全稳定的长期运行，配置必须的控制参数",
  local_blacklist_db: "本地黑名单",
  third_blacklist_db: "第三方黑名单库",
  sms_weixin_other_set: "短信/微信公众号通道和其它配置",
  sms_weixin_other_set_desc: "短信/短信支持阿里通道，可根据需要开启各类祝福语或问候语的发送。微信公众号对接后，可以通过微信扫码登录系统，也可以在公众号上进行订单查询。",
  menu_role_manage: "菜单角色管理",
  menu_role_manage_desc: "此处可新增菜单角色，基于角色选择菜单后，可以指定用户访问开启的菜单入口。",
  busi_fenpei_role: "商家可分配菜单",
  role_qx: "菜单权限",
  system_style: "系统样式",
  system_style_desc: "设置包括LOGO、标题、背景图等",
  style_set: "样式设置",
  system_anquan_pz: "系统安全性参数配置",
  system_anquan_pz_desc: "为系统能安全稳定的长期运行，配置必须的控制参数",
  dj_manage: "对接管理",
  dj_manage_desc: "集中管理线路对接与分配、声音复刻，以及短信等第三方对接能力。",
  fenpeixianlu: "分配线路",
  sms_dj: "短信对接",
  user_manage: "用户管理",
  user_manage_desc: "此处可以新增普通用户，在商家页面增加下级代理商。",
  balance_notify_set: "余额微信提醒",
  balance_notify_threshold: "余额低于多少元时推送",
  balance_notify_max_num: "累计提醒多少次后停止（每天最多1次）",
  balance_notify_yuan: "元",
  balance_notify_times: "次",
  balance_notify_hint: "定时提醒每天最多推送 1 次，例如设为 15 即大约连续提醒 15 天。达到次数后不再自动推送。「立刻推送」不受余额是否不足限制，但仍会计入累计次数。",
  balance_notify_push_now: "立刻推送",
  balance_notify_push_confirm: "将立即向符合条件的账号发送微信余额提醒，即使当前余额仍高于设定阈值。确定继续吗？",
  balance_notify_param_error: "请填写有效的推送余额和累计提醒次数。",
  user2_manage: "员工管理",
  user2_manage_desc: "此处可新增和删除员工。",
  yuangong: "员工",
  asr_aiover_content:"仅判定AI说话完成后的客户说话内容",
  asr_aiover_content_desc:"AI说话时不会被打断，它会一直说完，中间不停顿。“默认”选项说明：AI说话时，客户说的任何内容都会被判定。另外一个选择就是仅判定AI说话完成后的客户说话内容",
  recharge_remark_desc: "备注说明",
  reboot: "重启服务器",
  rebootdesc: "重启服务器（操作系统）后，等待5分钟后重试",
  rebootsure_desc: "重启服务器之前请检查当前服务器没有任何拨打或者整个服务器处于静默状态，确定立刻重启吗?",
  sms_channel_col: "通道",
  sms_proxy_add_title: "新增短信对接",
  sms_proxy_edit_title: "编辑短信对接",
  sms_ip_or_url: "IP或URL",
  sms_ip_or_url_ph: "请输入正确的IP或URL，如 127.0.0.1",
  sms_port_ph: "请输入端口，如 8080",
  sms_enterprise_id: "企业ID",
  sms_enterprise_id_ph: "请输入企业ID",
  sms_sign_id_ph: "请输入签名ID",
  sms_template_id_ph: "请输入模板ID",
  sms_template_param: "模板参数",
  sms_template_param_ph: "请输入模板参数",
  sms_goip_name: "GOIP名称",
  sms_goip_name_ph: "多个名称用英文逗号分隔",
  sms_uplink_recv: "短信上行接收",
  sms_report_recv: "短信报告接收",
  sms_price_fen: "短信单价",
  sms_price_fen_ph: "单价（分）",
  sms_price_unit: "（单位：分）",
  sms_day_limit: "每天最大发送",
  sms_day_limit_ph: "每天最大发送量",
  sms_count_unit: "（单位：条）",
  sms_month_limit: "每月最大发送",
  sms_month_limit_ph: "每月最大发送量",
  sms_test_phone: "测试手机号",
  sms_test_phone_ph: "请输入手机号",
  sms_test_content: "测试内容",
  sms_test_now: "立即测试",
  sms_test_dialog_title: "短信发送测试",
  sms_test_btn: "测试",
  sms_err_valid_ip: "请输入有效的IP地址",
  sms_err_valid_port: "请输入有效的端口",
  sms_err_valid_url: "请输入有效的URL地址",
  sms_err_goip: "请输入有效的GOIP名称",
  sms_err_sign_id: "请输入有效的签名ID",
  sms_err_username: "账号不能为空",
  sms_err_password: "密码不能为空",
  sms_err_price: "请输入短信单价",
  sms_err_day: "请输入每天最大发送量",
  sms_err_month: "请输入每月最大发送量",
  sms_err_test_phone: "请填写测试手机号",
  sms_err_test_need_save: "请先保存配置后再测试",
  sms_err_test_no_target: "请从列表操作列点击「测试」",
  normal: "正常",
  comm_pool_manage: "通信池管理",
  comm_pool_manage_desc: "通信池分为两种模式：1、默认模式一般主要用于直接对接网关或VOS或其他第三方SIP线路，并精准控制每条线路的拨打次数或分钟数。\n2、隐私线路或API线路，主要用于间接对接隐私保护厂商或API厂商的线路，通过API接口将被叫号码进行动态修改，以达到灵活拨打的目的，且也需要精准控制每条线路的拨打次数或分钟数。",
  comm_pool_mode_desc: "两种注册方式，本系统均不向VOS推送号码，都是做为接收端接收VOS的SIP呼叫。",
  comm_line_cycle_desc: "通信池的线路，会被循环使用。如配置了1条以上线路时，会按照配置的参数依次选线使用，当其中一条线路达到限制要求时，会停止选线直到下一个周期恢复。",
  comm_pool_name: "通信池名称",
  comm_name_remark: "名称备注",
  comm_owner_account: "归属账号",
  comm_operation: "操作",
  comm_temp_disable: "暂时停用",
  comm_address_port: "地址/端口",
  comm_reg_username: "注册账号",
  comm_edit: "修改",
  comm_view: "查看",
  comm_pool_add_title: "新增通信池",
  comm_pool_edit_title: "修改通信池",
  comm_line_add_title: "新增线路",
  comm_line_edit_title: "修改线路",
  comm_pool_type: "通信池类型",
  comm_pool_mode: "模式",
  comm_pool_account_pass: "账号/密码",
  comm_pool_prefix: "呼入被叫前缀",
  comm_pool_prefix_placeholder: "请填写4位字符",
  comm_pool_frozen: "已冻结",
  comm_pool_limit: "已频限",
  comm_pool_freeze: "冻结",
  comm_pool_restore: "恢复",
  comm_pool_delete_confirm: "确认删除该通信池吗？",
  comm_line_pool: "线路池",
  comm_vos_to_sys: "VOS向本系统注册",
  comm_sys_to_vos: "本系统向VOS注册",
  comm_rate: "费率",
  comm_rate_with_unit: "费率(厘)",
  comm_rate_placeholder: "单位：厘，计费周期分钟，不足一分钟按一分计费",
  comm_user_rate: "用户费率",
  comm_settle_rate: "结算费率",
  comm_net_rate: "净费率",
  comm_min_cost: "最低消费",
  comm_use: "使用",
  commcon_prefix: "前缀",
  comm_codec: "编码",
  comm_codec_line: "编码/线路",
  comm_codec_auto: "自动匹配",
  comm_codec_desc: "编码指语音通话编码格式，无特殊要求选择自动匹配。线路数指同时呼叫能接通的通道数。",
  comm_dial_interval_desc: "上一个接通结束后到下一个拨打间隔，单位秒。上一个未接通结束后到下一个拨打间隔，单位秒。",
  comm_dial_interval_on_placeholder: "接通间隔，单位秒",
  comm_dial_interval_off_placeholder: "未接通间隔，单位秒",
  comm_dial_limit_desc: "1小时内，仅允许拨打电话量（含已接通和未接通）。1天内，仅允许拨打电话量（含已接通和未接通）。1天内，仅允许拨打已接通数量。配置0不限制。",
  comm_dial_limit_hour_placeholder: "1小时上限",
  comm_dial_limit_day_placeholder: "1天内上限",
  comm_dial_limit_connected_day_placeholder: "1天内已接通上限",
  comm_month_minute_limit_desc: "每月拨打的总分钟数，按运营商分钟计算，不足一分钟按一分钟计算。配置0不限制。",
  comm_month_minute_limit_placeholder: "每月拨打的总分钟数，按运营商分钟计算，不足一分钟按一分钟计算。",
  comm_provider: "线路提供商",
  comm_server_ip: "服务器地址",
  comm_server_port: "服务器端口",
  comm_line_name: "线路名称",
  comm_line_count: "线路数",
  comm_main_send_number: "主送号码",
  comm_dial_interval: "拨打间隔",
  comm_dial_limit: "拨打量限制",
  comm_month_minute_limit: "每月分钟限制",
  comm_line_delete_confirm: "确认删除该线路吗？",
  comm_pool_name_required: "通信池名称至少2个字符。",
  comm_pool_account_required: "账号和密码不能为空。",
  comm_pool_prefix_required: "前缀必填且长度为4位。",
  comm_line_name_required: "线路名称至少2个字符。",
  comm_line_address_required: "地址和端口不能为空。",
  comm_server_port_invalid: "服务器端口不合法。",
  comm_record_mode: "录音模式",
  comm_no_record: "不录音",
  comm_sys_record: "系统录音",
  comm_third_record: "第三系统录音",
  comm_word_content: "话术内容",
  comm_word_keywords: "话术审核关键词",
  comm_line_type_landing: "落地网关",
  comm_line_type_docking_register: "对接网关-注册模式",
  comm_line_type_docking: "对接网关-对接模式",
  comm_line_type_privacy_landing: "隐私号码保护-落地网关",
  comm_line_type_privacy_register: "隐私号码保护-对接网关(注册)",
  comm_line_type_privacy_docking: "隐私号码保护-对接网关(对接)",
  comm_line_type_api: "API线路",
  team_stat_title: "团队分析",
  team_stat_subtitle: "团队分析仅针对客户中心的客户关系数据统计，拨打统计是人工拨打数据，不包含 Robot 外呼统计。",
  team_stat_all: "所有",
  team_stat_call_duration: "通话时长",
  team_stat_second_unit: "秒",
  team_stat_call_count: "通话次数",
  team_stat_count_unit: "次",
  team_stat_start_date: "开始日期",
  team_stat_end_date: "结束日期",
  team_stat_query: "查询",
  team_stat_last10days: "最近10天拨打统计",
  team_stat_today_top10: "今日拨打前10名",
  team_stat_back: "返回",
  team_stat_account: "账号",
  team_stat_total_dials: "总拨打数",
  team_stat_connected: "已接通数",
  team_stat_unconnected: "未接通数",
  team_stat_connect_rate: "接通率",
  team_stat_total_duration: "总拨打时长",
  team_stat_billing_duration: "计费时长",
  team_stat_followup: "打跟进",
  team_stat_remind: "打提醒",
  team_stat_alloc_success: "上级分配成功",
  team_stat_alloc_fail_repeat: "上级分配失败重复",
  team_stat_add_customer: "新增加客户",
  team_stat_delete_customer: "删除客户",
  team_stat_pubsea_pick: "公海池捞取",
  team_stat_pubsea_release: "释放到公海池",
  team_stat_operation: "操作",
  team_stat_view_detail: "查看明细",
  team_stat_phone: "号码",
  team_stat_recording: "录音",
  team_stat_export_started: "已开始导出，请稍后查看下载结果。",
  team_stat_intention_connected: "已接通",
  team_stat_intention_noneed: "不需要",
  team_stat_intention_need: "明确说需要",
  team_stat_intention_hangup_after_connect: "接通后挂断",
  team_stat_intention_unconnected: "未接通",
  team_stat_intention_unknown: "未知",
  comm_log_title: "日志分析",
  comm_log_subtitle: "用于查看实时通信日志，开关开启后每 5 秒自动刷新。",
  comm_log_switch_label: "日志采集",
  comm_log_empty: "暂无日志内容",
  save_ok: "保存成功",
  comm_delete_success: "删除成功",
  auto_refresh: "自动刷新",
  auto_refresh_interval_3s: "3秒刷新",
  auto_refresh_interval_5s: "5秒刷新",
  auto_refresh_interval_10s: "10秒刷新",
  auto_refresh_interval_default: "默认刷新",











}



// WEBPACK FOOTER //
// ./src/i18n/module_lang/AI_WorkBanch.js